export default {
  v5: {
    select_files_to_upload: 'Select files to upload',
    my_video_shorts: 'МИНИЙ ВИДЕО ШОРТС',
    see_more: 'ДЭЭР НЭМЭХ',
    no_shorts_found: 'Шорт олдсонгүй',
    shorts: 'Шорт',
    general_information: 'Ерөнхий мэдээлэл',
    gamification: 'Тоглоомжуулалт',
    click_to_select_files: 'Файлуудыг сонгохын тулд дарна уу',
    selected_files: 'Сонгосон файлууд',
    uploaded: 'Ачаалсан',
    failed: 'Амжилтгүй',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'Систем нь автомат байдлаар анализ хийж, агуулгын шаардлагын дагуу таны байгууллагын сангаас хамгийн холбогдолтой баримт бичгийг сонгоно.',
    select_from_library: ' Сангаас сонгох',
    search_document: 'Баримт бичгийг хайх...',
    selected: 'Сонгогдсон',
    loading_documents: 'Баримт бичгийг ачааллаж байна...',
    review_generated_content: 'Үүсгэсэн контентыг шалгах',
    confirm_and_replace_content: 'Контентыг баталгаажуулж, солих',
    the_generate_content_will_replace:
      'Үүсгэсэн контент нь сонгосон хуудсуудын одоогийн текстийг орлож сольно. Хэрэв та эдгээр өөрчлөлтийг хийхийг хүсэхгүй бол өмнөх алхам руу буцах боломжтой.',
    pages_to_be_updated: 'Шинэчлэх хуудсууд',
    generated_revisions: 'Үүсгэсэн өөрчлөлтүүд',
    lesson_preview: 'Хичээлийн урьдчилсан үзлэг',
    create_new_folder: 'Шинэ хавтас үүсгэх',
    rename_item: 'Элемент нэрийг өөрчлөх',
    enter_folder_name: 'Хавтасны нэрийг оруулна уу:',
    enter_new_name: 'Шинэ нэрийг оруулна уу:',
    folder_name: 'Хавтасны нэр:',
    new_name: 'Шинэ нэр',
    move_items: 'Элементийг шилжүүлэх',
    copy_items: 'Элементийг хуулах',
    move_here: 'Энд шилжүүлэх',
    copy_here: 'Энд хуулах',
    select_destination_library_and_folder:
      'Зориулалтын сан болон хавтсыг сонгох:',
    items_selected: 'Сонгосон элементүүд',
    version: 'Хувилбар',
    modified_by: 'Өөрчилсөн',
    size: 'Хэмжээ',
    restore: 'Сэргээх',
    are_you_sure_you_want_to_restore_this_version:
      'Та энэ хувилбарыг сэргээхийг хүсэж байна уу?',
    this_will_replce_the_current_version_with_the_selected_one:
      'Энэ нь одоогийн хувилбарыг сонгосон хувилбараар солино.',
    restore_this_version: 'Энэ хувилбарыг сэргээх',
    restore_not_available: 'Сэргээх боломжгүй',
    version_history: 'Хувилбарын түүх:',
    by_making_items_public:
      'Элементийг олон нийтэд нээлттэй болгосноор бүх хүн харах боломжтой болно. Үргэлжлэхийн өмнө нөхцөл болон дүрмийг уншина уу.',
    the_selected_items_will_be_copied:
      'Сонгосон элементүүд таны олон нийтийн санд хуулбарлагдаж, бүгдэд харагдана.',
    the_selected_items_will_be_copied_to_org:
      'Сонгосон элементүүд таны байгууллагын санд хуулбарлагдаж, бүх байгууллагын гишүүдэд харагдана.',
    the_selected_items_will_be_copied_to_your_private:
      'Сонгосон элементүүд таны хувийн санд хуулбарлагдаж, зөвхөн танд харагдана.',
    loading_organization: 'Байгууллагын хэрэглэгчид ачааллаж байна...',
    click_download_to_view: 'Үзэхийн тулд татаж авахыг дарна уу',
    archive_file: 'Архив файл',
    no_preview_available: 'Урьдчилсан харалт байхгүй',
    audit_report: 'Аудитын тайлан',
    audit_type: 'Үйлдлийн төрөл',
    i_agree_to_the_terms_and_conditions:
      'Би нөхцөл ба дүрмүүдийг зөвшөөрч байна.',
    this_file_is_indexed_for_ai: 'Энэ файл AI-д индексжүүлсэн байна.',
    file_is_not_indexed_for_ai: 'Файл AI-д индексжүүлэгдээгүй байна.',
    no_users_found: 'Хэрэглэгч олдсонгүй',
    no_users_available: 'Хэрэглэгчид байхгүй',
    add_people: 'Хүмүүс нэмэх',
    people: 'Хүмүүс',
    access_type: 'Нэвтрэх төрөл',
    no_group_found: 'Бүлэг олдсонгүй',
    add_group: 'Бүлэг нэмэх',
    groups: 'Бүлгүүд',
    users_top: 'Хэрэглэгч',
    confirm_delete: 'Устгахыг баталгаажуулах',
    do_you_want_remove: 'Та үүнийг устгахыг хүсэж байна уу',
    form_this_documents_permissions: 'энэ баримт бичгийн эрхээс?',
    no_users_found_in_this_group: 'Энэ бүлэгт хэрэглэгч олдсонгүй',
    add_selected_users: 'Сонгосон хэрэглэгчдийг нэмэх',
    choose_users_from_the_list: 'Жагсаалтаас хэрэглэгчийг сонгоно уу',
    selected_users: 'Сонгосон хэрэглэгчид',
    archived: 'Архивлагдсан',
    request_approval: 'Зөвшөөрөл хүсэх',
    document_in_review: 'Баримт бичиг шалгагдаж байна',
    approve: 'Зөвшөөрөх',
    reject: 'Татгалзах',
    comment: 'Сэтгэгдэл:',
    enter_your_commit: 'Сэтгэгдлээ оруулна уу...',
    confirm_cancel: 'Цуцлахыг баталгаажуулах',
    upload_3d_zip: '3D ZIP-г байршуулна уу',
    delete_items: 'Элементийг устгах',
    video_upload_request: 'Видео байршуулалтын хүсэлт',
    reject_video: 'Видео татгалзах',
    enter_rejection_reason: 'Татгалзсан шалтгаанаа оруулна уу...',
    please_provide_a_reason_for_reejection_this_video:
      'Энэ видеог татгалзах шалтгаанаа оруулна уу:',
    generate_trivia_with_ai: 'AI ашиглан сонирхолтой асуултууд үүсгэх',
    select_category: 'Ангилалыг сонгоно уу:',
    number_of_question: 'Асуултын тоо',
    generated_questions: 'Үүсгэсэн асуултууд',
    this_will_clear_all_generate_question:
      'Энэ нь бүх үүсгэсэн асуултуудыг арилгана. Үргэлжлүүлэх үү?',
    sure_delete: 'Та устгахдаа итгэлтэй байна уу?',
    delete_this_question: 'Энэ асуултыг устгахдаа итгэлтэй байна уу?',
    loading_quiz: 'Сорил ачааллаж байна...',
    creteing_file: 'Файл үүсгэж байна',
    opening_desktop_app: 'Ширээний програм нээж байна...',
    this_folder_is_empty: 'Энэ хавтас хоосон байна',
    select_a_competition: 'Тэмцээнийг сонгоно уу...',
    activity_badges: 'Үйл ажиллагааны тэмдэг',
    awarded_every_badges:
      '4, 8, 16, 32, 64, 128, 256, 512 нэвтрэлт бүрт шагнагдсан',
    learning_badges: 'Сургалтын тэмдэг',
    awarded_every_courses:
      '1, 4, 8, 16, 32, 64, 128 дууссан курс бүрт шагнагдсан',
    test_badges: 'Тестийн тэмдэг',
    awarded_every_passes_tests:
      '2, 4, 8, 16, 32, 64, 128, 256 амжилттай тест бүрт шагнагдсан',
    assignment_badges: 'Даалгаврын тэмдэг',
    awarded_every_passed_assignments:
      '1, 2, 4, 8, 16, 32, 64, 128 амжилттай даалгавар бүрт шагнагдсан',
    perfectionism_badges: 'Төгс төгөлдөрийн тэмдэг',
    awarded_every_assignments_with_scrore:
      '1, 2, 4, 8, 16, 32, 64, 128 оноо 90%+ даалгавар, тест бүрт шагнагдсан',
    communication_badges: 'Харилцааны тэмдэг',
    awarded_every_topics_or_comments:
      '2, 4, 8, 16, 32, 64, 128, 256 сэдэв эсвэл сэтгэгдэл бүрт шагнагдсан',
    certification_badges: 'Гэрчилгээний тэмдэг',
    awarded_every_certificates:
      '1, 2, 4, 8, 16, 32, 64, 128 сертификат бүрт шагнагдсан',
    level_name: 'Түвшний нэр',
    delete_competition: 'Тэмцээнийг устгах',
    this_week: 'Энэ долоо хоног',
    this_year: 'Энэ жил',
    make_organization: 'Байгууллага болгох',
    no_results_found: 'Үр дүн олдсонгүй',
    no_items_available: 'Элементийг олоогүй',
    help_video: 'Туслах видео',
    select_a_video_from_the_list:
      'Сургалтын эхлэхийн тулд жагсаалтаас видеог сонгоно уу'
  },
  v4: {
    upload_another_file: 'Upload another file',
    all_files_uploaded: 'All files uploaded',
    upload_and_submit: 'Upload & Submit',
    drop_files: 'Файлыг чирж оруулж, байрлалыг сонгоно уу.',
    duplicate_lessoon: 'Хичээл аль хэдийн курсанд орсон байна.',
    skill_rule_title: 'Чадварын аяллын гарчгийг оруулна уу',
    imageCreatorTitle: 'Зургийн үүсгэгч',
    isTranslated: 'Орчуулсан',
    translationCourseDesc:
      'Энэхүү курсын орчуулга хэдэн минут үргэлжлэх боломжтой. Тэвчээртэй байсанд баярлалаа!',
    translateCourseTip:
      'Анхны курсээс бие даан засварлах боломжтой орчуулсан курс үүсгээрэй, бүх хичээл болон хуудсуудыг агуулна.',
    translateModalBtn: 'Орчуулах',
    translationSuccess: '“<0/>” курс амжилттай орчуулсан!',
    translatingCourse: 'Курсыг орчуулах...',
    translateModalTitle: 'Курсыг орчуулах',
    translateSelectLang: 'Хэл сонгох',
    fileDeleteconfirm:
      'Та энэ файлыг устгах гэж байгаадаа итгэлтэй байна уу? Үйлдэл гэхэд арилшгүй!',
    fileDeleteMessage: 'Файл амжилттай устгагдлаа.',
    fileDeleteFailedMessage: 'Файл устгахад алдаа гарлаа!',
    fileDelete: 'Энэ файлыг устгах.',
    certificate_save_btn: 'Сертификатыг нэмэх: ',
    maze_path_info: 'Граф дээр ашиглах зам байхгүй байна!',
    file_size_mb: 'Файлын хэмжээ 25MB-с хэтрэж болохгүй!',
    reports: {
      products: 'Бүтээгдэхүүнүүд',
      users: 'Хэрэглэгчид',
      ph_username: 'Хэрэглэгчийн нэрээр хайх',
      ph_id: 'Хэрэглэгчийн ID дугаараар хайх',
      ph_email: 'Хэрэглэгчийн имэйлээр хайх'
    },
    select_upload_section_id: 'Хэсгийн файл шаардлагатай',
    tags_all: 'Бүгд',
    delete_file_confirm: 'Та энэ файлыг устгах уу?',
    delete_file_title: 'Файл устгах',
    tooltip_publish: 'Сонгосон хувилбараар курсыг нийтлэх',
    tooltip_save: 'Курсыг одоогийн шинэчлэлттэйгээр хадгалах',
    tooltip_next: 'Дараагийн курсын тохиргоо руу шилжих',
    tooltip_finish: 'Одоогийн шинэчлэлтийг дуусгаж хадгалах',
    stories_modal: {
      title_upload: 'Түүх байрлуулах',
      title_update: 'Түүх шинэчлэх',
      title_audio: 'Дууны түүхийн файл',
      btn_upload: 'Байрлуулах',
      btn_update: 'Шинэчлэх',
      btn_close: 'Хаах',
      btn_cancel: 'Цуцлах',
      lbl_cover: 'Түүхийн нүүр зураг',
      rule_cover: 'Дууны түүхийн нүүрийг байрлуулаарай!',
      lbl_title: 'Дууны түүхийн нэр',
      rule_title: 'Дууны түүхийн нэрийг оруулна уу!',
      lbl_description: 'Дууны түүхийн тайлбар',
      rule_description: 'Тайлбарыг оруулна уу!',
      lbl_file: 'Дууны түүхийн файлыг байрлуулах',
      rule_file: 'Файлыг байрлуулаарай!',
      rule_file_type: 'Хүчинтэй дууны файл байрлуулаарай!',
      lbl_select_file: 'Дууны түүхийн файл сонгоно уу',
      msg_valid_file: 'Хүчинтэй файл сонгоно уу!',
      msg_success: 'Түүх амжилттай байрлаа',
      msg_failed: 'Медиа мэдээлэл бүртгэхэд алдаа гарлаа!',
      msg_error: 'Файлыг байрлуулахад алдаа гарлаа!'
    },
    audio_modal: {
      title_upload: 'Байрлуулах',
      title_update: 'Шинэчлэх',
      title_audio: 'Дууны файл',
      btn_upload: 'Байрлуулах',
      btn_update: 'Шинэчлэх',
      btn_close: 'Хаах',
      btn_cancel: 'Цуцлах',
      lbl_cover: 'Дууны нүүр зураг',
      rule_cover: 'Нүүр зураг байрлуулаарай!',
      lbl_title: 'Дууны нэр',
      rule_title: 'Дууны нэрийг оруулна уу!',
      lbl_description: 'Дууны тайлбар',
      rule_description: 'Тайлбарыг оруулна уу!',
      lbl_file: 'Дууны файлыг байрлуулах',
      rule_file: 'Файл байрлуулаарай!',
      rule_file_type: 'Хүчинтэй дууны файл байрлуулаарай!',
      lbl_select_file: 'Дууны файлыг сонгоно уу',
      msg_valid_file: 'Хүчинтэй файл сонгоно уу!',
      msg_success: 'Дуу амжилттай байрлаа',
      msg_failed: 'Медиа мэдээлэл бүртгэхэд алдаа гарлаа!',
      msg_error: 'Файлыг байрлуулахад алдаа гарлаа!'
    },
    info_episode: 'Эпизодын нүүр зургийн мэдээлэл.',
    btn_delete_episode: 'Энэ подкаст эпизодыг устгах.',
    btn_edit_marketplace: 'Маркетплейс дэлгэрэнгүй засах.',
    btn_save_marketplace: 'Одоогийн өөрчлөлтийг хадгалах.',
    btn_ai_podcast: 'AI подкаст эпизод үүсгэх.',
    btn_upload_podcast: 'Өөрийн подкаст аудио байрлуулах.',
    attach_file:
      'Үзэгчидтэй илүү их контент хуваалцахын тулд файл байршуулаарай',
    fileDownload: 'Энэ файлыг татаж авах.',
    singleEpishode: 'Эпизод',
    podcast_music: 'подкаст, хөгжим ба түүх',
    publishHeader: 'Подкаст, хөгжим ба түүх нийтлэх',
    editHeader: 'Подкаст, хөгжим ба түүх засах',
    createHeader: 'Подкаст, хөгжим ба түүх үүсгэх',
    marketplaceHeader: 'Подкаст, хөгжим ба түүхийн зах зээлийн дэлгэрэнгүй',
    message_marketplace: 'Маркетплейс маягтыг бөглөнө үү!',
    create_podcast_live: 'Шууд подкаст ба хөгжим',
    create_podcast_custom: 'Захиалгат подкаст ба хөгжим',
    create_podcast_stories: 'Түүхүүд',
    ai_Assisted_podcast_reation: 'AI тусламжтай подкаст ба хөгжим',
    publishTitle: 'Подкаст, хөгжим ба түүхийг олон нийтэд нийтлэх.',
    customButton: 'Захиалгат үүсгэх',
    customTitle: 'Подкаст дээр хийсэн өөрчлөлтийг хадгалах.',
    updateButton: 'Шинэчлэх',
    createButton: 'Үүсгэх',
    createNewButton: 'Шинэ шинэчлэх',
    updateTitle: 'Одоогийн подкаст, хөгжим ба түүхийн мэдээллийг шинэчлэх.',
    createTitle: 'Шинэ подкаст, хөгжим ба түүх үүсгэх',
    createNewTitle: 'Шинэ подкаст, хөгжим, түүх одоогийн оролтоор үүснэ.',
    podcastTitle: 'Эпизодын жагсаалт',
    podcastStoryTitle: 'Түүхийн эпизодын жагсаалт',
    podcastToolTipTitle: 'Подкаст эпизодын жагсаалт',
    uploadAudio: 'Аудио байрлуулах',
    aiAudio: 'AI аудио',
    emptyPodcast: 'Одоогоор подкаст, хөгжим эсвэл түүх бичигдээгүй байна.',
    emptyStoriesPodcast: 'Түүхүүдийг нэмээгүй байна.',
    emptyCreatePodcast: 'Аудио нэмэхийн тулд эхлээд подкаст үүсгэнэ үү.',
    playPodcast: 'Сонгосон подкаст, хөгжим ба түүхийг тоглуулна.',
    pausePodcast: 'Сонгосон подкаст, хөгжим ба түүхийг түр зогсооно.',
    selectPodcast: 'Уг подкаст, хөгжим ба түүхийг сонгоно.',
    downloadPodcast: 'Энэ аудиог татаж авах.',
    uploadAudioFile: 'Шинэ аудио байрлуулаад одоогийн аудиог орлуулах.',
    deleteConfirm: 'Та энэ аудиог устгах уу?',
    roomName: 'Подкастын нэр',
    addGuestTitle: 'Зочин илтгэгч нэмэх',
    showTime: 'Үзүүлэлт цаг',
    startTime: 'Эхлэх цаг',
    endTime: 'Дуусах цаг',
    erorMsgImg: 'Хүчинтэй зураг сонгоно уу.',
    failedMsgImg: 'Зураг татаж авахад алдаа гарлаа. Дахин оролдоно уу!',
    failedMsgUpload: 'Нүүр зураг байршуулахад алдаа гарлаа!',
    btnCoverUpload: 'Нүүр зураг байрлуулах',
    is_private: 'Хувийн',
    to_attach: 'Файл хавсаргах',
    file_attached: 'Файл хавсаргасан',
    main_event: 'Гол арга хэмжээ',
    event: 'Арга хэмжээ',
    upload_pdf: 'PDF байрлуулах',
    portrait: 'Босоо',
    landscape: 'Хэвтээ',
    import_from_library: 'Медиа сангаас текст импортлох',
    question_answer_ai: 'Асуулт/Хариулт AI',
    take_maze: 'MetaMaze орох',
    training: 'Сургалт',
    select_transcribe_locale: 'Хөрвүүлэх хэл сонгоно уу',
    transcribe_limit: 'Хөрвүүлэх минутын тоог оруулна уу',
    not_complete: 'Marketplace-ийн мэдээлэл бүрэн биш байна',
    complete: 'Marketplace-ийн мэдээлэл бүрэн байна',
    not_admin: 'Marketplace руу нийтлэхэд админ эрх шаардлагатай',
    no_course: 'Marketplace идэвхжүүлэхийн тулд гарчиг оруулж зураг сонгоно уу',
    scorm_not_complete:
      'SCORM файл оруулахын тулд гарчиг оруулж зураг сонгоно уу',
    not_found_maze: 'MetaMaze олдсонгүй',
    email_require: 'Имэйл хаяг шаардлагатай',
    poll_required: 'Судалгааны мэдээлэл шаардлагатай',
    alert: 'Анхаар!',
    warning: 'Анхааруулга!',
    ok: 'Тийм',
    cancel: 'Цуцлах',
    done: 'Дууссан',
    insert: 'Оруулах',
    private: 'Хувийн',
    public: 'Нийтийн',
    no_connection: 'Интернэт холболт тасарсан',
    switch: 'Солих',
    share_screen: 'Дэлгэц хуваалцах',
    stop_share_screen: 'Дэлгэц хуваалцахыг зогсоох',
    share_screen_with_camera: 'Камерын хамт дэлгэц хуваалцах',
    stop_share_screen_with_camera: 'Камерын хамт дэлгэц хуваалцахыг зогсоох',
    camera_on: 'Камер асаах',
    camera_off: 'Камер унтраах',
    mic_on: 'Дууг идэвхжүүлэх',
    mic_off: 'Дууг унтраах',
    fullscreen: 'Бүтэн дэлгэц',
    live_now: 'Шууд дамжуулж байна',
    schedule_on: 'Хуваарьласан:',
    organisations: 'Байгууллагууд',
    org_groups: 'Байгууллагын бүлгүүд',
    specific_user: 'Тодорхой хэрэглэгч',
    gif: 'GIF зураг',
    unavailable: 'Боломжгүй',
    yes: 'Тийм',
    no: 'Үгүй',
    event_duration_message: 'Хамгийн ихдээ 300 минут (5 цаг)',
    send_email: 'Имэйл мэдэгдэл илгээх',
    admin_only: 'Зөвхөн админд',
    join: 'Нэгдэх',
    leave: 'Гарах',
    share: 'Хуваалцах',
    share_text: 'Энэ файлыг хуваалцах хүний имэйл хаягийг оруулна уу.',
    share_text_title: 'PDF хуваалцах',
    share_text_title_txt: 'Текст хуваалцах',
    select_users: 'Хэрэглэгч сонгох',
    delete: 'Устгах',
    attachment_event: 'Үйл явдлын хавсралтууд:',
    transcribe_limit: 'Хөрвүүлэх хугацаа (мин)',
    monthly_transcribe: 'Сарын хөрвүүлэлтийн хязгаар:',
    enable_ai: 'AI-г идэвхжүүлэх:',
    enable_maze: 'MetaMaze-г идэвхжүүлэх:',
    media_service: 'Медиа үйлчилгээ',
    allow_others: 'Бусдад засах эрх олгох',
    join_breakout_room: 'Breakout өрөөнд нэгдэх',
    bio: 'Танилцуулга',
    linkedin: 'LinkedIn',
    select_org_report: 'Тайлан гаргах байгууллагыг хайж сонгоно уу',
    org_image_not_found: 'Зураг олдсонгүй',
    insert_text: 'Текст оруулах',
    insert_question_answer: 'Асуулт/Хариулт AI',
    modal_title2: 'Текстийн сан',
    my_text_library: 'Миний текстийн сан',
    ai: 'AI',
    public_text_library: 'Нийтийн текстийн сан',
    organization_text_library: 'Байгууллагын текстийн сан',
    no_transcribed_text: 'Хөрвүүлсэн текст олдсонгүй',
    public_text_not_found: 'Нийтийн хөрвүүлсэн текст олдсонгүй',
    org_text_not_found: 'Байгууллагын хөрвүүлсэн текст олдсонгүй',
    org_video_not_found: 'Видео олдсонгүй',
    canva: 'Canva-аар хийх',
    canva_open: 'Canva редактор нээх бол энд дарна уу.',
    pdf: 'PDF',
    txt: 'ТЕКСТ',
    human: 'Premium',
    shared_file: 'Таны файл амжилттай хуваалцагдлаа.',
    error_shared_file: 'Файл хуваалцахад алдаа гарлаа. Дахин оролдоно уу.',
    publish: 'Нийтлэх',
    maze_scenes: 'MetaMaze-н үзэгдлүүд',
    pexel_images: 'Pexel зураг',
    group: 'Бүлэг',
    group_name: 'Бүлгийн нэр',
    select_group: 'Бүлэг сонгох',
    search_maze: 'MetaMaze хайх',
    hosts: 'Зохион байгуулагчид',
    avg_score: 'Дундаж оноо (%)',
    maze_report: 'Maze тайлан',
    maze_view: 'Maze харагдац',
    title_maze: 'MetaMaze',
    author: 'Зохиогч',
    match: 'Зам таарсан эсэх',
    preview_mazeTitle: 'Гарчиг:',
    other: 'Бусад',
    total: 'НИЙТ',
    report_course: 'СУРГАЛТ',
    report_courses: 'СУРГАЛТУУД',
    report_event: 'ҮЙЛ ЯВДАЛ',
    report_events: 'ҮЙЛ ЯВДЛУУД',
    report_maze: 'МАЗЕ',
    report_personalize_learning: 'ХУВЬЧИЛСАН СУРАЛЦАХУЙ',
    report_live_assessment: 'ШУУД ҮНЭЛГЭЭ',
    report_live_assessments: 'ШУУД ҮНЭЛГЭЭНҮҮД',
    report_skill_journey: 'УР ЧАДВАРЫН АЯЛАЛ',
    skill_journey: 'Ур чадварын аялал',
    skill_journeys: 'Ур чадварын аялалууд',
    date: 'ОГНОО:',
    search_people: 'Хүмүүс хайх',
    passed: 'ТЭНЦСЭН',
    failed: 'УНАСАН',
    item: 'ЗҮЙЛ',
    type: 'ТӨРӨЛ',
    minimum_pass_score: 'ШААЛТ ХАНГАХ ХАМГИЙН БАГА ОНОО',
    resources_count: 'НӨӨЦИЙН ТОО',
    back: 'БУЦАХ',
    resources: 'НӨӨЦҮҮД',
    time_spent: 'ЗАРЦУУЛСАН ЦАГ (МИН)',
    detail: 'ДЭЛГЭРЭНГҮЙ',
    watched_time_mins: 'ҮЗСЭН ЦАГ (МИН)',
    personalize_learning: 'Хувьчилсан суралцахуй',
    result: 'Үр дүн',
    assessment_title: 'Гарчиг',
    marketPlace_graph: 'Marketplace график',
    attachments: 'Нэмэлт хавсралтууд',
    new_scorm_course: 'Шинэ SCORM курс байршуулах',
    upload_scorm_course: 'SCORM курс байршуулах',
    new_maze: 'Шинэ MetaMaze үүсгэх',
    new_skill_journey: 'Ур чадварын аялал үүсгэх',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'Ур чадварын аялал',
    new_discussion_room: 'Шинэ подкаст үүсгэх',
    title: 'Та өнөөдөр юу хийхийг хүсэж байна вэ?',
    build_course: 'Миний курсыг бүтээх',
    live_broadcast: 'Шууд дамжуулалт',
    invite_users: 'Миний байгууллагад хэрэглэгч нэмэх',
    build_voice_over: 'Дуу оруулга хийх',
    view_reports: 'Тайлан харах',
    upload_media: 'Миний медиа эсвэл бүтээлийг байршуулах ба хуваалцах',
    main_menu: 'Үндсэн цэс',
    get_started: 'ЭХЛЭХ',
    search_group: 'Байгууллагын бүлэг хайх',
    ai_course: 'AI курс',
    search_user: 'Компани нэрээр хайх',
    no_maze: 'Одоогоор MetaMaze байхгүй байна.',
    conference_event_title: 'Бага хурлын үйл явдлууд',
    conference_event_subTitle: 'Дууссан бага хурлын үйл явдлууд',
    conference_event: 'Одоогоор бага хурлын үйл явдал алга байна.',
    no_skill: 'Одоогоор ур чадварын аялал байхгүй байна.',
    no_podcast: 'Одоогоор подкаст байхгүй байна.',
    maze_channel: 'MetaMaze',
    past_live_assessment: 'Өмнөх шууд үнэлгээнүүд',
    no_live_assessment: 'Одоогоор шууд үнэлгээ алга байна.',
    enrolled_courses: 'Курсууд',
    my_video_channel: 'Миний видео суваг',
    enrolled_liveEvents: 'Шууд үйл явдлууд',
    sharebot: 'Sharebot',
    selected_language: 'Сонгосон хэл',
    shareSphere_game: 'ShareSphere Тоглоом',
    maze: 'MetaMaze',
    skill: 'Ур чадварын аялал',
    channel: 'Суваг',
    order: 'Захиалга',
    is_record: 'Бичлэг',
    no_maze_found: 'MetaMaze олдсонгүй.',
    maze_self_limit_reached: 'MetaMaze-ийн өөрийгөө үнэлэх хязгаарт хүрсэн.',
    metamaze_two_times: 'Та энэ MetaMaze-ийг 2 удаа хийсэн байна.',
    metamaze_two_times_no_result:
      'Та энэ MetaMaze-ийг 2 удаа хийсэн байна. Гурав дахь удаад үнэлгээ хадгалагдахгүй.',
    scorm_zip: 'SCORM ZIP',
    pass_score: 'Тэнцэх хамгийн бага оноо',
    organization: 'Байгууллагаа сонгоно уу',
    pass_score_mark: '1-ээс 100 хүртэлх оноо оруулна уу',
    maze_cloning_success: 'MetaMaze "<0/>" амжилттай хуулбарлагдлаа!',
    create_certificate: 'Сертификат үүсгэх',
    create_badge: 'Тэмдэг үүсгэх',
    certificate_added: 'Сертификат нэмэгдлээ.',
    badge_added: 'Тэмдэг нэмэгдлээ.',
    certificate_warning:
      'Сертификат/тэмдгийг нийтэлсний дараа өөрчлөх боломжгүй!',
    created_course_plan:
      'Өөрийн бүтээсэн курсыг засварлаж, шууд үйл явдлыг төлөвлөн нийтлээрэй',
    market_place_space: 'Marketplace',
    select_course_language: 'Хэл сонгох (заавал биш)',
    select_language: 'Хэл сонгох',
    file_upload: 'Файл байршуулах',
    text: 'Энд текст бичнэ үү…',
    attempts_count: 'Хэрэглэгч дахин оролдох боломжтой тоо',
    no_of_people_placeholder: 'Хүмүүсийн тоо',
    back_to_maze: 'MetaMaze нөхцөл рүү буцах',
    edit_maze: 'Maze засварлах',
    wait: 'Түр хүлээнэ үү...',
    retry: 'Дахин оролдох',
    publish_scorm_course: 'SCORM курсыг нийтлэх',
    publish_maze: 'MetaMaze-ээ нийтлэх',
    import: 'Элемент импортлох',
    answer_correct: 'Зөв хариуг сонгоно уу',
    author_name: `Зохиогчийн нэрийг оруулна уу`,
    select_category: 'Ангиллыг сонгоно уу',
    course_outline: 'Сургалтын төлөвлөгөөг оруулна уу',
    course_obj: 'Сургалтын зорилгыг оруулна уу',
    course_description: 'Сургалтын тайлбарыг оруулна уу',
    maze_outline: 'Maze-ийн төлөвлөгөөг оруулна уу',
    maze_obj: 'Maze-ийн зорилгыг оруулна уу',
    maze_description: 'Maze-ийн тайлбарыг оруулна уу',
    lessons: 'Хичээлийн тоог оруулна уу',
    user_email_require: `Хэрэглэгчийн и-мэйл шаардлагатай`,
    team_size: `Багийн хэмжээ шаардлагатай`,
    enter_price: 'Үнэ оруулна уу (5 эсвэл түүнээс дээш)',
    input_title_maze: 'Maze-ийн гарчгийг оруулна уу',
    trainer_bio: 'Сургалтын багшийн намтрыг оруулна уу',
    trainer_linkedin: 'Сургалтын багшийн LinkedIn хаягийг оруулна уу',
    error_video: 'Видео тоог оруулна уу',
    input_video_link: 'Видео холбоосыг оруулна уу',
    number_of_video: 'видео тоо',
    number_of_lessions: 'хичээлийн тоо',
    no_of_people_in_conference: 'Хурлын оролцогчдын тоо хэд вэ?',
    transcribe_settings: 'Хуулбарлах тохиргоо',
    transcribe: 'Хуулбарлах',
    cloning_maze: 'MetaMaze-г хуулбарлаж байна...',
    id_number: 'Иргэний дугаар',
    timezone: 'Цагийн бүс',
    edit_maze: 'Засах',
    delete_maze: 'Устгах',
    view_maze: 'Харах',
    create_metamaze: 'MetaMaze үүсгэх',
    metamaze_scenario: 'MetaMaze-н нөхцөл байдал',
    publish_metamaze: 'Нийтлэх тохиргоо',
    search_result: 'Хайлтын үр дүн:',
    search_for: 'Хайх',
    search_no_result: '- Илэрц олдсонгүй!',
    channel_no_available: 'Суваг байхгүй байна!',
    this_card: 'Энэ бол карт',
    course_no_available: 'Сургалт байхгүй байна!',
    exit_fullscreen: 'Бүтэн дэлгэцээс гарах',
    bg_image: 'Арын зураг',
    introduction: 'Танилцуулга',
    summary: 'Хураангуй',
    generate_introduction: 'Танилцуулга үүсгэх',
    generate_summary: 'Хураангуй үүсгэх',
    bullet_points: 'Товч мэдээллүүд',
    title_simulation: 'Симуляцийн нэрийг оруулна уу',
    view_generated_images: 'Үүсгэсэн зургуудыг харах',
    image_transparency: 'Зургийн тунгалаг байдал',
    template_bg_color: 'Загварын арын өнгө',
    select_template_layout: 'Загварын зохион байгуулалтыг сонгоно уу',
    reload_template: '(Загваруудыг дахин ачаалах)',
    are_you_sure_want_close: 'Та хаахдаа итгэлтэй байна уу?',
    all_your_changes_will_be_lost: 'Таны бүх өөрчлөлт алдагдана.',
    please_checked_before_generated_video:
      'Видео үүсгэхээс өмнө бүх нөхцөлийг шалгасан эсэхээ баталгаажуулна уу.',
    voice_must_be_selected: 'Дуу хоолой заавал сонгогдсон байх ёстой',
    avatar_must_be_selected: 'Аватар зураг заавал сонгогдсон байх ёстой.',
    maximum_five_slides_try_again:
      'Файлаас зураг гаргах явцад алдаа гарлаа. Файлд 5 слайдаас ихгүй байх ба бүр слайд дээр тэмдэглэл байх ёстой. Дахин оролдоно уу!',
    back_to_upload: 'Буцах ба байршуулах',
    uploading_file_to_server: 'Файлыг сервер лүү байршуулж байна',
    extracting_images_from_your_file: 'Файлаас зураг гаргаж байна',
    upload_your_ppt_or_drag:
      'Танилцуулгын (.PPTX) файлаа байршуулах эсвэл энд чирж тавина уу.',
    maximum_five_slides_error:
      'PowerPoint файл 5 слайдаас ихгүй бөгөөд бүр слайд дээр тэмдэглэлтэй байх ёстой. Үгүй бол алдаа гарна.',
    number_of_questions_generated: 'Гарах асуултуудын тоо',
    quiz_page_this_cannot_be_done:
      'Та энэ хуудсанд тест нэмэхдээ итгэлтэй байна уу? Энэ үйлдлийг буцаах боломжгүй.',
    confirm_selection: 'Сонголтыг баталгаажуулах',
    select_quiz_page: 'Тестийн хуудсыг сонгох',
    lesson_do_you_want_add_this_quiz:
      'Та энэ тестийг хичээлийн аль хэсэгт нэмэх вэ?',
    beginning_of_lesson: 'Хичээлийн эхэнд',
    end_of_lesson: 'Хичээлийн төгсгөлд',
    currently_active_page: 'Идэвхтэй хуудас',
    finish: 'Дуусгах',
    upload_selection_file: 'Хэсгийн файлыг байршуулах',
    general_quiz: 'Ерөнхий тест',
    manage_sequence: 'Дараалал удирдах',
    save_sequence: 'Дарааллыг хадгалах',
    new: 'Шинэ',
    in_progress: 'Явц дунд',
    recommended_course: 'Зөвлөмж болгосон сургалт',
    up_coming: 'Удахгүй',
    past_live: 'Өнгөрсөн шууд хичээл',
    input_your_channel_name: 'Суваг нэрээ оруулна уу!',
    organization_place: 'Байгууллагын зах зээл',
    marketplace_report: 'Зах зээлийн тайлан',
    story_writing: 'Түүх бичих',
    Ai_quiz: 'AI тест',
    generate_quiz: 'Тест үүсгэх',
    create_story: 'Түүх үүсгэх',
    change_layout_page: 'Та энэ хуудасны байршлыг өөрчлөх гэж байна.',
    change_layout_message:
      'Зөвхөн текст, зураг, фон болон лого хадгалагдана. Бусад бүх элементүүд устах болно.',
    reviews: 'Сэтгэгдлүүд',
    tab_attachments: 'Хавсралтууд',
    zoom_in: 'Томруулах',
    zoom_out: 'Жижигрүүлэх',
    zoom_reset: 'Анхны хэмжээг сэргээх',
    no_attachment: 'Хавсралт алга.',
    select_upload_simulation: 'Симуляц сонгох/байршуулах',
    quiz_updated_successfully: 'Тест амжилттай шинэчлэгдлээ!',
    quizes: 'Тестүүд',
    trivia: 'Сонирхолтой баримт',
    closing: 'Хааж байна...',
    products: 'Бүтээгдэхүүнүүд',
    ask_questions: 'Асуултаа энд бичнэ үү...',
    course_information: 'Сургалтын мэдээлэл',
    course_assistance: 'Сургалт бүтээгчийн тусламж',
    go_back: 'Буцах',
    ai_generate_content_progress: 'Агуулга үүсгэж байна',
    view_generate_content: 'Үүсгэсэн агуулгыг харах',
    generate_error: 'Үүсгэх үед алдаа гарлаа!',
    confirm_creating_course: 'Энэ агуулгаар курс үүсгэхдээ итгэлтэй байна уу?',
    generate_content_automatically:
      'Энэ нь үүсгэсэн бүх агуулгыг хичээл болон хуудас хэлбэрээр автоматаар курс рүү нэмнэ.',
    quiz_created_successfully: 'Сорил амжилттай үүслээ!',
    create_quiz: 'Сорил үүсгэх',
    quiz_setting: 'Сорилын тохиргоо',
    please_fill_quiz_setting: '* Сорилын тохиргооны бүх талбарыг бөглөнө үү',
    question_list: 'Асуултын жагсаалт',
    add_quiz_to_page: 'Хуудас руу сорил нэмэх',
    form_create_question: 'Асуулт үүсгэх маягт',
    user_information_updated: 'Хэрэглэгчийн мэдээлэл шинэчлэгдлээ!',
    your_stripe_activete_to_continue:
      'Stripe бүртгэл идэвхгүй байна. Үргэлжлүүлэхийн тулд идэвхжүүлнэ үү.',
    connect_tripe: 'Stripe холбох',
    certificate_sent_sucessfully:
      'Сертификатыг таны и-мэйл хаяг руу амжилттай илгээлээ.',
    error_try_again: 'Алдаа гарлаа. Дахин оролдоно уу!',
    error_delete_channel: 'Сувгийг устгах үед алдаа гарлаа.',
    error_update_sub: 'Захиалга шинэчлэх үед алдаа гарлаа.',
    end_time_cannot_start:
      'Дуусах хугацаа эхлэх хугацаанаас өмнө байж болохгүй.',
    start_date_time_interval: 'Эхлэх огноо, цаг шаардлагатай!',
    podcast_updated_successful: 'Подкаст амжилттай шинэчлэгдлээ.',
    podcast_created_successful: 'Подкаст амжилттай үүслээ.',
    podcast_published_successful: 'Подкаст нийтлэгдлээ.',
    podcast_cover_updated: 'Подкастын хавтас шинэчлэгдлээ.',
    new_podcast_details:
      'Одоогийн подкаст дээр үндэслэн шинэ оролттойгоор шинэ подкаст үүснэ.',
    current_update_podcast:
      'Одоогийн подкастыг шинэчлэх (дуу хөгжим ба түүхийн хамт).',
    create_new_podcast: 'Шинэ подкаст үүсгэх',
    publish_podcast_public_view: 'Подкастыг олон нийтэд нийтлэх.',
    only_allowed_twenty_five_email: 'Зөвхөн 25 и-мэйл хаяг зөвшөөрөгдөнө.',
    only_allowed_five_email: 'Зөвхөн 5 и-мэйл хаяг зөвшөөрөгдөнө.',
    cover_is_required: 'Хавтас шаардлагатай.',
    topic_is_required: 'Сэдэв шаардлагатай.',
    delete_schedule: 'Цагийн хуваарь устгах',
    make_as_coaching: 'Зөвлөгөө өгөх боломжтой гэж тэмдэглэх',
    manage_category: 'Ангилал удирдах',
    threshold: 'Босго',
    threshold_popup:
      'Хувиар (%) илэрхийлэх босгын утга, тухайн ангилалд санал болгохыг идэвхжүүлнэ.',
    list_of_catagory: 'Ангиллын жагсаалт',
    category_name: 'Ангиллын нэр',
    category_threshold: 'Ангиллын босго',
    play_game: 'Тоглоом тоглох',
    switching_organization: 'Байгууллага солигдож байна...',
    coaching_session: 'Зөвлөх уулзалт',
    required_channel_id: 'Сувгийн ID шаардлагатай!',
    error_occured_try_again: 'Алдаа гарлаа. Дахин оролдоно уу!',
    please_complete_marketplace_form: 'Marketplace маягтыг бөглөнө үү!',
    upload_file_corrupt: 'Хуулсан файл гэмтсэн байна.',
    course_not_published: 'Курс нийтлэгдээгүй байна!',
    error_request: 'Хүсэлт илгээхэд алдаа гарлаа. Дахин оролдоно уу!',
    skill_request: 'Дутуу талбарыг бөглөнө үү!',
    error_occured: 'Алдаа гарлаа. Дахин оролдоно уу!',
    show_time: 'Цаг харуулах',
    start_time: 'Эхлэх цаг',
    end_time: 'Дуусах цаг',
    room_name: 'Подкаст нэр',
    add_guest_speaker: 'Уригдсан илтгэгч нэмэх',
    cover_picture: 'Хавтасны зураг',
    guest_speaker: 'Уригдсан илтгэгч',
    see_more: 'Илүү харах',
    see_less: 'Хураах',
    background: 'Арын хэсэг',
    icon: 'Дүрс',
    icon_size: 'Дүрсний хэмжээ',
    icon_color: 'Дүрсний өнгө',
    only_text: 'Зөвхөн текст',
    change_bg: 'Арын өнгө өөрчлөх',
    bg_color: 'Арын өнгө',
    font_size: 'Фонтын хэмжээ',
    normal: 'Энгийн',
    change_color: 'Текстийн өнгө өөрчлөх',
    slant_text: 'Налуу текст',
    text_radius: 'Текстийн дугуйрсан радиус',
    vertical_align: 'Босоо чиглэл',
    horizontal_align: 'Хэвтээ чиглэл',
    change_icon_color: 'Дүрсний өнгө солих',
    upload_icon: 'Дүрс оруулах',
    upload_signature: 'Гарын үсэг оруулах',
    add_another_sign: 'Өөр гарын үсэг нэмэх',
    name_badges: 'Badge нэр',
    should_less_150: '150 тэмдэгтээс хэтрэхгүй байх',
    your_badge: 'Таны badge',
    do_you_want_delete_badge: 'Та энэ badge-г устгахдаа итгэлтэй байна уу?',
    do_you_want_delete_cert: 'Та энэ сертификатыг устгахдаа итгэлтэй байна уу?',
    upload_logo: 'Лого оруулах',
    name_of_cert: 'Сертификатын нэр',
    upload_cert: 'Сертификат шинэчлэх',
    your_cert: 'Таны сертификат',
    translate_to: 'Орчуулах хэл',
    select_file_attach: 'Хавсаргах файлаа сонгоно уу',
    certificate: 'Сертификат',
    badge: 'Badge',
    publish_options: 'Нийтлэх сонголтууд',
    publish_skills_journey: 'Ур чадварын аяллыг нийтлэх',
    videos: 'Видео',
    generate_ai_video:
      'Видео үүсгэх процесс хэсэг хугацаа шаардана. Дуусмагц танд и-мэйл илгээнэ.',
    trainer_information: 'Сургалтын багшийн мэдээлэл',
    promotional_video_link: 'Сурталчилгааны видео холбоос',
    please_select: 'Сонгоно уу',
    image_name: 'Зургийн нэр:',
    image_size: 'Зургийн хэмжээ:',
    charecters_fifteen_less: '15 тэмдэгт эсвэл бага',
    leadership: 'Манлайлал',
    text_arc: 'Текстийн нум',
    vertical: 'Босоо',
    horizontal: 'Хэвтээ',
    badge_history: 'Badge түүх',
    templates: 'Загварууд',
    sign: 'Гарын үсэг',
    logo: 'Лого',
    certificate_history: 'Сертификатын түүх',
    please_wait: 'Түр хүлээнэ үү...',
    information: 'Мэдээлэл',
    support_five_thousand_live_event:
      '5000 хүртэл оролцогчтой шууд арга хэмжээг дэмжинэ',
    support_ten_live_event:
      '10 хүртэлх оролцогч бүхий видео арга хэмжээг дэмжинэ',
    we_will_back_participant:
      'Бид илүү олон оролцогчтой арга хэмжээтэй эргэн ирнэ.',
    course_objectives: 'Сургалтын зорилго',
    course_outlines: 'Сургалтын агуулга',
    price_dollor: 'үнэ (ам.доллар)',
    not_completed: 'Дутуу',
    enable_marketplace: 'Marketplace идэвхжүүлэх',
    enable_course_ai: 'AI-аар курс үүсгэх идэвхжүүлэх',
    enable_report_to_admin: 'Админд тайлан харахыг идэвхжүүлэх',
    enable_white_label: 'White-label идэвхжүүлэх',
    enable_eleven_labs_for_maze_play: 'Maze Play-д ElevenLabs идэвхжүүлэх',
    enable_eleven_labs_for_maze_play_cloned:
      'Cloned ElevenLabs дуу идэвхжүүлэх',
    simulation_quiz: 'Симуляц сорил',
    bg_color_setting: 'Арын өнгө тохиргоо',
    color_preview: 'Өнгөний урьдчилсан харагдац',
    choose_new_color: 'Шинэ өнгө сонгох',
    remove_color: 'Өнгө устгах',
    apply_color: 'Өнгө хэрэглэх',
    elemeent_in_a_sceenario_page:
      'Сценарийн хуудсан дээр өөр элемент нэмж болохгүй. Бусад хуудсыг сонгох эсвэл сценарийг устгаарай.',
    no_data_found: 'Мэдээлэл олдсонгүй.',
    references: 'Эшлэл',
    open_file: 'Файл нээх',
    showing_result: 'Үр дүнг харуулж байна:',
    fiften_day_free_trail: '15 хоногийн үнэгүй туршилт',
    your_browser_does_not_support:
      'Таны хөтөч энэ аудио элементийг дэмжихгүй байна.',
    podcast_desc: 'Подкастын тайлбар',
    input_podcast_desc: 'Подкастын тайлбарыг оруулна уу',
    podcast_obj: 'Подкастын зорилго',
    input_podcast_obj: 'Подкастын зорилгыг оруулна уу',
    podcast_outline: 'Подкастын төлөвлөгөө',
    input_podcast_outline: 'Подкастын төлөвлөгөөг оруулна уу',
    add_file: 'Файл нэмэх',
    generate_podcast_audio: 'Подкастын аудио үүсгэх',
    generate_uploaded_file_input_parameter:
      'Хэрэглэгчийн байршуулсан файл болон оруулсан параметрүүдэд үндэслэн контент үүсгэнэ.',
    go_backe_generation_state: 'Контент үүсгэх төлөв рүү буцах',
    create_ai_powered_podcast:
      'AI ашиглан подкастын ангийг аудиотойгоор үүсгэх',
    generate_voice_for_all_podcast:
      'Бүх подкастын ангид зориулж дуу хоолой үүсгэнэ үү',
    create_podcast_episode: 'Подкастын анги үүсгэх',
    voice_name: 'Дуу хоолойн нэр',
    input_custom_name: 'Захиалгат нэр оруулна уу!',
    enter_custom_name: 'Захиалгат дуу хоолойн нэр оруулна уу',
    upload_complete: 'Байршуулах дууссан',
    uploading_in_progress: 'Байршуулах явцад...',
    podcast_stream_content: 'Подкастын урсгал контент',
    upload_podcast_cover: 'Подкастын нүүр зураг байршуулна уу!',
    enter_podcast_name: 'Подкастын нэрийг оруулна уу!',
    podcast_topic: 'Подкастын сэдэв',
    enter_podcast_topic: 'Подкастын сэдвийг оруулна уу!',
    enter_podcast_desc: 'Подкастын тайлбарыг оруулна уу!',
    number_of_speaker: 'Яригчдын тоо',
    select_the_number_of_speaker: 'Яригчдын тоог сонгоно уу!',
    number_of_episode: 'Ангиудын тоо',
    input_number_of_episode: 'Ангиудын тоог оруулна уу!',
    podcast_length: 'Подкастын үргэлжлэх хугацаа',
    select_the_podcast_length: 'Подкастын үргэлжлэх хугацааг сонгоно уу!',
    short_podcast: 'Богино (5-10 мин)',
    medium_podcast: 'Дунд (15-18 мин)',
    long_podcast: 'Урт (18+ мин)',
    name_of_host: 'Хөтлөгчийн нэр',
    enter_host_name: 'Хөтлөгчийн нэрийг оруулна уу!',
    guest_name: 'Зочдын нэр',
    enter_guest_name: 'Зочдын нэрийг оруулна уу!',
    choose_speaker_tone: 'Яригчийн өнгө аяс сонгох',
    enter_speaker_tone: 'Подкастын өнгө аясыг сонгоно уу!',
    informal: 'Албан бус',
    formal: 'Албан ёсны',
    serious: 'Ноцтой',
    light_humor: 'Хөнгөн хошигнолтой',
    casual: 'Энгийн',
    select_content_source: 'Контентын эх сурвалж сонгох',
    from_internet: 'Интернэтээс',
    upload_pdf_internet: 'PDF эсвэл дотоод баримт бичиг байршуулах',
    note: 'Тэмдэглэл:',
    podcast_content_will_be_automatically_generated:
      'Подкастын контент итгэлтэй интернэт эх сурвалжаас автоматаар үүсгэгдэх болно.',
    upload_or_select_file: 'Файл байршуулна уу эсвэл сонгоно уу!',
    podcast_eposode_title: 'Подкастын ангийн гарчиг',
    enter_podcast_title: 'Ангийн гарчгийг оруулна уу!',
    podcast_episode_des: 'Подкастын ангийн тайлбар',
    enter_podcast_episode_des: 'Ангийн тайлбарыг оруулна уу!',
    voice: 'Дуу хоолой',
    music: 'Хөгжим',
    select_music: 'Хөгжим сонгох',
    play_the_music: 'Хөгжим тоглуулах',
    stop_the_music: 'Хөгжим зогсоох',
    context: 'Агуулга',
    generate_audio_content_selected_voice:
      'Сонгосон дуу хоолойд тулгуурлан аудио үүсгэнэ.',
    required_field_before_submitting:
      'Илгээхээс өмнө бүх шаардлагатай талбарыг бөглөнө үү.',
    regenerate_voice: 'Дахин дуу хоолой үүсгэх',
    generate_voice: 'Дуу хоолой үүсгэх',
    your_browser_does_not_suppot: 'Таны хөтөч аудио элемент дэмжихгүй байна.',
    are_sure_leave_podcast: 'Подкастыг орхих уу?',
    broadcast_ongoing: 'Шууд дамжуулалт явагдаж байна. Энэ хуудсаас гарах уу?',
    brodcaster_unavailable: 'Одоогоор хөтлөгч боломжгүй байна.',
    setting_calender_for_booking: 'Захиалгын хуанли тохируулж байна',
    add_calender: 'Хуанли нэмэх',
    waiting_join_host: 'Хөтлөгчийг нэгдэхийг хүлээж байна...',
    no_reviews_found: 'Сэтгэгдэл олдсонгүй.',
    rated_already: 'Та энэ шууд дамжуулалтыг аль хэдийн үнэлсэн байна.',
    downlink_png: 'PNG татах',
    downlink_jpg: 'JPG татах',
    donwload_file_format: 'Татах файлын форматыг сонгоно уу.',
    crashed_event:
      'Энэ үйл явдал тасалдсан байна. Шинэ үйл явдал үүсгэнэ үү. Уучлаарай.',
    prompt: 'Түлхүүр үг:',
    generated_image: '🚀 Зургийг үүсгэж байна... Түр хүлээнэ үү.',
    download_add: 'Бүгдийг татах',
    setting_generator: 'Үүсгэгч тохируулга',
    enter_image_prompt: 'Зураг үүсгэх түлхүүр үг оруулна уу',
    image_prompt: 'Зураг үүсгэх түлхүүр үг оруулах',
    negative_prompt: 'Сөрөг түлхүүр үг',
    negative_image_prompt: 'Сөрөг зураг үүсгэх түлхүүр үг оруулна уу',
    number_output: 'Гаралтын тоо',
    enter_number_output: 'Гаралтын тоог оруулна уу',
    image_style: 'Зургийн хэв маяг сонгоно уу',
    output_format: 'Гаралтын формат',
    seeds: 'Үр',
    enter_seeds: 'Үрийн тоог оруулна уу',
    performance_mode: 'Гүйцэтгэлийн горим',
    quality: 'Чанар',
    speed: 'Хурд',
    balanced: 'Тэнцвэртэй',
    guidance_scale: 'Зааварчилгааны хэмжээ',
    enter_guidance: 'Зааварчилгааны хэмжээг оруулна уу',
    select_image: 'Зураг сонгоно уу.',
    image_prmt: 'Зургийн түлхүүр үг',
    generate_image_list_empty: 'Үүсгэсэн зураг хоосон байна.',
    knowledge_center_tooltrip_des:
      'Ерөнхий мэдлэгийн асуултуудад AI ашиглан товч бөгөөд зөв хариулт өгнө. Хариулт нь интернетийн олон төрлийн эх сурвалж дээр үндэслэсэн.',
    contexts: 'Агуулга',
    ai_processing_video_sharebot:
      'AI видеог боловсруулахад 24 цаг шаардагдах бөгөөд Sharebot дээр харагдах болно.',
    remove_sharebot_video:
      'Sharebot-с видеог хасах бол тухайн видео болон транскрипцийг устгана уу.',
    remove_sharebot_video_audio:
      'Транскрипцийг устгаснаар Sharebot-с видео/аудио холбоос устах ч видео медиа номын санд харагдана.',
    monthly_live_stream:
      'Сарын шууд дамжуулалтын хязгаарыг өөрчлөхийг хүсвэл холбогдоно уу',
    monthly_transcribe_limit:
      'Сарын транскрипцийн хязгаарыг өөрчлөхийг хүсвэл холбогдоно уу',
    must_be_one_to_three_hundred: '1-300 минутын хооронд байх ёстой.',
    all_field_required: 'Бүх талбар шаардлагатай.',
    duration_minute: 'Хугацаа (хамгийн ихдээ 300 минут)',
    gender: 'Хүйс',
    select_gender: 'Хүйс сонгох',
    accent: 'Аялга',
    select_accent: 'Аялга сонгох',
    create_voice: 'Дуу үүсгэх',
    enter_voice_name: 'Дууны нэр оруулна уу',
    select_voice_gender: 'Дууны хүйсийг сонгоно уу',
    upload_voice: 'Өөрийн дууг байршуулах',
    upload_voice_mp_three: 'Өөрийн дууг байршуулах (.mp3)',
    cloned_voice: 'Хуулсан дуу',
    voice_type: 'Дууны төрөл',
    select_voice_type: 'Дууны төрлийг сонгоно уу',
    sharelook_stand: 'Стандарт',
    sharelook_premium: 'Премиум',
    sharelook_custum_voice: 'Тохируулсан (дууг хуулбарлах)',
    create_auto_flow: 'Автомат урсгал үүсгэх',
    how_many_layers: 'Хэдэн үе шаттай вэ',
    verify_selection: 'Сонголтоо баталгаажуулах',
    uploaded_successful: 'Амжилттай байршлаа',
    upload_failed: 'Байршуулахад алдаа гарлаа',
    upload_only_five_mb: 'Контент байршуулах (PDF файлууд, дээд тал нь 5)',
    docs_from_org_library: 'Байгууллагын сангаас баримт ашиглах',
    failed_maze_generate: 'Maze үүсгэхэд алдаа гарлаа. Дахин оролдоно уу.',
    generate_metamaze: 'MetaMaze үүсгэж байна...',
    metamaze_being_generated:
      'Таны MetaMaze үүсгэгдэж байна. Дууссаны дараа имэйлээр мэдэгдэнэ.',
    metamaze_generate_successfully: 'MetaMaze амжилттай үүсгэгдлээ!',
    metamaze_with_proceed: 'MetaMaze-г ашиглан үргэлжлүүлнэ үү.',
    ai_metamaze_generate: 'AI-аар MetaMaze үүсгэх',
    what_kind_maze_create: 'Ямар төрлийн maze үүсгэх вэ?',
    manual_metamaze_creation: 'Гараар MetaMaze үүсгэх',
    manually_maze_customizing_scnario:
      'Сценар ба сонголтын модыг гараар өөрчлөн maze үүсгэх',
    maze_ai_generated: 'AI-аар автоматаар үүсгэсэн maze',
    unmark_deadend: 'Төгсгөл биш гэж тэмдэглэх',
    mark_deadend: 'Төгсгөл гэж тэмдэглэх',
    select_multiple_image_for_scenario:
      'Сценарийн хувьд олон зураг сонгож болно.',
    select_your_image: 'Таны сонгосон зургууд',
    click_to_preview: 'Урьдчилан харахын тулд дарна уу',
    are_you_sure_delete_image: 'Энэ зургийг устгахдаа итгэлтэй байна уу?',
    select_image_from_library: 'Медиа сангаас зураг сонгох',
    uploading_video: 'Видео байршиж байна...',
    tree_node_type: 'Модны зангилааны төрөл',
    correct_option_scenario: 'Зөв сонголт эсвэл сценар',
    incorrect_option: 'Буруу сонголт',
    option_scenario_without_text: 'Текстгүй сонголт эсвэл сценар',
    dead_end: 'Төгсгөл (улаан хүрээтэй)',
    correct_path: 'Зөв зам',
    incorrect_path_not_selected_correct_option_path:
      'Буруу зам / Зөв сонголт хийгдээгүй зам',
    double_click_on_tree_node:
      'Модны зангилаа дээр давхар дарснаар тухайн агуулгыг текст засварлагч руу автоматаар шилжүүлнэ.',
    add_scenario: 'Сценар нэмэх',
    add_option: 'Сонголт нэмэх',
    an_error_occured: 'Алдаа гарлаа:',
    download_summary: 'Хураангуй татах',
    step_wise_analysis: 'Алхам алхмаар шинжилгээ',
    step: 'Алхам',
    upload_csv_file: 'CSV файл байршуулах',
    download_template_to_import: 'Жишээ загварыг татаж авч импортлох',
    please_input_email: 'И-мэйл хаяг оруулна уу.',
    email_at_least_three_characters: 'И-мэйл дор хаяж 3 тэмдэгт байх ёстой.',
    email_cannot_be_empty: 'И-мэйл хоосон байж болохгүй.',
    input_email_in_new_line: 'И-мэйл хаягуудыг тус бүр шинэ мөрөнд оруулна уу',
    role: 'Үүрэг',
    select_role: 'Үүрэг сонгоно уу',
    select_group: 'Бүлэг сонгоно уу',
    identification_number: 'Бүртгэлийн дугаар (Сонголттой)',
    add_identification_number: 'Бүртгэлийн дугаар оруулна уу',
    pie_chart_of_all_categories:
      'Sharelook дахь бүх ангиллын хэрэглээг харуулсан дугуй график.',
    total_sharesphere_question_answered_by_users:
      'Тухайн байгууллагад хэрэглэгчдийн хариулсан ShareSphere-ийн нийт асуулт болон ангилал тус бүрийн амжилт, алдааны тоо.',
    voice_style_over_the_text:
      'Та бичсэн текст дээр олон төрлийн дууны хэв маяг ашиглаж болно. Жишээ: Lorem Ipsum бол хэвлэлийн болон бичгийн стандарт хэрэглээний текст юм...',
    input_your_question: 'Асуултаа оруулна уу!',
    make_me_sales_manager:
      'жишээ: Намайг борлуулалтын менежер болгохын тулд юу хийх хэрэгтэй вэ?',
    enter_the_number_relevant_document: 'Холбогдох баримтын тоог оруулна уу',
    please_wait_loading_result: 'Үр дүн ачаалагдаж байна. Түр хүлээнэ үү...',
    no_result_found: 'Үр дүн олдсонгүй. Өөрөөр оролдоно уу',
    browser_doesnot_support_iframes: 'Таны хөтөч iframe дэмжихгүй байна',
    total_duration: 'Нийт хугацаа',
    number_of_messages: 'Мессежийн тоо',
    search_result: 'Хайлтын үр дүн',
    count_result: '(1244 үр дүн)',
    your_other_interests: 'Таны бусад сонирхол',
    your_total_score: 'Таны нийт оноо',
    add_a_question: '+Асуулт нэмэх',
    travia_question_empty: 'Travia асуултын жагсаалт хоосон байна.',
    video_generation_is_on_queue: 'Таны видео үүсгэх хүсэлт дараалалд байна!',
    checking_video_status: 'Видео төлөв шалгаж байна...',
    total_quizzes: 'Нийт сорилууд',
    number_of_votes: 'Саналын тоо',
    total_events: 'Нийт үйл явдал',
    number_of_rates: 'Үнэлгээний тоо',
    number_of_likes: 'Таалагдсан тоо',
    all_courses: 'Бүх сургалтууд',
    total_questions: 'Нийт асуултын тоо',
    no_skill_journey: 'Ур чадварын аялал олдсонгүй!',
    search_no_results: '- Хайлтад үр дүн алга!',
    no_image_generated: 'Зураг үүсээгүй!',
    all_topic_in_this_lesson:
      'Энэ хичээлийн бүх сэдэв устах болно. Энэ үйлдлийг буцаах боломжгүй.',
    content_has_been_generated: 'Энэ сэдвийн контент амжилттай үүссэн.',
    update_course_template: 'Сургалтын загвар шинэчлэх',
    add_course_template: 'Сургалтын загвар нэмэх',
    create_course_now: 'Сургалт шууд үүсгэх',
    preview_course: 'Сургалт урьдчилан харах',
    layout: 'Загвар',
    import_from_youtube: 'YouTube-оос импортлох',
    my_media_library: 'Миний медиа сан',
    bg_added: 'Арын дэвсгэр нэмэгдсэн',
    add_bg: 'Арын дэвсгэр нэмэх',
    booked_schedule: 'Захиалсан хуваарь',
    add_schedule: 'Хуваарь нэмэх',
    are_you_delete_schedule: 'Энэ хуваарийг устгахдаа итгэлтэй байна уу?',
    add_task: 'Даалгавар нэмэх',
    update_calender: 'Календар шинэчлэх',
    manage_cookies: 'Куки-ийг удирдах',
    cookie_banner_text:
      'Бид таны веб хөтчлийн туршлагыг сайжруулах, вэбсайтын траффикийг анализ хийх, агуулгыг хувийн болгохын тулд күүки ашигладаг. Таны нууцлал бидэнд чухал.',
    accept_all_cookies: 'Бүх күүки-г зөвшөөрөх',
    reject_all: 'Бүгдийг татгалзах',
    customize: 'Тохируулах',
    cookie_preferences_title: 'Күүки тохиргоо & Нууцлалын тохиргоо',
    privacy_subtitle:
      'Таны нууцлал чухал. Та аль күүки-г зөвшөөрөхөө сонгож болно. Та эдгээр тохиргоог хүссэн үедээ өөрчилж болно.',
    save_choices: 'Миний сонголтыг хадгалах',
    strictly_necessary: 'Зөвхөн зайлшгүй шаардлагатай',
    strictly_necessary_desc:
      'Эдгээр күүки нь вэбсайт хэвийн ажиллахад зайлшгүй шаардлагатай. Энэ нь хуудаснаас хуудас шилжих, форм илгээх, аюулгүй хэсэгт нэвтрэх зэрэг үндсэн функцуудыг идэвхжүүлдэг. Үүнийг ашиглахгүй бол вэбсайт хэвийн ажиллах боломжгүй.',
    analytics_performance: 'Аналитик & Гүйцэтгэл',
    analytics_performance_desc:
      'Эдгээр күүки нь вэбсайтад хэрэглэгчид хэрхэн харилцаж байгааг нэргүйгээр цуглуулж тайлагнахад тусалдаг. Энэ нь вэбсайтын гүйцэтгэл болон хэрэглэгчийн туршлагыг сайжруулахад тусалдаг.',
    advertising_marketing: 'Сурталчилгаа & Маркетинг',
    advertising_marketing_desc:
      'Эдгээр күүки нь сурталчилгааны мессежийг таны сонирхолд нийцүүлэхэд ашиглагддаг. Тэд ижил зар дахин гарч ирэхээс сэргийлж, сурталчилгааны зөв харагдах байдлыг хангадаг.',
    tracking_social: 'Хянах & Нийгмийн медиа',
    tracking_social_desc:
      'Эдгээр күүки нь сайжруулсан функц болон хувийн тохиргоог идэвхжүүлдэг, жишээ нь нийгмийн медиа функц болон хувийн агуулга. Үүнийг бид эсвэл гуравдагч талын үйлчилгээ үзүүлэгч үүсгэж болно.',
    functional: 'Функционал',
    functional_desc:
      'Эдгээр күүки нь чат дэмжлэг, шууд тусламж болон бусад интерактив функцуудыг идэвхжүүлж, вэбсайтад хэрэглэгчийн туршлагыг сайжруулдаг.',
    your_rights: 'Таны эрх:',
    rights_description:
      'Та хүссэн үедээ зөвшөөрлөө буцаах, өгөгдөлд хандах эсвэл устгахыг хүсэх боломжтой.',
    withdraw_consent: 'Бүх зөвшөөрлийг буцаах',

    how_many_options: 'Сонголт хэд вэ',
    add_content: 'Агуулга нэмэх',
    downloads_center: 'Татаж авах төв',
    sharelook_help_center: 'Sharelook Тусламжийн төв',
    channel_outline: 'Суваг тойм',
    channel_objectives: 'Суваг зорилго',
    no_sop_available: 'Боломжтой SOP жагсаалт алга.',
    generate_world_summary: 'Сценари үүсгэх',
    world_scenario: 'Бодит амьдралын сценари',
    drag_icon_hint: 'Зөвлөмж: Иконыг канвас руу чирж байрлалыг тохируулна',
    drag_text_hint: 'Зөвлөмж: Текстийг канвас руу чирж байрлалыг тохируулна',
    edit_badge: 'Бэйж засварлах',
    create_new_badge: 'Шинэ бэйж үүсгэх',
    select_video_preview: 'Урьдчилсан үзэх видеог сонгоно уу',
    certificate_title_required: 'Гэрчилгээний гарчиг шаардлагатай',
    discard_changes: 'Өөрчлөлтийг устгах',
    edit_certificate: 'Гэрчилгээг засварлах',
    add_another_logo: 'Өөр лого нэмэх',
    optional: 'Сонголттой',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'Шинэ Ажил үүсгэх',
    quest_filter_title: 'Ажил',
    sharelook_assistance: 'Sharelook Сургалт',
    upload_scorm_zip: 'SCORM ZIP-г оруулах',
    only_letters_numbers_space_dot_allowed:
      'Зөвхөн үсэг, тоо, хоосон зай, цэг зөвшөөрөгдсөн!',
    video_playing: 'Тоглож байна',
    course_price_message: `*Энэ курс зөвхөн байгууллагын хэрэглэгчдэд нийтлэгдэж, зах зээл дээр дахин худалдах боломжгүй.`,
    lesson_must_be_positive: 'Хичээлийн тоо 1-ээс их байх ёстой',
    btn_proceed: 'Үргэлжлүүлэх',
    rule_select_music: 'Дууг сонгоно уу',
    course_info: 'Курсын мэдээлэл',
    content_selection: 'Агуулга сонгох',
    course_content_source: 'Курсын агуулгын эх сурвалж',
    choose_how_to_source: 'Энэ курсын агуулгыг хэрхэн авахыг сонгоно уу:',
    automatic_selection: 'Автомат сонголт',
    system_will_automatically_select_relavant_documents:
      'Систем таны сангаас холбогдох баримт бичгийг автоматаар сонгоно',
    manual_selection: 'Гарын авлагаар сонгох',
    choose_specific_documents_from_your_library:
      'Сангаас тодорхой баримт бичгийг сонгоно уу',
    upload_files: 'Файл оруулах',
    upload_new_documents:
      'Шинэ баримт бичиг оруулах (PDF, DOC, DOCX, PPT, PPTX, TXT) - Хамгийн ихдээ 5 файл',
    file: 'файл',
    ready_to_upload: 'Оруулахад бэлэн',
    clear_all: 'Бүгдийг цэвэрлэх',
    confirm_course_wide_premiew: 'Курсын урьдчилсан харааг баталгаажуулах',
    generate_course_preview: 'Курсын урьдчилсан хараа үүсгэх',
    instructions_across_the_course_to_generate:
      'Бид таны зааврыг бүх курс дээр ашиглан урьдчилсан хараа үүсгэнэ. Хадгалах эсвэл устгахын өмнө бүгдийг шалгана уу.',
    instruction_to_preview_course_wide:
      'Бүх курсийн урьдчилсан харааны заавар:',
    edit_content: 'Агуулга засах',
    manage_course_template: 'Курсын загварыг удирдах',
    undo: 'Буцаах',
    apply_changes: 'Өөрчлөлт хэрэглэх',
    characters: 'тэмдэгт',
    apply_all: 'Бүгдэд хэрэглэх',
    apply_to_all: 'Бүгдэд хэрэглэнэ',
    use_this_content: 'Энэ агуулгыг ашиглах',
    original: 'Анхны',
    edited: 'Засварласан',
    edited_content_preview: 'Засварласан агуулгын урьдчилсан хараа',
    apply_edits_to_all_topices: 'Бүх сэдэвт засварыг хэрэглэх үү?',
    current_editing_instructions_across_the_whole_course:
      'Энэ нь таны одоогийн засварын зааврыг бүх курсэд ашиглах болно. Хадгалахаас өмнө хосолсон урьдчилсан харааг шалгана уу.',
    edit_content_instructions: 'Агуулга засварлах заавар',
    generate_content_for_this_topic_instruction:
      'Энэ сэдвийн агуулгыг зааврын дагуу үүсгэх',
    descrip_edit_content:
      'Энэ агуулгыг хэрхэн засахыг тайлбарлана уу (жишээ: багасгах, энгийн болгох, дахин бичих)',
    try_short_clear_direcctives: `Товч, тодорхой зааврыг ашиглаарай. Жишээ: "Үндсэн санааг үлдээж 100 үг рүү багасгах", "Хэлийг энгийн болгох", "Нэмэлтийг устгаж товч болгох".`,
    we_preserve_the_core_meaning:
      'Бид таны зааврыг хэрэгжүүлж байхдаа үндсэн утгыг хадгална.',
    feedback_optional: 'Санал хүсэлт (Сонголттой)',
    write_your_feedback_here: 'Энд санал хүсэлтээ бичнэ үү',
    from_web: 'Вебээс',
    from_desktop: 'Десктопоос',
    pleae_wait_processing: 'Ажиллаж байна, түр хүлээнэ үү...',
    create_simulation_from_screen_capture: 'Дэлгэцийн агшнаас симуляци үүсгэх',
    sharelook_not_found: 'ShareLook олдсонгүй',
    sharelook_screen_capture_application_not_be_opened:
      'ShareLook дэлгэц агшны апп-г нээж чадсангүй. Компьютерт суулгагдаагүй байж болно.',
    download_sharelook: 'ShareLook татаж авах',
    launch_sharelook_application: 'ShareLook апп-г ажиллуулах',
    this_will_open_the_sharelook_application_for_screen_capture:
      'Энэ нь дэлгэц агшны ShareLook апп-г нээнэ.',
    sharelook_dosenot_open:
      'Хэрэв ShareLook нээгдэхгүй бол компьютер дээр суулгагдаагүй байж магадгүй.',
    open_sharelook: 'ShareLook нээх',
    download_app: 'Апп татаж авах',
    background_image_setting: 'Арын зураг тохиргоо',
    current_image: 'Одоогийн зураг',
    change_image: 'Зургаа солих',
    remove_image: 'Зургаа устгах',
    no_background_image_selected: 'Арын зураг сонгогдоогүй',
    add_image: 'Зураг нэмэх',
    this_will_open_for_screen_recording:
      'Энэ нь дэлгэц бичлэгийн ShareLook апп-г нээнэ.',
    ai_image_generation: 'AI зураг үүсгэх',
    image_edit: 'Зураг засах',
    text_to_image: 'Текстээс зураг',
    output_gallary: 'Гаралтын галерей',
    instant_generation: 'Түргэн үүсгэхэд бэлэн',
    prompt_and_unleash_the_power: 'Prompt оруулж AI хүчийг ашигла',
    use_this_image: 'Энэ зургийг ашиглах',
    error_generating: 'Үүсгэхэд алдаа гарлаа.',
    generation_tips: 'Үүсгэх зөвлөмж',
    detailed_descriptions_for_more_accurate_results:
      'Илүү нарийн үр дүнд хүрэхийн тулд дэлгэрэнгүй тайлбар ашигла',
    reference_image: 'Лавлагааны зураг',
    select_pixel_image: 'Пиксел зураг сонгох',
    max_mb: 'Хамгийн их 50MB',
    please_enter_text_to_appear_image: 'Зурганд гарч ирэх текстээ оруулна уу',
    enter_text_to_apear_in_the_image: 'Зурганд гарах текст оруулна уу',
    generate_image: 'Зураг үүсгэх',
    prompt_assistant: 'Prompt туслах',
    generate_image_using_suggested_prompt:
      'Санал болгосон Prompt ашиглан зураг үүсгэх',
    talk_to_ai_about_the_image_generate:
      'Үүсгэхийг хүссэн зургаа AI-тай ярилцах',
    ask_for_prompt_suggestions: 'Prompt санал хүсэх...',
    enter_a_search_term_to_find_stock_images:
      'Сток зураг хайхын тулд хайлтын үг оруулна уу',
    choose_your_content_source: 'Агуулгын эх сурвалжаа сонгоно уу:',
    upload_new_document_from_your_device:
      'Төхөөрөмжөөс шинэ баримт бичиг оруулах',
    automatic_library_selection: 'Автомат сан сонголт',
    system_automatically_selects_relevant_document:
      'Систем холбогдох баримт бичгийг автоматаар сонгоно',
    manual_library_selection: 'Гарын авлагаар сан сонгох',
    generate_content: 'Агуулга үүсгэх',
    add_to_current_page: 'Одоогийн хуудсанд нэмэх',
    generate_bullet_points: 'Давхар цэг үүсгэх',
    generating: 'Үүсгэж байна',
    this_may_take_a_few_moments: 'Энэ нь бага зэрэг хугацаа шаардаж магадгүй',
    apply_to_page: 'Хуудасанд хэрэглэх',
    scenario_escription: 'Сценарийн тайлбар:',
    feedback: 'Санал хүсэлт',
    form_mode: 'Формын горим',
    chat_mode: 'Чат горим',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'Энэ нь сонгосон түүхийг AI ашиглан үргэлжлүүлэх болно.',
    continue_this_story_question: 'Энэ түүхийг үргэлжлүүлэх үү?',
    continue_this_story: 'Энэ түүхийг үргэлжлүүлэх',
    what_will_happen: 'Юу болох вэ:',
    the_ai_will_analyze_the_existing_story_content:
      'AI нь одоо байгаа түүхийн агуулгыг дүн шинжилгээ хийх болно',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'Ижил өнгө, хэв маягийг дагаж байгалийн үргэлжлэл үүсгээрэй',
    create_new_content_that_build_upon_the_current_narrative:
      'Одоо байгаа өгүүлэмж дээр үндэслэн шинэ агуулга үүсгээрэй',
    this_process_may_take_a_few_moments_to_complete:
      'Энэ процесс дуусахад хэдэн секунд шаардагдаж болно.',
    no_existing_stories_found_for_this_course:
      'Энэхүү хичээлд ямар ч түүх олдсонгүй.',
    create_your_first_story: 'Эхний түүхээ үүсгээрэй',
    existing_stories: 'Байгаа түүхүүд',
    create_new_story: 'Шинэ түүх үүсгэх',
    tone: 'Өнгө',
    style: 'Хэв маяг',
    genre: 'Төрөл',
    loading_your_stories: 'Таний түүхийг ачааллаж байна...',
    edit_story: 'Түүх засах',
    story_preferences: 'Түүхийн тохиргоо',
    please_input_your: 'Таныг оруулна уу',
    add_character_names_and_press_enter:
      'Дүрийн нэрүүдийг нэмээд Enter дарна уу',
    select_or_type_your: 'Сонгох эсвэл бичих',
    enter_your: 'Оруулна уу',
    position_of_the_story_in_the_lesson:
      'Түүхийн байрлал нь хичээлд. Түүхийг заасан байрлалд блок болгон нэмнэ.',
    save_previous_content_on_the_pages: 'Өмнөх агуулгыг хуудсанд хадгалах',
    the_existing_content_in_the_selected_pages:
      'Сонгосон хуудсууд дахь одоогийн агуулга үүсгэсэн түүхээр солигдоно.',
    real_world_scenario: 'Бодит ертөнцийн нөхцөл байдал',
    add_optional_instructions:
      'Сонголттой заавар нэмэх (өнгө, урт, үзэгчид гэх мэт)',
    ready_to_enerate_your_real_world_scenario:
      'Бодит ертөнцийн нөхцөл байдлыг үүсгэхэд бэлэн',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      'Хичээлийн агуулгын дагуу бодитой нөхцөл байдал үүсгэхийн тулд "Бодит ертөнцийн нөхцөл байдлыг үүсгэх" дээр дарна уу.',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'AI нь таны хичээлийн сэдэв, агуулгыг дүн шинжилгээ хийнэ',
    generate_a_practical_real_world_scenario:
      'Бодит амьдралд хэрэгжих нөхцөл байдал үүсгэх',
    you_can_then_edit_and_customize_the_result:
      'Та үр дүнг дараа нь засаж, өөрийн болгож болно',

    add_it_as_a_new_page_to_your_lesson: 'Үүнийг хичээлд шинэ хуудсаар нэмэх',
    regenerate_with_instructions: 'Заавартайгаар дахин үүсгэх',
    add_real_world_scenario: 'Бодит нөхцөл байдал нэмэх',
    generate_real_world_scenario: 'Бодит нөхцөл байдлыг үүсгэх',
    simulation_has_been_stopped: 'Симуляци зогссон !',
    loading_simulation: 'Симуляцийг ачааллаж байна...',
    you_have_exhausted_all_the_attempts: 'Та бүх оролдлогоо дуусгалаа',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'Энэ хуудсан дахь нөхцөл байдлыг судалж, доорх сонголтоос зөв хариуг сонгоно уу.',
    attempts_limit_reached:
      'Оролдлогын хязгаар хүрсэн. Та дахин тоглох боломжтой боловч оноо хадгалагдахгүй.',
    play_again: 'Дахин тоглох',
    import_music_from_computer: 'Компьютераас хөгжим импортлох.',
    more: 'Илүү',
    no_badge_yet: 'Одоогоор тэмдэг байхгүй',
    competition_filter: 'Тэмцээний шүүлтүүр',
    global_leaderboard: 'Дэлхийн шаталсан жагсаалт',
    placeholder_for_the_global_leaderboard:
      'Энэ нь Дэлхийн шаталсан жагсаалтын байр эзэлнэ.',
    badge_editor: 'Тэмдгийн редактор',
    adjust_the_appearance_of_this_badge_icon:
      'Энэ тэмдгийн дүрсийг тохируулах. Өөрчлөлт нь зөвхөн энэ тэмдгийн хувьд хүчинтэй.',
    badge_style: 'Тэмдгийн хэв маяг',
    the_image_must_be_pixels: 'Зураг нь 200x200 пиксел байх ёстой.',
    badge_name: 'Тэмдгийн нэр',
    badge_descrription: 'Тэмдгийн тайлбар',
    enter_badge_criteria: 'Тэмдгийн шалгуурыг оруулна уу',
    discard: 'Цуцлах',
    badge_enable: 'Тэмдэг идэвхтэй',
    award_users_with_badges_to_highlight_the_milestones:
      'Суралцагчдад тэмдэг олгох замаар амжилтыг тодруулах.',
    badge_types: 'Тэмдгийн төрөл',
    enable_or_disable_specific_badge_types_for_your_users:
      'Таны хэрэглэгчдэд зориулсан тодорхой тэмдгийн төрлийг идэвхжүүлэх эсвэл идэвхгүй болгох.',
    levels_enabled: 'Үе шат идэвхтэй',
    level_rules: 'Үе шатны дүрэм',
    points: 'Оноо',
    add_new_level: 'Шинэ үе шат нэмэх',
    add_level: 'Үе шат нэмэх',
    points_enabled: 'Оноо идэвхтэй',
    learning_activities_and_encourage_healthy_competition:
      'Өөр өөр суралцах үйл ажиллагаанд хэрэглэгчдэд оноо олгож, эрүүл өрсөлдөөн дэмжих.',
    award_points: 'Оноо олгох',
    the_following_equates_the_value_of_one_item_completion:
      'Дараах нь нэг зүйлийн дуусгаврын утгатай тэнцэнэ',
    general: 'Ерөнхий',
    others: 'Бусад',
    certificate: 'Гэрчилгээ',
    quiz_passed: 'Шалгалт амжилттай',
    tip_approved: 'Зөвлөгөө батлагдсан',
    tip_liked: 'Зөвлөгөө таалагдсан',
    rewards: 'Шагнал',
    offer_discounts_when_learners_achieve:
      'Суралцагчид тодорхой оноо, тэмдэг эсвэл үе шатыг авсан үед хөнгөлөлт санал болгох.',
    give_rewards: 'Шагнал өгөх',
    discount_course_purchases_by:
      'Сургалтын худалдан авалтад хөнгөлөлт үзүүлэх',
    with_points_more_than: 'оноо илүүтэй',
    with_badges_more_than: 'тэмдэг илүүтэй',
    with_level_upwards_more_than: 'үе шат илүүтэй',
    leaderboard: 'Шаталсан жагсаалт',
    leaderboard_enabled: 'Шаталсан жагсаалт идэвхтэй',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'Шаталсан жагсаалт нь хэрэглэгчдэд бусадтай харьцуулан суралцах явцыг харах боломжийг олгоно.',
    show_levels: 'Үе шатуудыг харуулах',
    show_points: 'Оноог харуулах',
    show_badges: 'Тэмдгүүдийг харуулах',
    show_courses: 'Сургалтуудыг харуулах',
    show_certificates: 'Гэрчилгээг харуулах',
    leaderboard_settings: 'Шаталсан жагсаалтын тохиргоо',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'Суралцагчдын сэдэл сэргээх үүднээс сонирхолтой шаталсан жагсаалтын туршлагыг тохируулах.',
    award_users_with_points_for_different_learning_activities:
      'Өөр өөр суралцах үйл ажиллагаанд хэрэглэгчдэд оноо олгох.',
    badge_set: 'Тэмдгийн багц',
    choose_the_type_of_badges_your_users:
      'Хэрэглэгчид суралцах явцдаа ямар төрлийн тэмдэг авахыг сонгоно уу.',
    levels: 'Үе шат',
    Levels_represent_the_stages:
      'Үе шатууд нь хэрэглэгчийн суралцах аяллын шатлалын илэрхийлэл.',
    enabled: 'Идэвхтэй',
    disabled: 'Идэвхгүй',
    quick_select: 'Хурдан сонгох',
    yesterday: 'Өчигдөр',
    last_week: 'Өнгөрсөн долоо хоног',
    Last_month: 'Өнгөрсөн сар',
    last_quarter: 'Өнгөрсөн улирал',
    historical_leaderboard: 'Түүхэн шаталсан жагсаалт',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'Өөрийн гүйцэтгэлийг хянаж, хамт суралцагчдынхаа дунд өөрийн байрлалыг харах',
    time_period: 'Цагийн хугацаа',
    page_of: 'Хуудас 1-ээс 1',
    edit_competition: 'Тэмцээнийг засах',
    create_competition: 'Тэмцээн үүсгэх',
    arrow_right: 'баруун сум',
    update_competition: 'Тэмцээнийг шинэчлэх',
    competition_title: 'Тэмцээний гарчиг',
    enter_competition_title: 'Тэмцээний гарчгийг оруулна уу',
    enter_competition_description: 'Тэмцээний тайлбарыг оруулна уу',
    leaderboard_skill: 'Чадвар',
    select_a_skill: 'Чадвар сонгох',
    no_skills_found: 'Чадвар олдсонгүй',
    competition_period: 'Тэмцээний хугацаа',
    add_badge_rule: 'Тэмдгийн дүрэм нэмэх',
    create_badge: 'Тэмдэг үүсгэх',
    add_level_rule: 'Үе шатны дүрэм нэмэх',
    selected_participants: 'Сонгосон оролцогчид',
    no_participants: 'Оролцогчид байхгүй',
    start_end_date: 'Эхлэх–Төгсгөл огноо',
    created_date: 'Үүсгэсэн',
    new_competition: 'Шинэ тэмцээн',
    competitions_list: 'Тэмцээнүүдийн жагсаалт',
    search_competitions: 'Тэмцээнүүдийг хайх...',
    are_you_sure_you_want_to_delete_the_competition:
      'Та энэ тэмцээнийг устгахыг хүсч байна уу',
    history: 'Түүх',
    export: 'Экспорт',
    search_by_name: 'Нэрээр хайх...',
    no_historical_data_available_for_the_selected_period:
      'Сонгосон хугацаанд түүхэн өгөгдөл алга байна.',
    no_leaderboard_data_available: 'Шаталсан жагсаалтын өгөгдөл байхгүй.',
    competitions: 'Тэмцээнүүд',
    leaderboards: 'Шаталсан жагсаалтууд',
    welcome_back: 'Дахин тавтай морил',
    track_your_performance_and_see:
      'Өөрийн гүйцэтгэлийг хянаж, байрлалаа харах',
    team_leaderboard: 'Багийн шаталсан жагсаалт',
    try_again: 'Дахин оролдох',
    no_competitions_for_search: 'Хайлтад тэмцээн байхгүй',
    no_competitions_available: 'Одоогоор тэмцээн байхгүй',
    no_competitions_matching_search:
      'Хайлтад тохирох тэмцээн олдсонгүй. Хайлтын үгсээ өөрчлөх эсвэл шинэ тэмцээн гарахыг хүлээнэ үү.',
    no_competitions_general:
      'Одоогоор ямар ч тэмцээн үүсгээгүй байна. Дараа нь шалгана уу эсвэл администратортой холбогдон шинэ тэмцээн үүсгээрэй.',
    media_management: 'Медиа удирдлага',
    badgess_set: 'Тэмдгийн багц',
    choose_the_default_visual_style_for_badge:
      'Платформ даяар хэрэглэгдэх тэмдгийн дүрсний анхдагч хэв маягийг сонгоно уу.',
    enable_badges: 'Тэмдэг идэвхжүүлэх',
    add_badge: 'Тэмдэг нэмэх',
    min: 'Мин',
    max: 'Макс',
    your_rank: 'Таны байрлал',
    your_points: 'Таны оноо',
    your_level: 'Таны үе шат',
    rank: 'Байр #',
    level: 'Үе шат',
    progress: 'Ахиц',
    new_folder: 'Шинэ хавтас',
    file_upload: 'Файл оруулах',
    writer: 'Бичигч',
    text_documents: 'Текстийн баримт бичиг',
    spreadsheets: 'Хүснэгт',
    impress: 'Презентаци',
    presentations: 'Презентацууд',
    capture_desktop_screen: 'Десктоп дэлгэцийг барих',
    capture_desktop_screens: 'Десктоп дэлгэцүүдийг барих',
    your_documents: 'Таны баримт бичгүүд',
    manage_your_videos_images_audio_files:
      'Видео, зураг, аудио болон бусад контентын хөрөнгийг удирдах.',
    your_organization_documents: 'Таны байгууллагын баримт бичгүүд',
    keep_your_organization_creative_assets_organized:
      'Байгууллагын бүтээлч хөрөнгийг эмх цэгцтэй байлгаж, хамтран ажиллах боломжийг хялбар болгоно.',
    your_public_documents: 'Таны олон нийтэд зориулсан баримт бичгүүд',
    curated_collection_of_media_assets_available:
      'Бүгдэд зориулсан сонгосон медиа хөрөнгө—судлах, дахин ашиглах, бүтээх боломжтой.',
    your_download_center_documents: 'Таны татаж авах төвийн баримт бичгүүд',
    repository_of_approved_media_assets_for_download:
      'Татаж авах, төсөлд ашиглах зөвшөөрөгдсөн медиа хөрөнгийн сан.',
    search_files_and_folders: 'Файл, хавтас хайх...',
    home: 'Нүүр',
    folders: 'Хавтас',
    folder_name: 'Хавтсын нэр',
    owner: 'Эзэмшигч',
    last_updated: 'Сүүлд шинэчлэгдсэн',
    action: 'Үйлдэл',
    no_folders_found: 'Хавтас олдсонгүй',
    files: 'Файлууд',
    enabling_ai: 'AI идэвхжүүлж байна...',
    rename: 'Нэр өөрчлөх',
    copy: 'Хуулбарлах',
    move: 'Шилжүүлэх',
    verson_history: 'Хувилбарын түүх',
    manage_permission: 'Зөвшөөрлийг удирдах',
    generate_audit_report: 'Аудитын тайлан үүсгэх',
    last_edited: 'Сүүлд зассан',
    no_files_found: 'Файл олдсонгүй',
    are_you_sure_you_want_to_make_this_item_public:
      'Та энэ зүйлийг олон нийтэд нээхийг хүсч байна уу? Энэ таны олон нийтийн сан руу хуулна.',
    move_to_organization: 'Байгууллагад шилжүүлэх',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'Та энэ зүйлийг байгууллагын сан руу хуулж оруулахыг хүсч байна уу?',
    are_you_sure_you_want_to_make_this_item_private:
      'Та энэ зүйлийг хувийн болгохыг хүсч байна уу? Энэ таны хувийн сан руу хуулна.',
    date_modified: 'Өөрчилсөн огноо',
    workflow_management: 'Ажлын урсгалын удирдлага',
    configure_editors_approvers_and_viewers_for_this_document:
      'Энэхүү баримт бичгийн засварлагч, батлагч, үзэгчийг тохируулах.',
    error_Loading_editor: 'Редактор ачаалахад алдаа гарлаа',
    debug_info: 'Алдааг оношлох мэдээлэл',
    loading_editor: 'Редакторыг ачааллаж байна...',
    submitted_for_review: 'Шалгалтанд илгээсэн',
    editors: 'Засварлагчид',
    no_editors_added_yet:
      'Одоогоор засварлагч нэмэгдээгүй. "Засварлагч нэмэх" дарна уу.',
    add_editor: 'Засварлагч нэмэх',
    approvers: 'Батлагчид',
    no_approvers_added_yet:
      'Одоогоор батлагч нэмэгдээгүй. "Батлагч нэмэх" дарна уу.',
    add_approvers: 'Батлагч нэмэх',
    viewer: 'Үзэгч',
    no_viewers_added_yet: 'Одоогоор үзэгч нэмэгдээгүй. "Үзэгч нэмэх" дарна уу.',
    add_viewer: 'Үзэгч нэмэх',
    are_you_sure_you_want_to_delete_the_selected_items:
      'Та сонгосон зүйлийг устгахдаа итгэлтэй байна уу?'
  },
  v3: {
    reportShareSphere: 'ХУВААЛЦАХ ОРЧИН',
    overview: 'Ангиллын тойм',
    triviaReport: 'ShareSphere ангилал',
    overviewGraph: 'Ангиллын тоймын график',
    category: 'Ангилал',
    phCategory: 'Ангилал сонгох',
    podcast: 'Подкаст, хөгжим ба түүх',
    pastPodcast: 'Өмнөх подкаст',
    upcomingPodcast: 'Ирэх подкаст',
    podcastLanguageTitle: 'Подкаст, хөгжим, түүхийн хэл',
    podcastLanguageCheckbox: 'Миний подкастын хэлэнд AI ашиглах',
    howRate: 'Та энэхүү подкастыг хэрхэн үнэлдэг вэ?',
    podcastSubmit: 'Илгээх',
    podcastGuest: 'Зочин илтгэгч:',
    podcastReview: 'Санал сэтгэгдэл',
    podcastEpishode: 'Бүлэг',
    podcastEnd: 'Подкаст дууссан',
    date_podcast: 'Подкастын огноо',
    skill_not_found: 'Уучлаарай! Ур чадварын аялал олдсонгүй.',
    coaching: 'Сургалт',
    webinar: 'Вебинар',
    public_conference: 'Нээлттэй бага хурал',
    skill_journey_subtitle:
      'Ур чадварын аялалаа тохируулах, хэн үзэж, оролцохыг сонгоно уу.',
    enable_white_label: 'Цагаан шошгыг идэвхжүүлэх',
    create_new_event_org:
      'Танай байгууллагад зориулсан шинэ арга хэмжээ үүсгэх',
    create_new_event_marketplace: 'Зах зээлд зориулсан шинэ арга хэмжээ үүсгэх',
    create_new_event_both:
      'Танай байгууллага болон зах зээлд зориулсан шинэ арга хэмжээ үүсгэх',
    event_outline: 'Арга хэмжээний ерөнхий төлөвлөгөөг оруулна уу',
    event_obj: 'Арга хэмжээний зорилгыг оруулна уу',
    event_description: 'Арга хэмжээний тайлбарыг оруулна уу',
    create_new_metamaze_org:
      'Танай байгууллагад зориулсан шинэ MetaMaze үүсгэх',
    create_new_metamaze_marketplace: 'Зах зээлд зориулсан шинэ MetaMaze үүсгэх',
    create_new_metamaze_both:
      'Танай байгууллага болон зах зээлд зориулсан шинэ MetaMaze үүсгэх',
    add_key_words: 'Түлхүүр үг нэмэх',
    press_enter_make_keyword: 'Түлхүүр үг үүсгэхийн тулд Enter дарна уу',
    disable_skip_quiz: 'Шалгалтыг алгасахыг хаах',
    warning_complete_quiz: 'Үргэлжлүүлэхийн тулд шалгалтыг дуусгана уу.',
    signup_email_verification:
      'Бид баталгаажуулах холбоосыг таны өгсөн хаягаар илгээсэн. Бүртгэлээ баталгаажуулахын тулд холбоосыг нээнэ үү.',
    verifying_registration: 'Бүртгэлийг баталгаажуулж байна...',
    reset_password_linK:
      'Бид таны өгсөн хаягаар нууц үг сэргээх холбоос илгээсэн. Шинэ нууц үг тогтоохын тулд холбоосыг нээнэ үү.',
    reset_email_error:
      'Энэ имэйлээр хэрэглэгч олдсонгүй, дахин хэрэглэгчийн нэрээр оролдоно уу!',
    first_name: 'Нэр',
    last_name: 'Овог',
    error_firstName: 'Нэрээ оруулна уу',
    error_sharebot_organization: 'Байгууллагаа оруулна уу',
    error_lastName: 'Овогоо оруулна уу',
    private_conference: 'Хувийн бага хурал',
    public_conference: 'Нээлттэй бага хурал',
    discussion_room: 'Хэлэлцүүлгийн өрөө',
    training_no_courses: 'Та одоогоор ямар ч курс хийж байгаагүй.',
    training_no_events: 'Та одоогоор ямар ч арга хэмжээнд оролцож байгаагүй.',
    allow_sharing_trainer_info:
      'Зах зээл дээр и-мэйл хаягийг хуваалцахыг зөвшөөрөх',
    error_username_space: 'Хэрэглэгчийн нэрэнд хоосон зай байх ёсгүй.',
    error_sharebot_organization_space:
      'Байгууллагын нэрэнд хоосон зай байх ёсгүй.',
    edit_permission: 'Засварлах эрх',
    valid_price: 'Үнэ 0-с их байх ёстой',
    course_price_message: `*Курс нь зөвхөн байгууллага худалдаж авсан хэрэглэгчдэд зориулсан бөгөөд зах зээлд дахин зарагдахгүй`,
    valid_edit_price: 'Засварлах үнэ худалдаж авах үнээс бага байх ёстой.',
    my_calendar: 'Миний хуанли',
    error_valid_firstName: 'Хүчинтэй нэр оруулна уу.',
    error_valid_organization: 'Хүчинтэй байгууллагын нэр оруулна уу.',
    error_valid_lastName: 'Хүчинтэй овог оруулна уу.',
    error_name_spaces: 'Нэрэнд хоосон зай байх ёсгүй',
    items: 'Бараа',
    publish_to_channel: 'Миний сувгийн цуглуулгад нийтлэх',
    create_a_channel: 'Миний сувгийг үүсгэх',
    create_a_trivia: 'Trivia тоглоом үүсгэх',
    create_a_new_channel: 'Шинэ сувгийн үүсгэх',
    add_videos: 'Видео нэмэх',
    save_and_continue: 'Хадгалах ба үргэлжлүүлэх',
    channel: 'Сувгийн',
    channels: 'Сувгууд',
    view_channel: 'Сувгийг харах',
    edit_channel: 'Сувгийг засах',
    delete_channel: 'Сувгийг устгах',
    my_video_channels: 'Миний видео сувгууд',
    training_no_channel: 'Та одоогоор ямар ч сувганд оролцож байгаагүй.',
    monthly_price_required: 'Сарын үнэ шаардлагатай',
    yearly_price_required: 'Жилийн үнэ шаардлагатай',
    one_time_price_required: 'Нэг удаагийн үнэ шаардлагатай',
    marketplace_quantity: 'АНУ-ын доллар',
    report_webinar: 'Вебинар',
    report_coaching: 'Сургалт',
    report_channel: 'Сувгийн',
    report_public_conference: 'Нээлттэй бага хурал',
    report_maze: 'Тэнүүч',
    channel: 'Сувгийн',
    edit_price: 'Үнийг засах ($)',
    quantity: 'Тоо хэмжээ',
    payment_type: 'Төлбөрийн төрөл',
    total_amount: 'Нийт дүн ($)',
    net_amount: 'Цэвэр дүн ($)',
    edit_option: 'Сонголтыг засах',
    marketplace_price: 'Үнэ ($)',
    market_name: 'Нэр',
    duration_min: 'Үргэлжлэх хугацаа (минут)',
    users_total: 'Хэрэглэгчид (нийт)',
    sales_total: 'Нийт борлуулалт (АНУ-ын доллар)',
    search_coaching: 'Сургалтыг хайх',
    search_channel: 'Сувгийг хайх',
    search_webinar: 'Вебинарыг хайх',
    search_maze: 'Тэнүүчийг хайх',
    search_public_conference: 'Нээлттэй бага хурлыг хайх',
    buyer_type: 'Худалдан авагчийн төрөл',
    quanity: 'Тоо хэмжээ',
    channel_unit_amount: 'Цэвэр дүн ($)',
    channel_updated_at: 'Шинэчлэгдсэн огноо',
    month_price: 'Үнэ (сар)',
    year_price: 'Үнэ (жил)',
    one_time_price: 'Үнэ (нэг удаа)',
    sharebot_organization: 'Шинэ байгууллагын нэр нэмэх',
    share_sphere: 'Хуваалцах орчин',
    ai_course_title: 'Курсын нэр',
    ai_input_course_title: 'Курсын нэрээ оруулна уу!',
    learning_objective_label: 'Суралцах зорилго',
    learning_objective_message: 'Суралцах зорилгоо оруулна уу!',
    standard_question: 'Сурагч ямар нэг стандартыг мөрдөх шаардлагатай юу?',
    standard_details_label: 'Стандартийн дэлгэрэнгүй мэдээлэл',
    standard_details_message: 'Стандартийн дэлгэрэнгүй мэдээллийг оруулна уу!',
    estimated_duration_label: 'Курсын тооцоолсон хугацаа (минут)',
    estimated_duration_message: 'Тооцоолсон хугацаагаа оруулна уу!',
    min_duration_message: 'Хамгийн багадаа 5 минут байх шаардлагатай.',
    ai_mins: '25 мин',
    industry_specific_question: 'Энэ нь тодорхой салбартаа хамаарах уу?',
    industry_label: 'Салбарыг зааж өгнө үү',
    industry_message: 'Салбараа оруулна уу!',
    ai_course_creation: 'AI Курсын бүтэц',
    course_generated: 'Курс Sharelook–оор үүсгэсэн',
    ai: 'AI',
    ai_you: 'Та',
    ai_prompt_ready:
      'Таны хүсэлт бэлэн боллоо. Одоо агуулгын хуваарийг үүсгэх боломжтой.',
    ai_unable_respond:
      'Уучлаарай! AI таны хүсэлтийг гүйцэтгэж чадахгүй байна. Дахин оролдоно уу.',
    ai_hide_toc: 'Агуулгын хуваарийг нуух',
    ai_preview_toc: 'Агуулгын хуваарийг урьдчилан харах',
    ai_generate_toc_now: 'Одоо агуулгын хуваарийг үүсгэх',
    ai_creation_course_title: 'Курсын нэр:',
    ai_creation_industry_specific: 'Тодорхой салбартай юу?:',
    ai_creation_industry: 'Салбар:',
    ai_creation_standard_needed: 'Сурагч мөрдөх стандарт байгаа юу?:',
    ai_creation_standard_details: 'Стандартийн дэлгэрэнгүй мэдээлэл:',
    ai_creation_estimated_duration: 'Курсын тооцоолсон хугацаа (минут):',
    minutes: 'минут',
    ai_creation_learning_objective: 'Суралцах зорилго:',
    setup_again: 'Дахин тохируулах',
    ai_creation_confirm_title:
      'Та энэ формыг дахин тохируулахыг хүсч байна уу?',
    ai_creation_confirm_content:
      'Чат болон бүх үүсгэсэн агуулгыг дахин эхлэнэ.',
    ai_toc: 'Агуулгын хуваарь',
    ai_note_topic:
      'Анхааруулга: Та хичээлийн сэдвүүдийг өөрчилж, байрлалыг нь өөрчлөх боломжтой.',
    ai_add_topic: '+ Сэдэв нэмэх',
    add_topic: 'Сэдэв нэмэх',
    add_lesson: 'Хичээл нэмэх',
    add_new_lesson: 'Шинэ хичээл нэмэх',
    ai_add_lesson: '+ Хичээл нэмэх',
    attention: 'Анхаар!',
    before_varifying: 'Шалгахын өмнө',
    ai_save_later: 'Дараа нь хадгалах',
    ai_download_word_doc: 'Word баримт болгон татаж авах',
    ai_download_course_word_doc: 'Курсыг Word баримт болгон татаж авах',
    ai_create_course_button: 'Курс үүсгэх',
    ai_generate_course_content: 'Курсын агуулга үүсгэх',
    ai_out_of: 'нийт',
    ai_subtopic_failed_content:
      'зарим дэд сэдвийн агуулга үүсгэсэнгүй. "Курсын агуулга үүсгэх" дээр дахин дарж эдгээр хэсгийг үүсгэнэ үү.',
    ai_edit_topic: 'Сэдвийг засах',
    ai_edit_lesson_title: 'Хичээлийн гарчгийг засах',
    ai_save_topic: 'Сэдвийг хадгалах',
    ai_save: 'Хадгалах',
    ai_save_lesson_title: 'Хичээлийн гарчгийг хадгалах',
    ai_add_new_topic: 'Шинэ сэдэв нэмэх',
    ai_download_ref: 'Эшлэлтэй татаж авах',
    ai_download_ref_content: 'Эх баримт эсшилтэй Word баримт татагдана.',
    ai_download_without_ref: 'Эшлэлгүй татаж авах',
    ai_download_two_word: 'Хоёр төрлийн Word баримт татагдана:',
    ai_download_two_word_content_one: '- Эшлэлгүй үндсэн агуулга,',
    ai_download_two_word_content_two: '– Зөвхөн эшлэлийн жагсаалт, агуулггүй.',
    ai_manage_content: 'Агуулгыг удирдах',
    ai_add_content_from_internet: '+ Интернэтээс агуулга нэмэх',
    ai_confirm_start: 'Эхлэхийг баталгаажуулах',
    ai_Verify: 'Шалгах',
    ai_undo_warning:
      'Энэ үйлдэл богиногүй цаг хугацаа шаарддаг. Буюу энэ цонхыг хаахгүй байхыг анхаарна уу, буцаах боломжгүй.',
    ai_verified_content:
      'Та агуулгыг баталгаажуулсан. Баталгаажуулсаны дараа одоогийн агуулгатай AI тусламж хэрэглэх боломжгүй болно.',
    ai_want_proceed: 'Та үргэлжлүүлэх үү?',
    upload_simulation: 'Симуляцыг илгээх',
    name_simulation: 'Симуляцийн нэр',
    selected_simulation_files: 'Сонгогдсон симуляцийн файлууд',
    score_between_one_hundred: 'Таны оноо 1–100 хооронд байх ёстой.',
    are_sure_simulation: 'Та энэ симуляцийн файлыг устгах уу?',
    required_simulation: 'Оноо шаардлагатай',
    required_section_file: 'Хэсгийн файл шаардлагатай',
    simulation: 'Симуляци',
    simulation_quiz_games: 'Тоглоомд сорил нэмэх шаардлагатай',
    simulation_alert_des:
      'Бүх асуултын хариу төрлийг ганц болон олон сонгомол байхаас гадна тоглоом нэмнэ.',
    alert_info: 'Мэдээлэл',
    ai_number_quiz: 'Сорилын тоо',
    ai_point: 'Оноо',
    ai_points: 'Оноо',
    val_required: 'Шаардлагатай',
    games: 'Тоглоомууд',
    add_simulation: 'Симуляци нэмэх',
    text_tiewer: 'Текст хянагч',
    back_to_account: 'Данс руу буцах',
    delete_account: 'Данс устгах',
    delete_account_title: 'Данс устгах уу???',
    delete_account_subtitle: 'Та энд дансаа устгах боломжтой.',
    delete_account_cannot_undo:
      'Та дансаа устгах гэж байна. Энэ үйлдэл ашиглуулна.',
    account_org_profile:
      'Та үүсгэсэн бүх курс, байгууллагын мэдээлэл, тохиргоог алдана.',
    deleting_account_database:
      'Данс устгасан үед таны бүх мэдээлэл өгөгдлийн сангаас хасагдана.',
    account_confirm_delete: 'Та дансаа устгах уу?',
    action_cannot_be_undone: 'Энэ үйлдэл буцаалтгүй.',
    account_delete_message_success: 'Таны данс амжилттай устгагдлаа.',
    message_edit: 'Засах',
    message_delete: 'Устгах',
    message_reply: 'Хариулах',
    attached_file: 'Хавсарсан файл',
    attach_file: 'Файл хавсаргах',
    attach_des: 'Хамгийн их 25MB',
    view: 'Харах',
    go_to_marketplace: 'Зах зээл рүү явна',
    learning_center: 'Сургалтын төв',
    knowledge_center: 'Мэдлэгийн төв',
    sharebot: 'ShareBot',
    sharebot_help_message: 'Өнөөдөр танд юу туслах вэ?',
    my_organization: 'Миний байгууллага',
    world_knowledge: 'Дэлхийн мэдлэг',
    welcome_to_sharelook: 'Sharelook руу тавтай морилно уу!',
    sharelook_you_want_go: 'Өнөөдөр хаашаа явахыг хүсч байна вэ?',
    shareLook_learning_management_system:
      'ShareLook сургалтын удирдлагын систем рүү нэвтэрч, байгууллагадаа курс болон шууд үйл явдлыг үүсгэнэ үү.',
    shareLook_powerful_ai_system:
      'ShareLook-ын хүчирхэг AI системд нэвтрэн PDF файлыг эсшил авах боломжтой.',
    edit_now: 'Одоо засах',
    sharelook_log_out: 'Та гарлаа. Дахин нэвтэрнэ үү!',
    sorry_error: 'Уучлаарай! Алдаа гарлаа.',
    login: 'Нэвтрэх',
    refresh_page: 'Хуудас шинэчлэх',
    just_a_moment: 'Хүлээнэ үү...',
    enter_lname_fname: 'Үргэлжлүүлэхийн тулд нэр, овогоо оруулна уу.',
    procced_to_sharelook: 'Sharelook рүү шилжих',
    option_one: 'Сонголт 1',
    option_two: 'Сонголт 2',
    selected_image: 'Сонгогдсон зураг:',
    add_text: 'Текст нэмэх',
    linkdin_is_required: 'LinkedIn шаардлагатай.',
    bio_is_required: 'Товч танилцуулга шаардлагатай.',
    save_user_information: 'Хэрэглэгчийн мэдээллийг хадгалах',
    select_all: 'Бүгдийг сонгох',
    enable_ai: 'AI-ийг идэвхжүүлэх',
    load_more: 'Цааш унших',
    channel_id: 'Сувгийн ID.',
    send: 'Илгээх',
    v4: 'Мэдээлэл',
    subscription: 'Үндсэн захиалга',
    reset_user_flag: 'Хэрэглэгчийн төлвийг дахин тохируулах',
    delete_my_accont: 'Данс устгах',
    sharebot_sub_error: 'Захиалгыг шалгах үед алдаа гарлаа. Дахин оролдоно уу!',
    sharebot_no_sub: 'Та одоогоор ямар ч захиалгатай биш байна.',
    sharebot_dont_sub: 'Танд өмнөх ямар ч захиалга байхгүй.',
    sharebot_prev_sub: 'Өмнө нь захиалсан',
    sharebot_sub: 'ShareBot захиалга',
    sharebot_un_sub: 'ShareBot захиалгыг цуцлах',
    sharebot_no_available: 'Тодорхой мэдээлэл алга байна',
    sharebot_start_date: 'Эхлэх огноо:',
    sharebot_end_date: 'Дуусах огноо:',
    sharebot_sure: 'Та итгэлтэй байна уу?',
    sharebot_do_you_want: 'Та хүсэж байна уу',
    unsubscribe: 'Захиалгыг цуцлах',
    unsubscribe_what: 'Цуцлах уу?',
    subscribe: 'Захиалах',
    subscribe_what: 'Захиалах уу?',
    subscribe_now: 'Одоо захиалах',
    confirm: 'Баталгаажуулах',
    sharebot_intel_knowledge_center: 'ShareBot Оюуны Төв',
    sharebot_welcome_paragraph:
      'ShareBot-ийн Мэдлэгийн Төв рүү тавтай морилно уу — мэргэжилтнүүд мэдээлэл олж, хамтын ажиллагаа хийх аргыг хувьсгал хийх AI чатбот.',
    expired: 'Хүртээж дууссан',
    active: 'Идэвхтэй',
    Inactive: 'Идэвхгүй',
    yearly_subscription: 'Жилийн захиалга',
    monthly_subscription: 'Сарын захиалга',
    no_sharebot_org: 'Танд ShareBot байгууллага байхгүй байна',
    sharebot_start_free_trial: 'Чөлөөт туршилтыг эхлүүлэх',
    sub_month: 'Сарын захиалга',
    sub_year: 'Жилийн захиалга',
    question_per_month: '1 TB өгөгдөл хадгалах, сар бүр 1000 асуулт',
    sharebot_para:
      'Үргэлжлүүлэхэд байгууллагыг устгахыг баталгаажуулна. Энэ үйлдэл нь ShareBot-аас авах үнэ цэнтэй мэдээллийг алдахад хүргэх бөгөөд буцаах боломжгүй.',
    cancelled_date: 'Цуцлагдсан огноо:',
    live_straming_para:
      'Хэрэв та сарын шууд нэвтрүүлгийн хязгаарыг өөрчлэх хүсэлтэй бол холбогдоно уу',
    sharelook_agree: 'Би Sharelook-ийн',
    terms_condition: 'нь үүрэг, нөхцлийг',
    and: 'мөн',
    privacy_policy: 'Нууцлалын бодлого',
    save_for_later: 'Дараа нь хадгалах',
    ai: 'AI',
    no_video_yet: 'Одоогоор видео сонгогдоогүй!',
    are_you_sure_delete_video: 'Та энэ видеог устгах уу?',
    video_des: 'Тайлбар',
    video_now: 'Одоогоор',
    video_playing: 'Одоогоор тоглож байна:',
    video_no: 'Видео №',
    ai_generated_course: 'AI үүсгэсэн курс',
    create_course_on_our_own: 'Өөрсдөө курс үүсгэх',
    ai_Assisted_ourse_reation: 'AI тусламжтай курс үүсгэх',
    pending: 'Хүлээгдэж буй',
    published: 'Нийтлэгдсэн',
    intro_course: 'таны курс рүү?',
    clone_course: 'Та хуулбар үүсгэх үү',
    browser_audio_not_support: 'Таны хөтөч дурсны формат дэмжихгүй байна.',
    audio_popup_content:
      'Та бичсэн текстээ янз бүрийн дуу хоолойгоор тоглуулж болох бөгөөд Lorem Ipsum хэв маяг хэв маяг',
    close: 'Хаах',
    podcast_rec: 'Бичлэг',
    create_podcast: 'Подкаст үүсгэх',
    add_admin: 'Админ нэмэх',
    delete_all: 'Бүгдийг устгах',
    ai_podcast_audio: 'AI подкаст аудио',
    language: 'Хэл',
    podcast_download_content:
      '*AI-аар үүсгэсэн аудио файлыг татаж аван засварлана уу.',
    upload_audio: 'Аудио оруулах',
    browser_do_not_support_audio: 'Таны хөтөч аудио элемент дэмжихгүй.',
    upload_cover: 'Дизайн оруулах',
    upload_ai_creator: 'AI бүтээгч',
    required_cover_image: 'Дизайны зураг шаардлагатай!',
    room_required_name: 'Подкастын нэр шаардлагатай!',
    add_guest_list: 'Зочдын жагсаалтыг нэмнэ үү!',
    podcast_add_participants: 'Оролцогч нэмэх',
    topic_required: 'Нэг сэдэв шаардлагатай',
    podcast_description: 'Тайлбар',
    podcast_date: 'Огноо',
    date: 'Огноо',
    podcast_time: 'Цаг',
    podcast_to: '–',
    podcast_all_day: 'Бүх өдөр',
    podcast_start_date_time: 'Эхлэх огноо ба цаг шаардлагатай!',
    podcast_id: 'ID',
    selected_user: 'Сонгогдсон хэрэглэгчийг урих',
    see_more: 'Дэлгэрэнгүй',
    see_less: 'Багасгах',
    no_review_yet: 'Шүүмж байхгүй, анхны бичлэгээ хийнэ үү.',
    request_to_speak: 'Хэрэглэгчийн илтгэх хүсэлтийг зөвшөөрөх үү?',
    kick_user: 'Та энэ хэрэглэгчийг хасах уу?',
    accept_request: 'Хүсэлтийг хүлээн авах',
    kick: 'Хасах',
    started: 'Эхэлсэн',
    end: 'Дуусах',
    join_now: 'Одоо нэгдээрэй',
    podcast_end: 'Подкаст дууслаа',
    connecting: 'Холбогдож байна...',
    knowledge_center_know_today: 'Өнөөдөр юу мэдмээр байна?',
    knowledge_center_question: 'Эхлээд асуултаа бичнэ үү',
    knowledge_center_error: 'Уучлаарай! Алдаа гарлаа.',
    knowledge_center_tooltrip:
      'Танай байгууллагын нөөцөөс эх баримттай хариултыг богино хугацаанд олж, PDF-файлыг урьдчилан үзэж, татаж авах боломжтой.',
    open_file: 'Файлыг нээх',
    reference: 'Эшлэл',
    are_you_cancel: 'Та цуцлах уу?',
    are_you_remove_media: 'Та энэ медиаг устгах уу?',
    terms_agree: 'Би эдгээрийг зөвшөөрч байна',
    ready: 'Бэлэн',
    send_email: 'Имэйл илгээх',
    active_users: 'Идэвхтэй хэрэглэгчид',
    sign_up_user: 'Бүртгэлтэй хэрэглэгч',
    non_sign_up_user: 'Бүртгэлгүй хэрэглэгч',
    organisation: 'Байгууллага',
    usage_report: 'Хэрэглэх тайлан',
    check_email: 'Имэйлээ шалгана уу',
    delete_schedule: 'Хуваарийг устгах',
    are_you_sure_delete_schedule: 'Та энэ хуваарийг устгах уу?',
    add_task: 'Ажил үүрэг оруулна уу!',
    coaching_available: 'Сургалтын цаг боломжтой гэсэн тэмдэглэл',
    message_booking_coaching: 'Энэ цагийн хуваарь сургалтын бүртгэлтэй байна.',
    task_day: 'Ажлын өдөр',
    created_task_day: 'Та энэ өдөрт ажил үүрэг үүсгэлээ.',
    event_day: 'Үйл явдлын өдөр',
    has_booked_coaching: 'Тухайн өдөрт сургалтанд бүртгэгдсэн.',
    active_day: 'Идэвхтэй өдөр',
    selectable_time_slots:
      'Баруун талын цагийн сонголтууд тухайн өдөр хүчинтэй.',
    compare_last_month: 'Өмнөх сартай харьцуулахад',
    uploading_file: 'Файлаа илгээж байна',
    attach_file_course: 'Энэ курс рүү хавсаргав.',
    fetch_request: 'Таны хүсэлтийг авч байна',
    finilize_upload: 'Илгээхийг дуусгав',
    scorm_scanned: 'Жаахан хүлээнэ үү… SCORM zip файлыг танилцуулж байна.',
    scan_status: 'Сканийн төлөв:',
    scan_completed: 'Скан дууссан. Таны файл нь',
    scan_progress: 'Скан хийгдэж байна…',
    check_scorm: 'SCORM 1.2 стандарт хэмжээнүүдийг шалгах… ажиглана уу…',
    file_check_success: 'Файлын шалгалт амжилттай',
    file_check_progress: 'Файлын шалгалт хийгдэж байна…',
    scorm_not_upload:
      'Таны файл SCORM 1.2 стандартад нийцэхгүй байна, дахин илгээнэ үү.',
    select_question: 'Хариултын сонголт (зөв хариулт нэгийг сонгоно)',
    select_answer: 'Хариултын сонголтоо заана уу!',
    check_option_one: '1‑р сонголтыг оруулна уу!',
    check_option_two: '2‑р сонголтыг оруулна уу!',
    check_option_three: '3‑р сонголтыг оруулна уу!',
    check_option_four: '4‑р сонголтыг оруулна уу!',
    question_image: 'Асуултын зураг',
    select_question_image: 'Асуултын зургаа заана уу!',
    ans_image: 'Хариултын зураг',
    upload_image_question: 'Хариултын зургийг оруулах',
    select_image_answer: 'Хариултын-зургаа заана уу!',
    save_question: 'Асуултыг хадгалах',
    do_you_leave: 'Та явах гэж байна уу?',
    loose_all_progress: 'Та бүх ахиц дэвшлээ алдана.',
    welcome: 'Тавтай морилно уу',
    team_knowledge_quest: 'Багийн мэдлэгийн тэмцээн',
    your_score: 'Таны оноо',
    start_playing: 'Тоглоом эхлүүлэх',
    share_sphere_complete: 'ShareSphere дууслаа',
    final_score: 'Эцсийн оноо',
    play_next: 'Дараагийн тоглоом',
    you_donot_access_event: 'Та энэ үйл явдал рүү хандах эрхгүй.',
    ai_content_generated: 'Энэ сэдвийн агуулга үүсгэгдлээ.',
    ai_popup_confirm_content: 'Агуулга үүсгэхийг баталгаажуулах',
    limit_transcribe_text:
      'Хуулбарлах хугацаа үлдсэн: <0>{{ transcribe_limit }}</0> минут <1/><2/> <3>. Хуулбарлах хязгаарыг өөрчлөхийн тулд дараах хаягаар холбоо барина уу: </3> <4>admin@sharelook.com</4>.',
    monthly_ai_credit_limit: 'AI кредитийн хязгаарлалтыг өөрчлөхийн тулд холбоо барина уу',
    remaining_credits_text: 'Үлдсэн AI кредитүүд: <0>{{ remaining_credits }}</0> кредит <1/><2/> <3>. AI кредитийн хязгаарлалтыг өөрчлөхийн тулд холбоо барина уу </3> <4>admin@sharelook.com</4>.',
    you_donot_access_event: 'Та энэ үйл явдалд хандах эрхгүй байна.',
    ai_course_title_training: 'Манлайллын сургалтын курсууд',
    ai_course_object: 'Дижитал эринд манлайлах ур чадвар',
    create_ai_video: 'AI видео үүсгэх',
    generate: 'ҮҮСГЭХ',
    video_generate_process:
      'Видео үүсгэхэд тодорхой хугацаа шаардагдаж магадгүй. Дуусмагц танд и-мэйл илгээнэ.',
    stripe_account_connect:
      'Таны Stripe бүртгэл идэвхгүй байна. Үргэлжлүүлэхийн тулд холбох эсвэл идэвхжүүлнэ үү.',
    ai_creator: 'AI бүтээгч',
    check_video_status: 'Видео үүсгэх явцыг шалгаж байна...',
    video_on_queue: 'Видео үүсгэх дараалалд байна.',
    video_fail_generation:
      'Уучлаарай, видео үүсгэх явц амжилтгүй боллоо. Өөр видео оролдоно уу.',
    video_currently_generated: 'Энэ видео одоогоор үүсгэгдэж байна.',
    checking_status: 'Төлөв шалгаж байна',
    check_status: 'Төлөв шалгах',
    browser_does_not_support_audio: 'Таны хөтөч audio тагийг дэмжихгүй байна',
    existing_edit_scenario:
      'Та одоогийн хувилбарыг засах уу эсвэл шинэ хувилбар үүсгэх үү? Хэрвээ та шинэ хувилбар үүсгэвэл хуучин хувилбар устах болно.',
    generate_scenario: 'Хувилбар үүсгэх',
    layout: 'Тохиргоо',
    confirm_change: 'Өөрчлөлтийг баталгаажуулах',
    generated_ai_creation_message:
      'Зөвхөн AI-аар үүсгэсэн текстийн элементүүд хадгалагдана. Бусад бүх элементүүд хуудсанд хадгалагдахгүй.',
    generate_story: 'Түүх үүсгэх',
    save_original_content: 'Эх контентыг хадгалах:',
    story_added_specified_position:
      'Хичээлийн аль хэсэгт түүх нэмэхийг заана. Түүхийг заасан байрлалд блок хэлбэрээр нэмнэ.',
    position_of_story: 'Түүхийн байрлал',
    start_the_lesson: 'Хичээл эхлэх',
    end_the_lesson: 'Хичээл дуусах',
    add_story_pages: 'Хуудас руу түүх нэмэх',
    browser_does_not_support: 'Таны хөтөч аудио элементийг дэмжихгүй байна.',
    no_video_available: 'Видео байхгүй байна.',
    no_podcast_available: 'Подкаст байхгүй байна.',
    no_item_baskets: 'Сагсанд ямар ч зүйл алга.',
    ai_course_object: 'Дижитал эринд манлайлах ур чадвар'
  },
  v2: {
    n_data: 'Өгөгдөл байхгүй',
    change: 'Өөрчлөх',
    remove: 'Арилгах',
    auto_background: 'Автомат арын дэвсгэр',
    create_new_course_org: 'Байгууллагадаа шинэ курс үүсгэх.',
    create_new_course_marketplace: 'Зах зээлд зориулан шинэ курс үүсгэх.',
    create_new_course_both:
      'Байгууллага болон зах зээлд зориулсан шинэ курс үүсгэх.',
    ok: 'За ',
    page_bg: 'Хуудасны арын дэвсгэр',
    lesson_cover: 'Хичээлийн нүүр зураг',
    create_skill_journey: 'Ур чадварын аялал үүсгэх',
    scroms: 'Скормууд',
    min_score_pass: 'Хамгийн бага босго оноо',
    no_scorms_available: 'Скорм байхгүй байна.',
    no_events_available: 'Эвент байхгүй байна.',
    no_courses_available: 'Курс байхгүй байна.',
    no_courses_baskets: 'Сагсанд курс байхгүй.',
    no_mazes_baskets: 'Сагсанд мэйз байхгүй.',
    no_scroms_baskets: 'Сагсанд скорм байхгүй.',
    no_events_baskets: 'Сагсанд эвент байхгүй.',
    sorry: ' Уучлаарай!',
    option_1: 'Сонголт 1',
    option_2: 'Сонголт 2',
    enter_number_words: ' Үгийн тоо оруулах',
    summarize: 'Хураангуйлах',
    answer: 'Хариулах',
    hold_tight_one_minute:
      'Түр хүлээгээрэй, бид бэлтгэж байна. Нэг минут болно.',
    enter_question: 'Асуултаа оруулна уу',
    enter_relevant_documents: 'Холбогдох баримт бичгийн тоог оруулна уу',
    please_input_relevant_documents: 'Холбогдох баримт бичгийг оруулна уу!',
    please_wait_loading_results: 'Илэрцийг ачаалах хүртэл хүлээнэ үү...',
    proceed_to_add_voice: 'Дуу нэмэхээр үргэлжлүүлэх',
    results: 'Илэрц',
    no_result_found_try_asking_questions:
      'Илэрц олдсонгүй. Нэмж асуулт асууж үзнэ үү',
    eg: 'жишээ',
    what_make_sales_manager: 'Худалдааны менежер болоход юу шаардлагатай вэ',
    please_select_lang: ' Хүссэн хэлээ сонгоно уу!',
    search: 'Хайх',
    please_copy_desired_content:
      'Хүссэн контентоо зүүн гар талын савнаас баруун гар талын сав руу хуулна уу',
    rating_req: 'Заавал үнэлгээ өгөх шаардлагатай.',
    review_req: ' Заавал сэтгэгдлээ өгөх шаардлагатай.',
    rating_review_req: 'Заавал үнэлгээ, сэтгэгдлээ өгөх ёстой.',
    how_rate_this: 'Үүнийг та хэрхэн үнэлэх вэ',
    amazing_above_expectations: 'Гайхалтай, төсөөллөөс илүү!',
    certificates: 'Сертификатууд ',
    you_no_certificates: 'Танд одоогоор сертификат байхгүй байна.',
    please_add_review: 'Үнэлгээ өгөхдөө сэтгэгдлээ бичнэ үү. Баярлалаа.',
    post: 'Нийтлэх',
    rate: 'Үнэлэх',
    avg_rating: 'Дундаж үнэлгээ',
    no_review_found: 'Сэтгэгдэл олдсонгүй',
    are_sure_to_disale_zoom_integration:
      'Та Zoom холболтыг салгахдаа итгэлтэй байна уу?',
    badges: 'Тэмдгүүд',
    you_no_badge_available: 'Танд одоогоор тэмдэг байхгүй байна.',
    download_certificate: 'Сертификат татах',
    loading: 'Ачаалж байна...',
    no_file_attached: 'Хавсаргасан файл байхгүй',
    you_do_not_have_any_notes: 'Танд тэмдэглэл байхгүй.',
    question: 'Асуулт',
    score: 'Оноо',
    alert_score_message: 'хүн оноогоо илгээсэн байна.',
    alert_question_message: 'Шинээр асуулт нэмэгдээгүй байна.',
    button_submit: 'Илгээх',
    button_allScores: 'Бүх оноог илгээсэн.',
    record_wait: 'Бичлэг хийгдэж байна. Түр хүлээнэ үү...',
    buttonSubmit_warning: 'Илгээхийн өмнө бүх оноог оруулна уу',

    // List.jsx @Added:Mahesh
    upload_ar_assets: 'AR ассет байршуулах',
    edit_ar_assets: 'AR ассет засварлах',
    upload_assets: 'Ассет байршуулах',

    // ARUploads.jsx @Added:Mahesh
    trigger_title: 'Гарчиг эхлүүлэх',
    trigger_description: 'Эхлүүлэх тайлбар',
    please_type_target_description: 'Бай тайлбараа бичнэ үү',
    trigger_image: 'Эхлүүлэх зураг*',
    upload_trigger_image: 'Эхлүүлэх зургаа оруулна уу',
    drag_n_drop: 'Чирч ирээд оруулах',
    file_size_should_not_exceed: '(Файлын хэмжээ 2 MB-ээс хэтэрч болохгүй)',
    ar_content: 'AR контент *',
    upload_3d_zip: '3D Zip байршуулах',
    content_attached: 'Контент хавсаргасан.',
    enter_trigger_image_title: 'Эхлүүлэх зургийн гарчиг оруулна',
    ar_preview_image: 'AR урьдчилан харах зураг',
    upload_preview_image: 'Урьдчилан харах зураг байршуулах',
    creating___: 'Үүсгэж байна...',
    updating___: 'Шинэчилж байна...',
    create: 'Үүсгэж байна',
    update: 'Шинэчлэх',
    ar_assets: 'AR зураг',
    _3d_files_mp4: '(Нягтруулсан .OBJ, .FBX)',
    persons_have_submitted_their_scores: 'хүн оноогоо илгээсэн байна.',
    no_questions_added_till_now: 'Одоог хүртэл асуулт нэмэгдээгүй байна ',
    submit: 'Илгээх',
    all_scores_submitted: 'Бүх оноог илгээсэн.',
    recording_is_starting: 'Бичлэг хийгдэж байна. Түр хүлээнэ үү...',
    please_input_scores_before_submitting:
      'Илгээхийн өмнө бүх оноог оруулна уу',
    //EventMenus.jsx
    end_for_all: 'Бүгдийг дуусгах',
    full_screen: 'Бүтэц дэлгэц',
    breakout_room: 'Завсарлагын өрөө',
    //ChimeConference.jsx
    send_invitations: 'Илгээсэн урилга(ууд)',
    add_participants: 'Оролцогч(ид) нэмэх',
    create_breakout_room: 'Завсарлагын өрөө үүсгэх',
    //AntMediServeice.jsx
    connecting: 'Холбож байна...',
    //AntPlayer.jsx
    currently_broadcaster_unavailable: 'Өргөн дамжуулагч одоогоор байхгүй.',
    //BreakoutForm.jsx
    how_many_breakout_room_to_create: 'Хэдэн завсарлагын өрөө үүсгэх вэ?',
    create_upto_three_breakout_rooms: '*3 хүртэлх завсарлагын өрөө үүсгэх',
    //PassiveUsers/index.js
    allow: 'Зөвшөөрөх',
    //PreviewHeader.jsx
    additional: 'Нэмэлт',
    attachment: 'Хавсралт',
    //EventOverview.jsx
    no_description_available: 'Тайлбар байхгүй.',
    //EventParticipants.jsx
    people: 'ХҮМҮҮС',
    waiting: 'Хүлээж байна',
    hand_raising_users: 'Гараа өргөсөн хэрэглэгчид -',
    invite: 'урих',
    //EventRooms.jsx
    create_room: 'Өрөө үүсгэх',
    //Header.jsx
    create_live_event: 'Шууд эвент үүсгэх',
    //Detail.jsx
    support_upto_fivethousand_participants:
      'Энэхүү эвентэд 5000 хүртэлх оролцогч хамрагдах боломжтой event',
    support_upto_ten_participants:
      '10 хүртэлх видео оролцогч хамрагдах боломжтой',
    support_upto_twohundred_participants:
      'Энэхүү эвентэд 200 хүртэлх оролцогч хамрагдах боломжтой',
    supprt_upto_five_participants:
      '5 хүртэлх видео оролцогч хамрагдах боломжтой',
    support_upto_twentyfive_participants:
      'Энэхүү эвентэд 25 хүртэлх хүн шууд видеогоор орж болно.',
    two_live_video_participants:
      'Энэхүү эвентэд 2 хүн шууд видеогоор орж болно (зохион байгуулагч болон оролцогч)',
    you_can_have_upto_five_examinees: 'Зөвхөн 5 хүртэлх шалгагч байх боломжтой',
    you_can_have_upto_twentyfive_participants:
      'Та 25 хүртэлх оролцогч хамруулах боломжтой',
    you_can_have_upto_five_participants:
      'Та 5 хүртэлх оролцогч хамруулах боломжтой',
    you_can_have_upto_ten_participants:
      'Та 10 хүртэлх оролцогч хамруулах боломжтой',
    select_hosts_email: 'Зохион байгуулагчийн имэйлийг сонгоно уу',
    //Setting.jsx
    send_invite_email: 'Урих имэйл илгээх',
    do_not_send_invite_email: 'Урих имэйл бүү илгээ',
    error: 'Алдаа',
    //ShowContactsModal.jsx
    max_twentyfive_users_allowed: 'Хамгийн ихдээ 25 хүн сонгох боломжтой',
    max_five_users_allowed: 'Хамгийн ихдээ 5 хүн сонгох боломжтой',
    max_ten_users_allowed: 'Хамгийн ихдээ 10 хүн сонгох боломжтой',
    no_user_found: 'Хэрэглэгч олдсонгүй',
    //SwitchSettings.jsx
    transcribe_to: 'Хөрвүүлэх',
    //ZoomForm.js
    integrate_zoom_to_start_meeting:
      'Zoom уулзалт эхлүүлэх бол zoom-тэй холбоно уу.',
    zoom_is_not_integrated: 'Zoom холбогдоогүй байна',
    // Poll.jsx
    delete_poll: 'Санал хураалтыг устгах',
    add_poll: 'Санал хураалт нэмэх',
    /* @Added By: Prabin */
    //Events
    live_now: 'ШУУД ДАМЖУУЛЖ БАЙНА !!!',
    average_rating: 'Дундаж үнэлгээ',
    review: 'Хяналт',

    // Reports/Course/Details/Details.jsx
    time_spent: 'Зарцуулсан цаг',
    total: 'Нийт',
    /* @Added By: Furkan */
    // Reports/Events/Preview/Preview.jsx
    mins: 'Минут',
    /* @Added By: Furkan */
    // Reports/Lesson/Details/Internal/Quiz/Quiz.jsx
    no_data: 'Тааврын дата байхгүй байна',
    total_score: 'Нийт оноо',
    pass_score: 'Босго оноо',
    point: 'Оноо',
    /* @Added By: Furkan */
    // Reports/Lesson/Details/Internal/Quiz/QuizByUser/QuizByUser.jsx
    wrong: 'Буруу',
    response: 'Хариу',
    submitted: 'Илгээсэн',
    /* @Added By: Furkan */
    // Reports/LiveAssessments/Preview/Preview.jsx
    average: 'Дундаж',
    /* @Added By: Furkan */
    // Reports/Maze/Preview/Preview.jsx
    total_play: 'Нийт тоглолт',
    view_graph: 'График харах',
    time_spent_mins: 'Зарцуулсан хугацаа (минут)',
    play: 'Тоглох',
    ideal_path: 'Тохиромжтой зам',
    user_incorrect_path: 'Хэрэглэгч буруу зам',
    ideal_path_taken: 'Хэрэглэгч тохиромжтой зам сонгосон',
    scenario: 'Сценари',
    option: 'Сонголт',
    spend: 'Зарцуулах',
    /* @Added By: Furkan */
    // Reports/Report/Report.jsx
    average_spending_time: 'Дундаж зарцуулах хугацаа',
    activity_overview: 'Үйл ажиллагааны тойм',
    /* @Added By: Furkan */
    // Reports/Report/Report_.jsx
    live_event: 'Шууд эвент ',
    live_assessment: 'Шууд үнэлгээ',
    report_download: 'Тайлан татах',
    all_workshops: 'Бүх дасгал ажил',
    /* @Added By: Furkan */
    // Reports/User/Detail/Detail.jsx
    overview_average_activity: 'Үйл ажиллагааны ерөнхий дундаж',
    overview_workshop_graph: 'Дасгал ажлын графикийн тойм ',
    mazes: 'Мэйзүүд ',
    correct_feedback: 'Зөв санал сэтгэгдэл',
    incorrect_feedback: 'Буруу санал сэтгэгдэл',
    checkin_checkout: 'Бүртгүүлж орох – Бүртгүүлж гарах',
    minutes: 'минут',
    incorrect_path: 'Буруу зам',
    answer_not_available: 'Хариулт байхгүй байна',
    views: 'үзсэн тоо',
    item: 'зүйл',
    questions: 'Асуултууд',
    total_points: 'Нийт оноо',
    total_attempts: 'Нийт оролдлого',
    /* @Added By: Furkan */
    // Reports/User/Detail/Detail.jsx
    created_date: 'Үүсгэсэн огноо',
    host_name: 'Зохион байгуулагчийн нэр',
    host_section: 'Зохион байгуулагчийн хэсэг',
    /* @Added By: Furkan */
    // views/SkillJourney/SkillJourney.jsx
    choose_products: 'Бүтээгдэхүүн сонгох',
    add_to_basket: 'Сагсанд нэмэх',
    basket: 'Сагс',
    times: 'удаа',
    events: 'Эвентүүд',
    scorms: 'Скормууд',
    /* @Added By: Furkan */
    // views/SkillJourney/View/View.jsx
    skill_journey_overview: 'Skill Journey overview',
    /* @Added By: Furkan */
    // components/Header/internal/Informations/Informations.jsx
    how_to_use: 'Хэрхэн ашиглах вэ',
    live_broadcast_description:
      'БИД ХЯЛБАР АШИГЛАХ БОЛОМЖТОЙ ХИЧЭЭЛ БЭЛТГЭГЧИД ШУУД ВИДЕО ДАМЖУУЛАЛТЫГ ХОЛБОСОН',
    live_broadcast_subdescription:
      'ShareLook-ын патенттай шууд дамжуулах системийн тусламжтай та сургалтыг автоматжуулж, олныг хамруулж, мэдлэг түгээх явцыг улам боловсронгуй болгож болно.',

    // views/SkillJourney/PublishSkillJourney/PublishSkillJourney.jsx
    disclaimer: `Миний ур чадварын аялал дараахь зүйлийг хийхгүй гэдгийг би баталж байна.: 
  - аливаа гуравдагч этгээдийн эрхийг зөрчих
  - гүтгэлэг, садар самуун, ёс суртахуунгүй, садар самуун, садар самуун, хүчирхийлэлтэй, доромжилсон, доромжилсон, заналхийлсэн, ялгаварлан гадуурхсан агуулгатай, бүр одоор далдалсан аливаа хууль бус зүйлийг агуулсан байх.
  - бусад хүмүүст хувийн халдлагыг агуулсан
  - бусад оролцогчид, олон нийтийн зүтгэлтнүүд эсвэл олны танил хүмүүсийн дүр төрхийг агуулсан
  - Тухайн хүний зөвшөөрөлгүйгээр аливаа хувь хүний талаарх аливаа бичлэг, хувийн мэдээллийг агуулсан байх ба дэлхийн аль ч хэсэгт мэдээлэл хамгаалах журмыг зөрчөөгүй болно.
  - аливаа арилжааны уриалга эсвэл аливаа хэлбэрийг агуулсан “спам”'`,
    price: 'Үнэ',
    video_link: 'Видео холбоос',
    category: 'Ангилал',
    objectives: 'Зорилтууд',
    marketplace_description: 'Зах зээлийн тодорхойлолт',

    live_discussion: 'ШУУД ХЭЛЭЛЦҮҮЛЭГ',
    poll: 'САНАЛ АСУУЛГА',
    hide_grid: 'Сүлжээг нуух',
    show_grid: 'Торыг харуулах',
    stop_screen_share: 'Дэлгэц хуваалцахыг зогсоох',
    screen_share: 'Дэлгэц хуваалцах',
    mute: 'Дууг хаах',
    unmute: 'Дэлгэц хуваалцах',
    raise_hand: 'Гараа өргө',
    waiting__: 'Хүлээж байна...',
    audio_active: 'Аудио идэвхтэй'
  },
  general: {
    save: 'хадгалах',
    autosaved: 'Автоматаар хадгалсан',
    back_to: 'Буцах',
    by: 'Хийсэн хүн',
    chat: 'Чат',
    is_record: 'Бичлэг хийх ', // to translate
    completed: 'Гүйцээсэн',
    canceled: 'Цуцалсан',
    component: 'Бүрэлдэхүүн',
    confirm: 'Баталгаажуулах',
    course: 'Курс',
    skill: 'Чадварын Аялал',
    maze: 'Мета Лабиринт',
    channel: 'Сувгийн',
    podcast: 'Подкаст',

    date: 'Огноо',
    details: 'Деталь',
    empty: 'Дата байхгүй',
    enrolled: 'Элссэн',
    free: 'Үнэгүй',
    graph: 'График',
    loading: 'Ачаалж байна...',
    lesson: 'хичээл',
    lessons: 'хичээлүүд',
    live_assessment: 'Шууд үнэлгээ',
    live_event: 'Шууд эвент',
    maze: 'Мэйз', // to translate ,
    skill: 'Ур чадварын аялал', // to translate
    no: 'Үгүй',
    of: '-ын',
    or: 'Эсвэл',
    order: 'дараалал', // to translate
    organization: 'Байгууллага',
    page: 'Хуудас',
    pages: 'Хуудаснууд',
    personal: 'Хувийн',
    poll: 'Санал хураалт',
    rating: 'Үнэлгээ',
    reset: 'Тохиргоо хийх',
    signin: 'Нэвтрэх',
    signup: 'Бүртгүүлэх',
    soon: 'Удахгүй',
    type: 'Төрөл',
    uploading: 'Байршуулж байна...',
    yes: 'Тийм',
    something_went_wrong: 'Алдаа гарлаа!',
    view_all: 'Бүгдийг харах',
    upload_successful: 'Амжилттай байршлаа',
    upload_successful_message:
      'Таны excel баримт бичиг амжилттай байршиж, одоогоор ачаалж байна. Түр хүлээн үү.',
    check_email_upload_successful:
      'Хэрэглэгчийн жагсаалтыг <1>харах</1> бол <0>имэйл хаягаа шалгана уу</0>.',
    is_private: 'Хувийн',
    to_attach: 'Файл хавсаргах', // to translate
    file_attached: 'Файл хавсаргасан' // to translate
  },

  account: {
    title: 'Бүртгэл',
    subtitle: 'Тохиргоо, бүртгэлийн мэдээллээ удирдах.',
    saved: 'Бүртгэлийг амжилттай өөрчиллөө'
  },

  assessments: {
    title: 'Үнэлгээнүүд',
    subtitle: 'Үнэлгээ үүсгэх',
    finished: 'Үнэлгээ дууслаа ',
    countdown: 'Шууд үнэлгээг дамжуулах хугацаа',
    create: 'Үнэлгээ үүсгэх',
    list_title: 'Таны үнэлгээнүүд',
    delete_warning: 'Та үүнийг устгахдаа итгэлтэй байна уу?',
    details_title: 'Үнэлгээний дэлгэрэнгүй нэмэх',
    details_subtitle:
      'Үнэлгээнд нэр өгч, ямар зорилготой болохыг хүмүүст хэлнэ үү.',
    disclaimer: `Миний үнэлгээ дараах зүйлсийг зөрчөөгүй гэдгийг баталж байна:
    - аливаа гуравдагч талын эрхийг зөрчөөгүй
    - бусдын нэр төрд халдсан, эрээ цээргүй авирласан, ёс журамгүй, садар самуун, порно гэрэл зураг, хүчирхийлэл, хэрцгий үйлдэл, доромжлол, заналхийлэл эсвэл ялгаварлан гадуурхсан контент агуулаагүй, од тэмдэглэгээгээр нууж оруулаагүй
    - бусдад хувийн ашиг сонирхлын үүднээс халдаагүй
    - бусад оролцогчид, олны танил хүн эсвэл од хүний дүр эсгээгүй
    - аливаа хувь хүний зөвшөөрөлгүйгээр хувь хүний мэдээлэл, бичлэгийг агуулаагүй ба дэлхийн аль ч улсын дата хамгаалах хуулийг зөрчөөгүй
    - ашгийн сонирхолтой ямар нэг “ухуулга” агуулаагүй`, // added_first
    assessment_details: 'Үнэлгээний дэлгэрэнгүй', // to translate
    assessment_settings: 'Үнэлгээний тохиргоо' // to translate
  },

  buildersettings: {
    title: 'Нийтлэх тохиргоо',
    subtitle:
      'Эвентийн тохиргоо нэмэх, хэн таны эвентийг харах, үйлдэл хийх боломжтойг тохируулах event'
  },

  buttons: {
    market_place: 'Зах зээл',
    back_to_normal: 'Энгийн рүү буцах',
    add: 'Нэмэх',
    add_page: 'Хуудас нэмэх',
    add_lesson: 'Хичээл нэмэх',
    add_answer: 'Шинэ хариулт нэмэх',
    add_group: 'Групп нэмэх',
    add_organization: 'Байгууллага нэмэх',
    add_question: 'Асуулт нэмэх',
    add_quiz: 'Таавар нэмэх',
    add_users: 'Хэрэглэгч нэмэх',
    back: 'Буцах',
    back_to_maze: 'Мэйз сценари руу буцах', // to translate
    back_to_course: 'Курсийн тойм руу буцах',
    back_to_lesson: 'Хичээлийн тойм руу буцах',
    back_to_media: 'Медиа сан руу буцах',
    back_to_details: 'Деталь руу буцах',
    cancel: 'Цуцлах',
    clear: 'Арилгах',
    close: 'Хаах',
    clone: 'Клон хийх',
    close_lesson: 'Хичээлийг хаах',
    clone_course: 'Курсийг клон хийх',
    confirm: 'Баталгаажуулах',
    create: 'Үүсгэх',
    download: 'Татах',
    download_mass_user_tamplate: 'Загварыг татаж авах',
    add_mass_users: 'Масс хэрэглэгчид нэмэх',
    upload_excel_list: 'Excel жагсаалт байршуулах',
    delete: 'Медиа устгах',
    edit: 'Засварлах',
    edit_course: 'Курс засварлах',
    edit_maze: 'Мэйз засварлах', // to translate
    enroll: 'Элсэх',
    finish: 'Дуусгах',
    wait: 'Хүлээх...', // to translate
    retry: 'Дахин оролдох', // to translate
    upload_image: 'Зураг оруулах',
    upload_image_video: 'Зураг эсвэл видео оруулах',
    select_media_library: 'Медиа сан сонгох',
    make_public: 'Нийтэд нээлттэй болгох',
    make_private: 'Хувийн болгох',
    make_org: 'Байгууллага үүсгэх',
    media: 'Медиа сан',
    my_theme: 'Миний загвар',
    next: 'Дараагийн',
    next_lesson: 'Дараагийн хичээл',
    next_step: 'Дараагийн алхам',
    previous_step: 'Өмнөх алхам',
    publish: 'Нийтлэх',
    publish_assessment: 'Үнэлгээгээ нийтлэх',
    publish_course: 'Оноогоо нийтлэх',
    publish_scorm_course: 'СКОРМ курсээ нийтлэх', // to translate
    publish_event: 'Эвентээ нийтлэх',
    publish_maze: 'Мэйз нийтлэх', // to translate
    reset: 'Дахин тохируулах',
    reset_elements: 'Дахин тохируулах элементүүд',
    save: 'Хадгалах',
    creating: 'Үүсгэж байна...',
    updating: 'Шинэчилж байна...',
    saved: 'Хадгалсан',
    save_for_later: 'Дараа үзэхээр хадгалах',
    save_settings: 'Тохиргоог хадгалах',
    select_files: 'Файл сонгох',
    select_theme: 'Загвар сонгох',
    start_lesson: 'Хичээл эхлүүлэх',
    update: 'Шинэчлэх',
    import: 'Элементүүдийг импорт хийх', // to translate
    upload: 'Байршуулах',
    upload_audio: 'Аудио байршуулах',
    upload_photo: 'Профайл зураг байршуулах',
    upload_video: 'Видео байршуулах',
    enrolled: 'Элссэн',
    unenroll: 'Элсэхээ болих',
    from_library: 'Медиа сан',
    remove: 'Устгах',
    removed: 'Устгасан',
    start_broadcast: 'Өргөн дамжуулалт эхлүүлэх',
    end_broadcast: 'Өргөн дамжуулалт дуусгах',
    camera: 'Камер',
    screen: 'Дэлгэц',
    screen_with_camera: 'Камертай дэлгэц',

    // added_first
    insert: 'Оруулах', // to translate
    inserting: 'Оруулж байна', // to translate

    upload_pdf: 'PDF байршуулах', // to translate

    portrait: 'Босоо зураг', // to translate
    landscape: 'Хөндлөн зураг', // to translate
    import_from_library: 'Медиа сангаас текст импорт хийх', // to translate
    question_answer_ai: 'Асуулт хариулт хиймэл оюун ухаан', // to translate

    //maze
    take_maze: 'МЭЙЗ ХИЙХ' // to translate
  },

  card: {
    quick_add: 'Түргэн нэмэх',
    add: 'Нэмэх',
    clone: 'Клон хийх',
    completed: 'Гүйцээсэн хичээлүүд'
  },

  course: {
    upcoming_course: 'Дараагийн курс',
    unPublishEvent: 'Эвентийг нийтлэхээ болих',
    unPublishAssessment: 'Үнэлгээг нийтлэхээ болих',
    unPublishMaze: 'Мэйз нийтлэхээ болих', // to translate
    pastCourse: 'Бэлтгэх курс',
    upcoming: 'Дараагийн шууд эвент',
    upcomingMaze: 'Дараагийн мэйз', // to translate
    pastMaze: 'Өмнөх мэйз', // to translate
    pastEvent: 'Өмнө шууд эвент',
    pastAssessment: 'Өмнөх шууд үнэлгээ',
    upcomingAssessment: 'Дараагийн шууд үнэлгээ',
    created: 'Үүсгэсэн огноо:',
    assignees: 'Хуваарилсан хүмүүс',
    organisations:
      '{{ organizations }} Байгууллагууд, <2> {{ users }} хэрэглэгчид</2>',
    event_date: 'Шууд эвентийн огноо <1> {{ date }} </1>',
    delete_warning: 'Үүнийг устгахдаа та итгэлтэй байна уу',
    clonning_no_lesson:
      'Энэ Курсийг клон хийхийн тулд багадаа нэг Хичээл нэмнэ үү.',
    clone_warning: 'Үүнийг клон хийхдээ та итгэлтэй байна уу',
    clone_success: 'клон хийж байна',
    disclaimer: ` Миний курс дараах зүйлсийг агуулаагүй гэдгийг баталж байна:
    - аливаа гуравдагч талын эрхийг зөрчөөгүй
  - бусдын нэр төрд халдсан, эрээ цээргүй авирласан, ёс журамгүй, садар самуун, порно гэрэл зураг, хүчирхийлэл, хэрцгий үйлдэл, доромжлол, заналхийлэл эсвэл ялгаварлан гадуурхсан контент агуулаагүй, од тэмдэглэгээгээр нууж оруулаагүй
  - бусдад хувийн ашиг сонирхлын үүднээс халдаагүй
  - бусад оролцогчид, олны танил хүн эсвэл од хүний дүр эсгээгүй
  - аливаа хувь хүний зөвшөөрөлгүйгээр хувь хүний мэдээлэл, бичлэгийг агуулаагүй ба дэлхийн аль ч улсын дата хамгаалах хуулийг зөрчөөгүй
  - ашгийн сонирхолтой ямар нэг “ухуулга” агуулаагүй `
  },

  coursecreate: {
    dropzone_text: 'Медиа оруулах',
    sidebar_text: 'Хичээлдээ <1/> зориулан <3/> загвар сонгоно уу',
    delete_warning: 'Та энэ хичээлийг устгахдаа итгэлтэй байна уу?'
  },

  coursepage: {
    quizview_loading: 'Хариултыг шалгаж байна. Хүлээнэ үү...',
    quizview_answer: 'Таны хариулт'
  },

  coursequiz: {
    title: 'Бүх хичээлд таавар бий'
  },

  dashboard: {
    tooltip_title: 'Энэ видеог дахиж бүү харуул',
    page_title: 'Таны курсүүдийн тоон үзүүлэлт',
    page_subtitle: 'Үүсгэсэн курсүүдийн статус',
    profile_add_info:
      'Профайлаа гүйцээхийн тулд <1>{{uncompletedText}}</1> нэмнэ үү.',
    profile_build:
      'Профайлаа <1>энд</1> үүсгэн, өөрийн сонирхол, ур чадварын талаар бидэнд хэлээрэй.',
    profile_title: 'Профайлын чансаа',
    more_details: 'Дэлгэрэнгүй деталь'
  },

  errors: {
    answer: 'Хариултаа оруулна уу',
    answer_correct: 'Зөв хариулт сонгоно уу',
    author: `Зохиогчийн нэрийг оруулна уу`, // to translate
    category: 'Ангилал сонгоно уу', //to translate
    course_outline: 'Курсийн агуулгыг оруулна уу', // to translate
    course_obj: 'Курсийн зорилтыг оруулна уу', // to translate
    course_description: 'Курсийн тайлбарыг оруулна уу', // to translate
    maze_outline: 'Мэйзийн агуулгыг оруулна уу', // to translate
    maze_obj: 'Мэйзийн зорилтыг оруулна уу', // to translate
    maze_description: 'Мэйзийн тайлбарыг оруулна уу', // to translate
    code: 'Кодоо оруулна уу',
    criterion: 'Шалгуураа оруулна уу',
    duration: 'Үргэлжлэх хугацаа шаардлагатай',
    element: 'Элемент оруулна уу',
    email: 'Имэйлээ оруулна уу',
    email_invalid: 'Имэйл буруу байна',
    feedback_correct: 'Оруулсан санал зөвлөмж зөв байна',
    feedback_incorrect: 'Оруулсан санал зөвлөмж буруу байна',
    host: 'Эвентийн зохион байгуулагчийг оруулна уу',
    host_assessment: 'Үнэлгээний зохион байгуулагчийг оруулна уу',
    image: 'Зураг оруулна уу',
    lessons: 'Хичээлийн тоог оруулна уу', // to translate
    location: 'Байршлаа оруулна уу',
    live_location: 'Өргөн нэвтрүүлгийн байршлаа оруулна уу',
    limit: 'Шууд дамжуулах хугацаагаа оруулна уу',
    min_3char: '3-аас доошгүй тэмдэгт',
    number: 'Эерэг тоо оруулна уу.',
    host_email_require: `Зохион байгуулагчийн имэйл шаардлагатай.`,
    attendee_email_require: `Оролцогчийн имэйл шаардлагатай.`,
    user_email_require: `Хэрэглэгчийн имэйл шаардлагатай.`, // to translate
    team_size: `Багийн хэмжээ шаардлагатай.`, //to translate
    name: 'Нэрээ оруулна уу',
    not_found_course: 'Курс олдсонгүй',
    not_found_event: 'Эвент олдсонгүй',
    not_found_assessment: 'Үнэлгээ олдсонгүй',
    organization: 'Байгууллага сонгоно уу', // to translate
    pass_score: '0-оос 100 хүртэл үнэлгээ оруулна уу', // to translate
    password: 'Нууц үгээ оруулна уу',
    password_digit: 'Нэгээс багагүй тэмдэгт',
    password_short: 'Нууц үг хэт богино байна, 10-аас доошгүй тэмдэгт.',
    password_special: 'Нэгээс доошгүй онцгой тэмдэгт байна',
    password_uppercase: 'Нэгээс доошгүй том үсэг байна',
    password_lowercase: 'Нэгээс доошгүй жижиг үсэг байна',
    phone: ' Утасны дугаараа оруулна уу',
    phone_invalid: 'Утасны дугаар буруу байна',
    position: 'Байрлалаа оруулна уу',
    price: 'Үнэ оруулна уу (5 эсвэл түүнээс дээш)', // to translate
    question: 'Асуултаа оруулна уу',
    start_date: 'Эхлэх өдөр & цаг шаардлагатай',
    tag: 'Тааг сонгоно уу',
    topics: 'Нэгээс доошгүй сэдэв сонгоно уу.',
    live_topics: ' Сэдвүүд нэмнэ үү',
    title: 'Гарчиг оруулна уу ',
    title_assessment: 'Үнэлгээний нэр оруулна уу',
    title_course: 'Курсийн нэр оруулна уу',
    title_maze: 'Мэйзийн нэр оруулна уу', // to translate
    title_empty: 'Нэр хоосон байж болохгүй',
    title_event: 'Эвентийн нэр оруулна уу',
    title_lesson: 'Хичээлийн нэр оруулна уу',
    title_quiz: 'Тааврын нэр оруулна уу',
    trainer_bio: 'Багшийн товч мэдээлэл оруулна уу', // to translate
    trainer_linkedin: 'Багшийн linkedin хаягийг оруулна уу', // to translate
    username: 'Хэрэглэгчийн нэрээ оруулна уу',
    invalid_verification_code: 'Энэхүү баталгаажуулалтын холбоос нь хугацаа нь дууссан эсвэл хүчингүй болсон байна. Энэ нь ихэвчлэн шинэ баталгаажуулалтын имэйл хүссэн үед тохиоلدдог. Имэйлээ баталгаажуулахын тулд Sharelook-оос ирсэн хамгийн сүүлийн имэйлийг шалгана уу.',
    upload_error: 'Алдаа – Файл тохирохгүй байна!',
    upload_more_than_10: 'Та нэг удаад 10-аас доош файл байршуулах боломжтой.',
    video: 'Видеоны тоог оруулна уу', // to translate
    video_link: 'Видеоны холбоос оруулна уу', // to translate
    topics_max: '5-аас дээшгүй сэдэв нэмнэ үү. (5-ын тоо)', // to translate  (just the digit 5)
    upload_excel: 'Зөв файл байршуулсан эсэхээ шалгана уу.',
    title_excel: 'Загварыг байршуулахад алдаа гарлаа:',
    file_size_exceed: 'Файлын хэмжээ ихэдсэн',
    subtitle_excel:
      'Өгсөн загварыг ашиглаж, багануудыг зөв бөглөсөн эсэхээ шалгана уу.',
    select_broadcast_option: 'Эвентийг өргөн нэвтрүүлэх сонголтоо хийнэ үү',
    multi_hosts_number_error: 'Илтгэгчийн тоо эвентэд зааснаас хэтрэх ёсгүй.',
    conference_people_number_error: `Оролцогчдын тоо эвентэд зааснаас хэтрэх ёсгүй.`,
    select_max_host: 'Эвентэд нэгээс доошгүй илтгэгч сонгоно уу.',
    select_max_conference: 'Эвентэд нэгээс доошгүй оролцогч сонгоно уу.',
    stream_stop_error: 'Дахин холбогдох гэж оролдож байна...',
    no_stream_error: 'зохион байгуулагч эвент эхлүүлэхийг хүлээж байна',
    unsecure_context:
      'Ноцтой алдаа: Аюултай контекстийн улмаас хөтөч камер, мик ашиглах боломжгүй байна. SSL суулгаад https хаягаар хандана уу',
    ws_not_supported:
      'Ноцтой алдаа: WebSocket-ыг энэ хөтөч дээр ашиглах боломжгүй.',

    // added_first
    no_org: 'Үргэлжлүүлэхийн тулд нэгээс доошгүй байгууллага сонгоно уу.', // to translate
    no_org_group:
      'Үргэлжлүүлэхийн тулд нэгээс доошгүй байгууллагын групп сонгоно уу.', // to translate
    waiting_to_join: 'Хүн нэгдэхийг хүлээж байна!', // to translate

    //new
    select_transcribe_locale: 'Хөрвүүлэх хэлээ сонгоно уу', // to translate
    transcribe_limit: 'Хөрвүүлэх минутаа оруулна уу', // to translate
    not_complete: 'Зах зээлийн мэдээлэл гүйцэд бус', // to translate
    complete: 'Зах зээлийн мэдээлэл бүрэн гүйцэд', // to translate
    not_admin: 'Зах зээлд нийтлэхийн тулд админы зөвшөөрөл хэрэгтэй', // to translate
    no_course: 'Зах зээлийг нээхийн тулд нэр өгөөд, зургаа сонгоно уу.', // to translate
    scorm_not_complete:
      'Скорм файл оруулахын тулд нэр өгөөд, зургаа сонгоно уу.', // to translate
    //maze
    not_found_maze: 'Мэйз олдсонгүй', // to translate
    email_require: 'Имэйл шаардлагатай', // to translate
    poll_required: 'Санал хураалтын дата шаардлагатай' // to translate
  },

  events: {
    title: 'Шууд эвентийн деталь нэмэх',
    change_host: 'Зохион байгуулагчийн өөрчлөх',
    finished: 'Эвент дууссан',
    countdown: 'Шууд эвент дамжуулах хүртэл хугацаа ',
    subtitle: 'Шууд эвентдээ нэр өгч, юуны тухай болохыг хүмүүст хэлнэ үү.',
    poll_disabled: 'Энэ эвентэд санал хураах боломжгүй.',
    disclaimer: `Миний эвентэд дараах зүйлсийг агуулаагүй гэдгийг баталж байна:
    - аливаа гуравдагч талын эрхийг зөрчөөгүй
  - бусдын нэр төрд халдсан, эрээ цээргүй авирласан, ёс журамгүй, садар самуун, порно гэрэл зураг, хүчирхийлэл, хэрцгий үйлдэл, доромжлол, заналхийлэл эсвэл ялгаварлан гадуурхсан контент агуулаагүй, од тэмдэглэгээгээр нууж оруулаагүй
  - бусдад хувийн ашиг сонирхлын үүднээс халдаагүй
  - бусад оролцогчид, олны танил хүн эсвэл од хүний дүр эсгээгүй
  - аливаа хувь хүний зөвшөөрөлгүйгээр хувь хүний мэдээлэл, бичлэгийг агуулаагүй ба дэлхийн аль ч улсын дата хамгаалах хуулийг зөрчөөгүй
  - ашгийн сонирхолтой ямар нэг “ухуулга” агуулаагүй'`,
    prompt_message:
      'Энэ хуудаснаа гарвал таны эвент дуусна. Та гарахдаа итгэлтэй байна уу?',
    duration_exceed_message:
      'Таны өргөн нэвтрүүлгийн хугацаа дууслаа. Апп өргөн нэвтрүүлгийг зогсоох болно.',
    before_schedule_message:
      'Та хуваарьт цагаас өмнө өргөн нэвтрүүлгийг эхлүүлэх гэж байна. Өргөн нэвтрүүлгийг зогсоовол эвент дуусна гэдгийг санана уу.',
    browser_unsupportive_message:
      'Уг хөтөч дээр дэлгэцээ хуваалцах боломжгүй байна. Энэ холбоосоор орж боломжтой хөтчүүдийг харна уу',
    cancel_switch_host_message:
      'Зохион байгуулагч байхгүй байна. Эвентийг та үргэлжлүүлэх болно.',
    coaching_prompt_message:
      'Эвент дуусах хүртэл та энэ хуудсыг орхих боломжгүй.',
    event_modal_warn: 'Та эвентээс гарахыг хүсэж байна уу?',
    event_end_warn: 'Та эвентийг дуусгамаар байна уу?',
    confirm_message: 'Та OK гэдгийг дарвал эвент дуусна.',
    screen_share_denied: 'Та дэлгэцээ хуваалцахаас татгалзсан',
    media_not_found:
      'Камер, мик олдсонгүй эсвэл таны төхөөрөмж дээр ашиглах зөвшөөрлийг өгөөгүй байна.',
    media_not_access:
      'Камер эсвэл микийг өөр хэсэгт ашиглаад, төхөөрөмж ашиглахыг зөвшөөрөхгүй байна',
    constraint_error:
      'Таны видео, аудионы шахалтад нийцэх төхөөрөмж олдсонгүй. Та видео, аудионыхоо шахалтыг өөрчилж болно.',
    media_access_denied: 'Камер, мик ашиглахыг зөвшөөрөөгүй байна.'
  },

  filters: {
    days7: 'Сүүлийн 7 өдөр',
    days15: 'Сүүлийн 15 өдөр',
    days30: 'Сүүлийн 30 өдөр',
    days365: 'Сүүлийн 365 өдөр',
    date: 'Үүсгэсэн огноо',
    relevance: 'Ач холбогдол',
    popularity: 'Түгээмэл байдал',
    name: 'Нэр',
    group: 'Групп',
    Newest_to_Oldest: 'Шинээс хуучин',
    Oldest_to_Newest: 'Хуучнаас шинэ',
    A_Z: 'А-аас Я',
    Z_A: 'Я-аас А'
  },

  helpers: {
    password:
      'Таны бүртгэлийн нууцлалыг хадгалахын тулд бид нэгээс доошгүй жижиг үсэг, тоо багтаахыг шаарддаг. Мөн та 10-аас доошгүй тэмдэгт бүхий нууц үг сонгох хэрэгтэй.',
    phone: 'Улсын кодоо оруулна уу. Жишээ нь: +65',
    username:
      'Хэрэглэгчийн нэр нь нийтийн мэдээлэл гэж тооцогдох ба шаардлагатай тохиолдолд бусад хэрэглэгчидтэй хуваалцана. Иймээс хувийн мэдээллээ хэрэглэгчийн нэрээр сонгохгүй байхгүй хүсэж байна.',
    public_description_normal:
      'Таны <0><0/></0> хадгалагдлаа. Анхны тохиргоо нь Хувийн байна. Энэхүү контентыг зөвхөн та харж болно гэсэн үг. Контентыг нийтлэхийг тулд та доорх сонголтуудаас аль нэгийг сонгоно. <0><0/></0>-ээ Нийтэд нээлттэй нийтлэнэ гэдэг нь платформ дээр бүх хэрэглэгчид харагдана гэсэн үг. Тодорхой хэрэглэгчид харагдах сонголтыг хийснээр та <0><0/></0>-ээ Sharelook-т бүртгэлтэй имэйл хаягийг ашиглан тодорхой хүмүүст харуулах юм.',
    public_description_admin:
      'Таны <0><0/></0> хадгалагдлаа. Анхны тохиргоо нь Хувийн байна. Ингэснээр зөвхөн та (контентыг хийсэн хүн) энэ контентыг харна. Контентыг нийтлэхийг тулд та доорх сонголтуудаас аль нэгийг сонгоно уу. <0><0/></0>-ээ Нийтэд нээлттэй нийтэлнэ гэдэг нь платформ дээр бүх хэрэглэгчид харагдана гэсэн үг. Үүнд танай байгууллагаас гаднах хүмүүс мөн хамаарна. Байгууллагадаа нийтэлнэ гэвэл зөвхөн танай байгууллага дахь хүмүүс уг контентыг харна. Мөн та 1 эсвэл түүнээс олон группэд нийтэлж болно. Энэ тохиолдолд зөвхөн тухайн группийн хүмүүс контентыг харна. Эцэст нь та Sharelook-т бүртгэлтэй имэйлийг ашиглан байгууллагын доторх болон гаднах тодорхой хүмүүст нийтлэх боломжтой.'
  },

  labels: {
    add: 'Нэмэх',
    no_of_people_in_conference: 'Хуралд хэчнээн хүн байна вэ?', //to translate
    portrait: 'Босоо зургийг тайрах',
    landscape: 'Хөндлөн зургийг тайрах',
    transcribe_settings: 'Хөрвүүлэх тохиргоо', // to translate
    transcribe: 'Хөрвүүлэх', // to translate
    answer_type: 'Хариултын төрөл',
    answers: 'Хариултууд',
    back_to_quiz: 'Тааврын жагсаалт руу буцах',
    back_to_question: 'Асуултын жагсаалт руу буцах',
    chat: 'Чат',
    chat_available: 'Энэ эвентэд чатлах боломжгүй',
    chat_report: 'Чат тайлан',
    choice_single: 'Дан сонголт',
    choice_multiple: 'Олон сонголт',
    choice_free: '"Үнэгүй" сонголт',
    choice_sorting: '"Эрэмбэлэх" сонголт',
    choice_matrix: '"Матрикс эрэмбэлэх" сонголт',
    clone_lesson_permission: 'Клон хийх зөвшөөрөл',
    code: 'Код',
    correct: 'Зөв',
    created: 'Үүсгэсэн огноо',
    clone_modal: 'Курсийг клон хийх',
    cloning_course: 'Курсийг клон хийж байна...',
    cloning_maze: 'Мэйзийг клон хийж байна...', //to translate
    cloning: 'Клон хийж байна...',
    cloning_course_desc:
      'Энэ процесс хугацаа шаардана. Та тэвчээртэй хүлээнэ үү',
    cloning_success: '"<0/>" курсийг амжилттай клон хийлээ!',
    maze_cloning_success: '"<0/>" мэйзийг амжилттай клон хийлээ!', // to translate
    create_certificate: 'Сертификат үүсгэх', // to translate
    create_badge: 'Тэмдэг үүсгэх', // to translate
    certificate_added: 'Сертификат нэмэгдлээ.', // to translate
    badge_added: 'Тэмдэг нэмэгдлээ.', // to translate
    certificate_warning:
      'Нийтлэгдсэний дараа сертификат/тэмдгийг засварлах боломжгүй!', // to translate
    description: 'Тайлбар',
    disclaimer: 'Үгүйсгэсэн мэдэгдэл',
    drop_file: 'Файлаа энд оруулна уу...',
    duration: 'Үргэлжлэх хугацаа',
    edit: 'Засварлах',
    email: 'Имэйл',
    event: 'Эвент',
    event_all: 'Түүний бүх эвентүүд',
    event_date: 'Шууд эвентийн орон нутгийн цагаар Огноо/Цаг',
    event_this: 'Энэ эвент',
    expire: 'Дуусах хугацаа',
    expiry_date: 'Дуусах өдөр',
    forgot: 'Нууц үгээ мартсан уу?',
    group: 'Групп',
    groups_list: 'Группүүдийн жагсаалт',
    host: 'Зохион байгуулагч',
    id_annotation: 'Тайлбарын id',
    id_number: 'Id дугаар', // to translate
    id_quiz: 'Тааврын id',
    incorrect: 'Буруу',
    interests: 'Сонирхол',
    invited: 'Урьсан',
    live_chat: 'Шууд хэлэлцүүлэг',
    live_stream_limit: 'Шууд дамжуулалтын минут',
    contact_text:
      'Шууд дамжуулалтын сарын хязгаараа өөрчлөхийг хүсвэл холбоо барина уу',
    contact_admin:
      '<0>Хэрэв та шууд дамжуулалтын сарын хязгаараа өөрчлөхийг хүсвэл</0> <1>admin@sharelook.com</1>хаягаар холбогдоно уу',
    limit_stream_text:
      'Шууд дамжуулалтын үлдсэн минут: <0>{{ limit }}</0> минут<1/><2/> <3> Шууд дамжуулалтын сарын хязгаараа өөрчлөхийг хүсвэл</3> <4>admin@sharelook.com</4>хаягаар холбогдоно уу',
    location: 'Байршил',
    lessons: 'Хичээлүүд',
    location_broadcast: 'Зохион байгуулагчийн серверийн байршил',
    location_broadcast_subtitle:
      'Дуу дүрсний саажилтыг бууруулахын тулд зохион байгуулагчийн байршилтай хамгийн ойр байршил нэмнэ үү',
    media_manager: 'Медиа менежер',
    minutes: 'Минут',
    name: 'Нэр',
    online_quiz: 'Цахим таавар',
    organiser: 'Зохиолч',
    organization: 'Байгууллага',
    overall_emotion: 'Ерөнхий туршлага:',
    organizations_list: 'Байгууллагуудын жагсаалт',
    password: 'Нууц үг',
    participants: 'Оролцогчид',
    pass_score: 'Босго оноо', // to translate
    picture: 'Зураг',
    scorm_zip: 'Скорм Zip', // to translate
    phone: 'Утас',
    photo: 'Гэрэл зураг',
    poll: 'Санал хураалт',
    position: 'Байрлал',
    processing: 'Дамжуулж байна',
    privacy_settings: 'Хувийн тохиргоо',
    question: 'Асуулт',
    quiz_create: 'Шинэ таавар үүсгэх',
    quiz_name: 'Тааврын нэр',
    quiz_update: 'Тааврыг шинэчлэх',
    select_organization: 'Байгууллага сонгох',
    settings: 'Тохиргоо',
    show: 'Харуулах',
    show_graph: 'Графикийн үр дүнг харуулах',
    signin: 'Нэвтрэх',
    signup: 'Бүртгүүлэх',
    sort_by: 'Эрэмбэлэх',
    start_date: 'Эхлэх өдөр',
    tags: 'Таагууд',
    terms: 'Би<1>үйлчилгээний нөхцөлийг</1>хүлээн зөвшөөрч байна.',
    timezone: 'Цагийн бүс', //to translate
    title: 'Гарчиг',
    topics: 'Сэдвүүд',
    topic: 'Сэдэв',
    total_comments: 'Нийт сэтгэгдэл',
    username: 'Хэрэглэгчийн нэр',
    users_list: 'Хэрэглэгчдийн жагсаалт',
    users_emails: `Тодорхой хэрэглэгчийн имэйл сонгоно уу`,
    description_specifiction_email:
      'Тодорхой олон хэрэглэгч рүү илгээхийн тулд мөр бүрт 1 имэйл хаяг оруулна уу.',
    message_specific_email: 'Тодорхой хэрэглэгчийн имэйлийг оруулна уу.',
    viewers: 'Харсан хүмүүс',
    edit_course: 'Засварлах',
    edit_assessment: 'Засварлах',
    edit_event: 'Засварлах',
    edit_maze: 'Засварлах', //to translate
    delete_course: 'Устгах',
    delete_event: 'Устгах',
    delete_maze: 'Устгах', //to translate
    delete_assessment: 'Устгах',
    view_course: 'Харах',
    view_event: 'Харах',
    view_assessment: 'Харах',
    view_maze: 'Харах', //to translate
    date_event: 'Шууд эвентийн өдөр',
    date_assessment: 'Шууд үнэлгээний өдөр',
    clone_of: 'Клон',
    clone_course:
      'Бүх хичээл хуудсыг багтаасан курсийн эхийг бие даан өөрчлөх боломжтой клон үүсгэх.',
    make: 'Нээлттэй болгох',
    available_to: 'бүх ShareLook хэрэглэгчдэд нээлттэй',
    uploaded_by: 'Байршуулсан хүн: ',
    course: 'Курс',
    assessment: 'Үнэлгээ',
    user_not_exist: 'Хэрэглэгч олдсонгүй. Та урилга илгээх үү?',
    check_user: 'Мэдэгдэл',
    user_not_exist_in_org:
      'Энэ байгууллагад ийм хэрэглэгч байхгүй байна. Та урилга илгээх үү?',
    title_modal_stream: 'Байгууллагын шууд дамжуулалтын хязгаарыг өөрчлөх',
    des_warning_stream: 'Та өөрчлөх гэж байна',
    monthly_stream: 'cарын шууд дамжуулалтын хязгаар:',
    min_per_month: 'минут/цаг',
    broadcast_label: 'Би үүнийг хүсэж байна:',
    hosts_emails: `Тодорхой зохион байгуулагчийн имэйлийг оруулах`,
    attendee_emails: `Тодорхой оролцогчийн имэйлийг оруулах`,
    examinee_emails: `Тодорхой шалгуулагчийн имэйлийг оруулах`, // to translate
    description_host_specifiction_email: 'Мөр бүрд нэг имэйл хаяг оруулна уу.',
    presenter_label: 'Илтгэгч',
    presenter_label_conference: 'Хүний тоо',
    event_privacy: 'Хурлын горим',
    // added_second
    alert: 'Анхааруулга!', // to translate
    warning: 'Анхаар!', // to translate
    ok: 'За', // to translate
    cancel: 'Цуцлах', // to translate
    done: 'Болсон', // to translate
    insert: 'Оруулах', // to translate
    private: 'Хувийн', // to translate
    public: 'Нийтийн', // to translate
    no_connection: 'Интернэт холболт салсан', // to translate
    switch: 'Солих', // to translate
    share_screen: 'Дэлгэц хуваалцах', // to translate
    stop_share_screen: 'Дэлгэц хуваалцахаа болих', // to translate
    share_screen_with_camera: 'Камертай дэлгэц хуваалцах', // to translate
    stop_share_screen_with_camera: 'Камертай дэлгэц хуваалцахаа болих', // to translate
    camera_on: 'Камер асаалттай', // to translate
    camera_off: 'Камер унтраасан', // to translate
    mic_on: 'дууг нээх', // to translate
    mic_off: 'дууг хаах', // to translate
    fullscreen: 'бүтэн дэлгэц', // to translate
    live_now: 'Шууд дамжуулж байна', // to translate
    schedule_on: 'Хуваарьт өдөр', // to translate
    organisations: 'Байгууллагууд', // to translate
    org_groups: 'Байгууллагын группүүд', // to translate
    specific_user: 'Тодорхой хэрэглэгч', // to translate
    gif: 'GIF', // to translate
    unavailable: 'байхгүй байна', // to translate
    yes: 'Тийм', // to translate
    no: 'Үгүй', // to translate
    event_duration_message: '300 минутаас дээшгүй(5 цаг)', // to translate
    send_email: 'Имэйл мэдэгдэл илгээх', // to translate
    admin_only: 'Зөвхөн админ', // to translate
    join: 'Нэгдэх', // to translate
    leave: 'Орхих', // to translate
    share: 'Хуваалцах', // to translate
    share_text: 'Энэ файлыг хуваалцах хүнийхээ имэйлийг бичнэ үү', // to translate
    share_text_title: 'PDF хуваалцах', // to translate
    share_text_title_txt: 'Текст хуваалцах', // to translate
    select_users: 'Хэрэглэгчид сонгох', // to translate
    delete: 'Хэрэглэгчид сонгох', // to translate
    attachment_event: 'Эвентийн хавсралтууд:', // to translate,
    // newly added
    transcribe_limit: 'Хөрвүүлэх минут', // to translate
    monthly_transcribe: 'сарын хөрвүүлэх хязгаар:', // to translate
    enable_ai: 'Хиймэл оюун ухааныг идэвхжүүлэх:', // to translate
    media_service: 'Медиа үйлчилгээ', // to translate
    allow_others: 'Бусад хүмүүс засвар хийхийг зөвшөөрөх' // to translate
  },

  broadcastOptions: {
    stream_from_phone: ' Утсаараа шууд өргөн нэвтрүүлэх',
    other_webrtc: 'Хувийн компьютероосоо веминар хийх',
    multihost: 'Хувийн компьютероосоо олон хэрэглэгчид рүү веминар хийх',
    peer2peer: 'Дасгалжуулалтын уулзалт',
    conference: 'Шууд хурал'
  },

  //to translate
  conferenceTeamOptions: {
    uptoTen: '1-ээс 10', // to translate
    uptoTwenty: '11-ээс 20', // to translate
    uptoTwentyFive: '21-ээс 25' // to translate
    // uptoForty: '31 to 40'
  },

  //to translate
  conferenceAttendeeOptions: {
    uptoTwoHundredFifty: '1-ээс 250' // to translate
    // uptoHundred: '51 to 100',
    // uptoTwoHundred: '101 to 200'
    // uptoForty: '31 to 40'
  },

  mediaServices: {
    ANTMEDIA: 'АНТМЕДИА', // to translate
    CHIME: 'ЧАЙМ' // to translate
  },

  lessoncreate: {
    title: 'Хичээлийн дэлгэрэнгүй нэмэх',
    subtitle: 'Хичээлдээ нэр өгөөд, юун тухай болохыг хүмүүст хэлнэ үү.',
    input_label_title: 'Хичээлийн нэр',
    input_label_topics: 'Хичээлийн сэдвүүд',
    input_label_description: 'Хичээлийн тайлбар',
    delete_warning: 'Та энэ хуудсыг устгахдаа итгэлтэй байна уу?'
  },

  lessonoverview: {
    title: 'Хичээл нэмэх',
    subtitle: 'Add existing lesson or create a new one',
    new_lesson: 'create a new lesson',
    new_lesson_sub: 'Бэлэн хичээл нэмэх эсвэл шинийг үүсгэх!',
    existing_lesson: 'Шинэ хичээл үүсгэх',
    existing_lesson_sub:
      'Бэлэн хичээлтэй холбох, энэ хичээлд хийсэн өөрчлөлт нь бусад курсэд байгаа энэ хичээлд л нөлөөлнө.',
    clone_lesson: 'бэлэн хичээлийг хуулбарлах',
    clone_lesson_sub:
      'Хичээлийн цор ганц хуулбар үүсгэх. Энэ хичээлд оруулсан өөрчлөлт эх хичээлд нөлөөлөхгүй.',
    clone_lesson_modal_sub:
      'Курсдээ нэмэх хичээлийнхээ доорх клон товчийг дарна уу.'
  },

  management: {
    groups_title: 'Группүүдээ удирдах',
    delete_warning: 'Та итгэлтэй байна уу?',
    organizations_title: 'Миний байгууллагууд',
    organizations_subtitle: 'Жагсаалтдаа байгууллагууд нэмэх',
    users_title: 'Хэрэглэгчдийг удирдах',
    users_position: 'Бүртгэл хариуцсан ахлах менежер',
    user_not_found: 'Хэрэглэгч олдсонгүй',
    select_org: 'Хэрэглэгчдийг удирдахын тулд байгууллага олоод сонгоно уу',
    select_org_report: 'Тайлан гаргахын тулд байгууллага олоод сонгоно уу' // to translate
  },

  audio: {
    modal_title: 'Аудио оруулах',
    list_view: 'Жагсаалтаар харах',
    create_audio_modal_title: 'Аудио үүсгэх',
    edit_audio_modal_title: 'Аудио засварлах',
    public_audio_not_found: 'Аудио олдсонгүй.',
    private_audio_not_found: 'Та хараахан аудио байршуулаагүй байна',
    org_audio_not_found: 'Аудио олдсонгүй.', // to translate
    are_you_sure_to_delete: 'Та устгахдаа итгэлтэй байна уу?',
    type_something: 'Ямар нэг зүйл шивэх',
    select_voice: 'Сонгох',
    file_name: 'Файлын нэр',
    description: 'Тайлбар',
    topic: 'Сэдэв',
    key_words_tag: 'Түлхүүр үгийн тааг',
    mp3_audio: 'MP3 аудио',
    created: 'Үүсгэсэн',
    duration: 'Үргэлжлэх хугацаа',
    close: 'хаах'
  },

  image: {
    modal_title: 'Зураг оруулах',
    image: 'Зураг',
    pixel: 'Нягтрал',
    dimension: 'Хэмжээ',
    public_image_not_found: 'Зураг олдсонгүй.',
    private_image_not_found: 'Та хараахан зураг байршуулаагүй байна',
    org_image_not_found: 'Зураг олдсонгүй.' // to translate
  },

  annotation: {
    modal_title: 'Тайлбар'
  },

  text: {
    modal_title: 'Текст засварлагч',
    insert_text: 'Текст оруулах', // to translate
    insert_question_answer: 'Асуулт хариулт хиймэл оюун ухаан', //to translate
    modal_title2: 'Текст галерей', // to translate
    my_text_library: 'Миний текст галерей', // to translate
    ai: 'Хиймэл оюун ухаан', // to translate
    public_text_library: 'Нийтийн текст галерей', // to translate
    organization_text_library: 'Байгууллагын текст сан', // to translate
    no_transcribed_text: 'Хөрвүүлсэн текст олдсонгүй', // to translate
    public_text_not_found: 'Нийтийн хөрвүүлсэн текст олдсонгүй.', // to translate
    org_text_not_found: 'Байгууллагын хөрвүүлсэн текст олдсонгүй.' // to translate
  },

  video: {
    modal_title: 'Видео оруулах',
    image: 'Видео',
    mp4_video: 'MP4 Видео',
    public_video_not_found: 'Видео олдсонгүй.',
    private_video_not_found: 'Та хараахан видео байршуулаагүй байна',
    org_video_not_found: 'Видео олдсонгүй.' // to translate
  },

  media: {
    title: 'Медиа сан',
    subtitle: 'Таны файлуудын сан',
    modal_title: 'Медиа байршуулах',
    canva: 'Canva-аас үүнийг хийх', // to translate
    canva_open: 'Canva Editor нээх бол энд дар', //to translate
    delete_warning: 'Устгахаа баталгаажуулах',
    delete_message:
      'Устгагдсан медиа нь ашиглагдсан хуудаснууд дээрээ харагдсаар байх болно',
    dropzone_text: 'Эсвэл чирээд авчрах',
    delete_success: 'Медиа амжилттай устлаа',
    upload_file: 'Файл байршуулах',
    drag_drop: 'эсвэл чирээд авчрах',
    import_file: 'Компьютероосоо файл(ууд) импорт хийх',
    no_media: 'Та хараахан медиа байршуулаагүй байна',
    media_type: 'Медиа төрөл',
    video: 'Видео',
    image: 'Зураг',
    audio: 'Аудио',
    gif: 'GIF',
    pdf: 'PDF', // to translate
    transcribed_text: 'Хөрвүүлсэн текст',
    txt: 'ТЕКСТ', // to translate
    media_not_found: 'Медиа олдсонгүй.',
    of: '-ын',
    disclaimer: `Миний медиа дараах зүйлсийг зөрчөөгүй гэдгийг баталж байна:

    - аливаа гуравдагч талын эрхийг зөрчөөгүй
    - бусдын нэр төрд халдсан, эрээ цээргүй авирласан, ёс журамгүй, садар самуун, порно гэрэл зураг, хүчирхийлэл, хэрцгий үйлдэл, доромжлол, заналхийлэл эсвэл ялгаварлан гадуурхсан контент агуулаагүй, од тэмдэглэгээгээр нууж оруулаагүй
    - бусдад хувийн ашиг сонирхлын үүднээс халдаагүй
    - бусад оролцогчид, олны танил хүн эсвэл од хүний дүр эсгээгүй
    - аливаа хувь хүний зөвшөөрөлгүйгээр хувь хүний мэдээлэл, бичлэгийг агуулаагүй ба дэлхийн аль ч улсын дата хамгаалах хуулийг зөрчөөгүй
    - ашгийн сонирхолтой ямар нэг “ухуулга” агуулаагүй`,

    // added_first
    my_media: 'Миний медиа', // to translate
    maze_scenes: 'Мэйз үзэгдлүүд', // to translate
    public_library: 'Нийтийн сан', // to translate
    organization_library: 'Байгууллагын сан', // to translate
    upload_from_computer: 'Компьютероос байршуулах', // to translate
    pexel_images: 'Pexel зургууд', // to translate
    create: 'Үүсгэх', // to translate
    all: 'Бүгд', // to translate
    male: 'Эрэгтэй', // to translate
    female: 'Эмэгтэй', // to translate
    processing_audio: 'Аудиог боловсруулж байна', // to translate
    create_annotation: 'Тайлбар үүсгэх', // to translate
    popup_over_lesson_text:
      'Дарсны дараа хичээлийн хуудас дээр тайлбар үсэрч гарч ирнэ', // to translate
    edit_detail: 'Деталь засварлах', // to translate
    delete: 'Устгах', // to translate
    go_create_audio: 'Аудио үүсгэх рүү очих', // to translate
    show_more_details: 'илүү деталь харуулах', // to translate
    show_less_details: 'бага деталь харуулах', // to translate
    drop_files: 'Файлаа оруулаад, байршуулах газар', // to translate
    or: 'Эсвэл', // to translate
    import_files: 'Компьютероос файлууд импорт хийх', // to translate
    // added_fourth
    human: 'Премиум', // to translate
    shared_file: 'Та файлаа амжилттай хуваалцлаа', // to translate
    error_shared_file: 'Файл хуваалцахад алдаа гарлаа. Дахин оролдоно уу.', // to translate
    publish: 'Нийтлэх' // to translate
  },

  navigation: {
    account: 'Бүртгэл',
    assessments: 'Үнэлгээнүүд',
    dashboard: 'Талбар',
    groups: 'Групп менежмент',
    logout: 'Гарах',
    organisations: 'Байгууллагууд',
    organizations_users: 'Байгууллагууд & Хэрэглэгчид',
    reports: 'Тайлангууд',
    schedule: 'Хуваарь',
    training: 'Сургалт',
    users: 'Хэрэглэгчид',

    // added_first
    nowLive: 'Шууд',

    workshop: 'Миний дасгал ажил'
  },

  onboarding: {
    step1_title: 'Алхам 1 : Бидэнд өөрийнхөө тухай товч танилцуулах',
    step1_subtitle:
      'Таны нэр хэн бэ? Та хаанаас ирсэн бэ? Таны албан тушаал юу вэ?',
    step2_title: 'Алхам 2 : Сайжруулах шаардлагатай зарим ур чадвар',
    step2_subtitle:
      'Дараа нь юуг илүү ойлгохыг хүсэж буй тухайгаа хэлнэ үү. Сайн ойлгохгүй байгаа зүйл байж болно. Шинэ зүйлийн талаар сурах гэж байна уу? Таны хайртай хүн юу хийдэг вэ?'
  },

  pagebuilder: {
    title: 'Хичээл үүсгэх',
    subtitle:
      'Танаас хүмүүс сурах контентыг үүсгэх цаг боллоо. Та зураг, видео, инфографик ашиглаж болно',
    select_layout: 'Хуудасны төлөвлөлтийг сонгох',
    template1: 'Хоосон',
    template2: 'Гарчиг & Дэд гарчиг',
    template3: 'Гарчиг & Текст',
    template4: 'Гарчиг, Медиа & Текст',
    template5: 'Гарчиг & Медиа',
    template6: 'Гарчиг & Таавар'
  },

  pageconstructor: {
    title: 'Хичээл үүсгэх болон клон хийх',
    subtitle:
      'Танаас хүмүүс сурах курсийн контентыг үүсгэх цаг боллоо. Та зураг, видео, инфографик ашиглаж болно'
  },

  passwordreset: {
    success_coded:
      'Таны өгсөн хаяг руу баталгаажуулах код имэйлээр илгээсэн. Доорх хэсэгт тухайн кодыг хуулаад шинэ нууц үг үүсгэнэ үү.',
    success_changed:
      'Та шинэ нууц үг амжилттай үүсгэлээ. Та одоо нэвтэрч болно.'
  },

  placeholders: {
    attempts_count: 'Хэрэглэгч дахин оролдох боломжтой тоо', // to translate
    no_of_people_placeholder: 'Number of people', //to translate
    search: 'Хүмүүсийн тоо',
    answer: 'Хайх',
    chat: 'Ямар нэг зүйл хэлэх...',
    code: 'Код',
    criterion: 'Шалгуур',
    date_event: 'Өдөр & цаг сонгох',
    date_start: 'Эхлэх огноо',
    date_expire: 'Дуусах огноо',
    description: 'Тайлбар',
    elements: 'Элементүүдийг эрэмбэлэх',
    email: 'Имэйл',
    feedback_correct: 'Санал зөвлөмж зөв',
    feedback_incorrect: 'Санал зөвлөмж буруу',
    host: 'Зохион байгуулагч',
    keywords: 'Түлхүүр үг(с) хайх',
    lesson_description: 'Хичээлийн тайлбар',
    location: 'Байршил',
    minutes: 'Минут',
    name: 'Нэр',
    organiser: 'Зохиолч',
    organization: 'Байгууллага',
    password: 'Нууц үг',
    phone: 'Утас',
    photo: 'Зураг',
    picture: 'Зураг',
    point: 'Оноо',
    position: 'Байрлал',
    question: 'Асуулт',
    quiz: 'Тааврын нэр',
    search_course: 'Курсээр хайх',
    search_media: 'Медиагаар хайх',
    search_name: 'Нэрээр хайх',
    search_title: 'Гарчгаар хайх',
    search_training: 'Сургалтаар хайх',
    settings: 'Тохиргоо',
    tags: 'Таагууд',
    title: 'Гарчиг',
    topics: 'Сэдвүүд',
    username: 'Хэрэглэгчийн нэр',
    keyword: 'Түлхүүр үгс',
    max_500_characters: '500 тэмдэгтээс дээшгүй',
    no_description: 'Файлд тайлбар алга',
    no_keyword: 'Файлд түлхүүр үгс алга',
    no_topics: 'Файлд сэдэв тохируулаагүй байна',
    feedback: 'Мессеж',
    contact: 'Бид яаж туслах вэ?',
    text: ' Текстээ энд бичнэ үү.' //to translate
  },

  publishsettings: {
    title: 'Нийтлэх тохиргоо',
    event_subtitle:
      'Эвентээ тохиргоо хийнэ үү. Эвентийг хэн харах, харьцаж болохыг тохируулна',
    assessment_subtitile:
      'Үнэлгээндээ нэр өгөөд үүнээс юу сурах тухай хүмүүст хэлж өгнө үү',
    course_subtitle:
      'Курсдээ тохиргоо хийнэ үү. Курсийг хэн харах, харьцаж болохыг тохируулна',
    disclaimer:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis',
    dates_validation_error: 'Хоёр огноог хоёуланг бөглөнө.',
    course_dates_validation_error: 'Энэ курс эхлэх болон дуусах хугацааг оруулна уу.',
    emails_validation_error: 'Имэйл жагсаалт буруу байна.',
    specific_email_validation_error: 'Зөвхөн нэг имэйл зөвшөөрнө.',
    i_agree_to_these: 'Бид эдгээр',
    terms_and_conditions: 'үйлчилгээний нөхцөлийг зөвшөөрч байна.',
    PublicDescription:
      'Үнэгүй ашиглах хувь хэрэглэгчид: (Хувийн болон нийтийн сонголт) Таны [Курс|Эвент|Үнэлгээ] хадгалагдан, анхны тохиргоогоор Хувийн байна. Энэ контент зөвхөн танд харагдана гэсэн үг. Контентыг нийтлэхийн тулд доор зааснаар нийтийн болгоно уу. Ингэвэл платформ дээр бүх хэрэглэгчид курс харагдана.',
    OrganisationsDescription:
      'Байгууллагын хэрэглэгчид: (""Дуусгах"" гэхийн оронд ""Нийтлэх"" гэдгийг дарж, өөр нийтлэх сонголт хийлгүйгээр бусад хэрэглэгчдийн адил хуудсыг нийтлээрэй.) Таны [Курс|Эвент|Үнэлгээ] хадгалагдсан ба Хувийн тохиргоотой байна. Зөвхөн та болон байгууллагын удирдлагууд харж болно гэсэн үг. Хэрэглэгч болохоор та байгууллагадаа контентыг нийтлэх боломжгүй ба удирдлагын зөвшөөрөл шаардлагатай. Удирдлагын хүнтэй холбогдож, контентыг нийтэд, байгууллагын бүх хүмүүст, байгууллагын тодорхой хэрэглэгчдэд өгөхийг хүснэ үү.',
    OrganisationGroupsDescription:
      'Байгууллагын удирдлага: (Байгууллага доторх контент: Хувийн, нийтийн, байгууллагын, группүүд, тодорхой хэрэглэгчид): Энэхүү [Курс|Эвент|Үнэлгээ] хадгалагдсан ба анхны тохиргоогоор Хувийн байна. Энэ нь зөвхөн танд (болон контент үүсгэгчид) харагдана гэсэн үг. Контентыг нийтлэх бол доорх сонголтуудаас хийнэ үү. Нийтэд курсээ нийтэлснээр платформ дээр бүх хэрэглэгчид харагдана гэсэн үг. Үүнд таны байгууллагад үл хамаарах хүмүүс ч багтана. Байгууллагад нийтлэх гэвэл байгууллагын бүх хүмүүс харна гэсэн үг. Мөн та нэг эсвэл түүнээс дээш тооны группэд нийтлэх боломжтой. Тухайн группэд байгаа хэрэглэгчид уг контентыг харна. Эцэст нь та байгууллагад үл хамаарах хүмүүст Sharelook-д бүртгэлтэй имэйлийг ашиглан тодорхой хэрэглэгчид нийтэлж болно.',
    SpecificUsersDescription:
      'Төлбөртэй хувь хэрэглэгчид: (хувийн, нийтийн, тодорхой хэрэглэгчид) Таны [Курс|Эвент|Үнэлгээ] хадгалагдсан ба анхны тохиргоогоор Хувийн байна. Энэ контент зөвхөн танд харагдана гэсэн үг. Контентыг нийтлэх бол дараах сонголтуудаас хийнэ үү. Курсийг нийтэд нийтэлвэл платформ дээр бүх хэрэглэгчид харагдана. Тодорхой хэрэглэгчид харуулах сонголтыг хийснээр та Sharelook-т бүртгэлтэй имэйл хаягийг ашиглан тодорхой хэрэглэгчдэд курсээ хуваалцах боломжтой.'
  },

  quiz: {
    quiz_empty: 'Та хараахан таавар үүсгээгүй байна',
    questions_empty: 'Та хараахан асуулт үүсгээгүй байна'
  },

  regions: {
    asia_pacific_australia: 'Австрали',
    asia_pacific_india: 'Энэтхэг',
    asia_pacific_japan: 'Япон',
    asia_pacific_s_korea: 'Өмнөд Солонгос',
    asia_pacific_singapore: 'Сингапур',
    asia_pacific_taiwan: 'Тайвань',
    eu_belgium: 'Бельги',
    eu_germany: 'Герман',
    eu_ireland: 'Ирланд',
    south_america_brazil: 'Бразил',
    us_central_iowa: 'Йова',
    us_east_s_carolina: 'Өмнөд Каролина',
    us_east_virginia: 'Виржиниа',
    us_west_california: 'Калифорниа',
    us_west_oregon: 'Орегон'
  },

  publishmaze: {
    title: 'Нийтлэх тохиргоо', // to translate
    maze_subtitle:
      'Мэйздээ тохиргоо нэмээрэй. Хэн таны мэйзийг харах, харьцаж болохыг тохируулаарай.', // to translate
    disclaimer: `Миний үнэлгээ дараах зүйлсийг зөрчөөгүй гэдгийг баталж байна:
    - аливаа гуравдагч талын эрхийг зөрчөөгүй
    - бусдын нэр төрд халдсан, эрээ цээргүй авирласан, ёс журамгүй, садар самуун, порно гэрэл зураг, хүчирхийлэл, хэрцгий үйлдэл, доромжлол, заналхийлэл эсвэл ялгаварлан гадуурхсан контент агуулаагүй, од тэмдэглэгээгээр нууж оруулаагүй
    - бусдад хувийн ашиг сонирхлын үүднээс халдаагүй
    - бусад оролцогчид, олны танил хүн эсвэл од хүний дүр эсгээгүй
    - аливаа хувь хүний зөвшөөрөлгүйгээр хувь хүний мэдээлэл, бичлэгийг агуулаагүй ба дэлхийн аль ч улсын дата хамгаалах хуулийг зөрчөөгүй
    - ашгийн сонирхолтой ямар нэг “ухуулга” агуулаагүй'` // to translate
  },

  reports: {
    title: 'Тайлангууд',

    // added_first
    workshop_report: 'Дасгал ажлын тайлан',
    user_report: 'Хэрэглэгчийн тайлан',
    organization_workshop: 'Байгууллагын дасгал ажил',
    course: 'Курс',
    live_event: 'Шууд эвент',
    workShop_graph: 'Дасгал ажлын график',
    organization_account: 'Байгууллагын бүртгэл',
    all: 'Бүх',
    name: 'Нэр',
    group: 'Групп', //to translate
    group_name: 'Группийн нэр', //to translate
    select_group: 'Групп сонгох', //to translate
    id_number: 'ID дугаар',
    email: 'Имэйл',
    search_user_report: 'Хэрэглэгчийн тайлангаар хайх',
    participant: 'Оролцогч',
    participants: 'Оролцогчид',
    host: 'Зохион байгуулагч',
    hosts: 'Зохион байгуулагчид', //to translate
    username: 'Хэрэглэгчийн нэр',
    event: 'Эвент',
    quiz: 'Таавар',
    assessment: 'Үнэлгээ',
    time: 'Хугацаа',
    no_recent_activity: 'Сүүлийн үед үйлдэл бүртгэгдээгүй байна',
    workshops: 'Дасгал ажлууд',
    courses: 'Курсүүд',
    live_events: 'Шууд эвентүүд',
    live_assessments: 'Шууд үнэлгээнүүд',
    quizzes: 'Тааврууд',
    overview: 'Тойм',
    by: '-аар',
    views: 'Үзсэн тоо',
    status: 'Статус',
    pass_score: 'Босго оноо', // to translate
    poll: 'Санал хураалт',
    comment: 'Сэтгэгдэл',
    comments: 'Сэтгэгдлүүд',
    no_comments: 'Сэтгэгдэл байхгүй',
    no_polls: 'Санал хураалт байхгүй',
    live_date: 'Шууд дамжуулах өдөр',
    score: 'Оноо',
    question: 'Асуулт',
    submit: 'Илгээх',
    recent_activity: 'Сүүлийн үеийн үйлдэл',
    ago: 'Өмнө',
    no_data_found: 'Дата олдсонгүй',
    start_end_live: 'Шууд дамжуулалтыг эхлүүлэх/Дуусгах',
    join_leave_date: 'Нэгдэх / Орхих',
    watched_time: 'Үзсэн хугацаа',
    complete: 'Гүйцэд',
    in_complete: 'Гүйцэд бус',
    today: 'Өнөөдөр',
    seven_days: '7 өдөр',
    last_month: 'Өнгөрсөн сар',
    one_year: '1 жил',
    all_time: 'Бүх хугацаа',
    report: 'Тайлан',
    from_date: 'Эхлэх огноо',
    to_date: 'Дуусах огноо',
    all_workshop: 'Бүх дасгал ажил',
    all_participants: 'Бүх оролцогчид',
    live_assessment: 'Шууд үнэлгээ',
    users: 'Хэрэглэгчид',
    download: 'Татах',
    recent: 'Саяхны',
    WorkShop: 'Дасгал ажил',
    Activity: 'Үйлдэл',
    created_date: 'Үүсгэсэн огноо',
    lessons: 'Хичээлүүд',
    lesson: 'Хичээл',
    report_download: 'ТАТАХ',
    this_month: 'Энэ сар',
    search_course: 'Курс хайх',
    // search_skill_journey: "Search Skill journey", // to translate
    search_maze: 'Мэйз хайх', // to translate
    participants_graph: 'Оролцогчдын график',
    viewed: 'Харсан',
    enrolled: 'Элссэн',
    description: 'Тайлбар',
    topic: 'Сэдэв',
    analytic: 'Анализ',
    quiz_list: 'Тааврын жагсаалт',
    select_one: 'Нэгийг сонгох',
    group_status: 'Групп статус',
    duration_min: 'Үргэлжлэх хугацаа (мин)',
    submit_poll: 'Санал хураалт илгээх',
    download_events: 'Эвентүүдийг татаж авах',
    search_event: 'Эвент хайх',
    duration: 'Үргэлжлэх хугацаа',
    total_participants: 'Нийт оролцогчид',
    message: 'Мессеж',
    avg_message: 'Дундаж мессеж',
    per_message: 'МЕССЕЖНИЙ ХУВЬ/ ЭВЕНТ',
    avg_score: 'Дундаж оноо', // to translate
    maze: 'Мэйз', // to translate
    maze_report: ' Мэйз тайлан', // to translate
    maze_view: 'Мэйз харагдах байдал', // to translate
    title_maze: 'Мэйз', // to translate
    author: 'Зохиогч', // to translate
    completed: 'Дуусгасан', // to translate
    match: 'Зам таарч байна', // to translate
    preview_mazeTitle: 'Гарчиг: ', // to translate
    other: 'Бусад', // to translate
    total: 'НИЙТ', // to translate
    report_courses: 'КУРСҮҮД', // to translate
    report_events: 'ЭВЕНТҮҮД', // to translate
    report_maze: 'МЭЙЗ', // to translate
    report_personalize_learning: 'СУРГАЛТЫГ ӨӨРТӨӨ ТОХИРУУЛАХ', // to translate
    report_live_assessments: 'ШУУД ҮНЭЛГЭЭНҮҮД', // to translate
    report_skill_journey: 'УР ЧАДВАРЫН АЯЛАЛ', // to translate
    skill_journey: 'Ур чадварын аялал', // to translate
    skill_journeys: 'Ур чадварын аяллууд', // to translate
    date: 'ОГНОО: ', // to translate
    search_people: 'Хүмүүс хайх', // to translate
    passed: 'ДАВСАН', // to translate
    failed: 'УНАСАН', // to translate
    item: 'ЗҮЙЛ', // to translate
    items: 'ЗҮЙЛС', //to translate
    type: 'ТӨРӨЛ', // to translate
    minimum_pass_score: 'БОСГО ОНОО', // to translate
    resources_count: 'ЭХ СУРВАЛЖИЙН ТОО', // to translate
    back: 'БУЦАХ', // to translate
    resources: 'ЭХ СУРВАЛЖУУД', // to translate
    time_spent: 'ЗАРЦУУЛСАН ХУГАЦАА (МИН)', // to translate
    detail: 'ДЕТАЛЬ', // to translate
    watched_time_mins: 'ҮЗСЭН ХУГАЦАА (МИН)', // to translate
    personalize_learning: 'сургалтыг өөртөө тохируулах', // to translate
    result: 'үр дүн', // to translate
    assessment_title: 'Гарчиг' // to translate
  },

  signup: {
    success_step1:
      ' Таны өгсөн хаяг руу баталгаажуулах код имэйлээр илгээсэн. Доорх хэсэгт тухайн кодыг хуулаад шинэ нууц үг үүсгэнэ үү.',
    success_step2: 'Баярлалаа. Таны бүртгэл амжилттай.',
    privacy: `Би Sharelook-ын <1> үйлчилгээний нөхцөл</1> болон <3> нууцлалын бодлогыг</3> хүлээн зөвшөөрч байна,`
  },

  stream: {
    emotion_impressive: 'Сэтгэл хөдөлгөм',
    emotion_unimpressive: 'Сэтгэл үл хөдөлгөм',
    message_not_started: 'Тун удахгүй',
    message_running: 'Шууд',
    message_processing:
      'Бид шууд бичлэгийн дахин тоглуулахаар боловсруулж байна. Дараа эргэн ирж видеог үзэж, үнэлгээ, санал зөвлөмжөө нэмээрэй.'
  },

  tabs: {
    audience: 'Үзэгчид',
    course: 'Курсийн тойм',
    details: 'Шууд эвентийн деталь',
    description: 'Тайлбар',
    host: 'Зохион байгуулагч',
    lesson: 'Хичээлийн тойм',
    lessons: 'Хичээлүүд',
    overview: 'Тойм',
    page: 'Хуудас үүсгэгч',
    publish: 'Нийтлэх',
    settings: 'Нийтлэх тохиргоо',
    total_views: 'Нийт үзсэн тоо',
    live_participates: 'Шууд дамжуулалтад оролцогчид',
    live_chats: 'Шууд чатууд',
    live_quiz: 'Шууд санал хураалтууд',
    trainer_rating: 'Багшийн үнэлгээ',
    trainer_times: 'Багшийн хугацаа',
    courses_quizzes: 'Курсийн таавар',
    user_list: 'Хэрэглэгчийн жагсаалт',
    discussion: 'Хэлэлцүүлэг',
    notes: 'Миний тэмдэглэлүүд',
    attachments: 'Нэмэлт хавсралт' // to translate
  },

  topics: {
    SALES_TRAINING: 'Борлуулалтын сургалт',
    NEGOTIATION_TRAINING: 'Хэлэлцээрийн сургалт ',
    CROSS_CULTURAL_AWARENESS: 'Соёлын хоорондын ялгаатай ойлголтыг таниулах',
    NETWORKING_SKILLS: 'Нэтворкинг ур чадвар',
    SOFTWARE_ARCHITECTURE: 'Программ хангамжийн архитектур',
    PROJECT_MANAGEMENT: 'Төслийн менежмент',
    DIGITAL_TRANSFORMATION: 'Цахим хувьсал',
    IT_CONSULTING: 'IT Зөвлөгөө',
    MANAGEMENT_CONSULTING: 'Менежмент зөвлөгөө',
    HR_CONSULTING: 'Хүний нөөцийн зөвлөгөө',
    INTERNET_OF_THINGS: 'Интернэтийн зүйлс (IoT)',
    CYBERSECURITY: 'Цахим аюулгүй байдал',
    PRIVACY_AND_GDRP: 'Хувийн болон Ерөнхий Дата Хамгаалах Тогтоомж'
  },

  training: {
    title: 'Сургалт',
    title_assessment: 'Үнэлгээнүүд',
    subtitle: 'Курсүүд болон шууд эвентүүд',
    enrolled_title: 'Элссэн курсүүд болон шууд эвентүүд',
    enrolled_subtitle: 'Таны элссэн курсүүд болон шууд эвентүүд',
    enrolled_message: 'Танд элссэн курс, эвент байхгүй байна.',
    maze_channel: 'Миний мэйз суваг', // to translate
    past_live_assessment: 'Өмнөх шууд үнэлгээнүүд', // to translate
    no_live_assessment: 'Шууд үнэлгээ одоогоор байхгүй байна', // to translate
    past_live_event_title: 'Өмнөх шууд эвентүүд',
    past_live_event_subTitle: 'Дууссан шууд эвентүүд',
    past_live_event: 'Өмнөх шууд эвент байхгүй байна.',
    recomended_title: 'Санал болгох курс, шууд эвентүүд',
    now_live_event_title: 'Одоо шууд дамжуулж байна',
    now_live_event_subTitle:
      'Шууд дамжуулж буй эсвэл удахгүй шууд дамжуулах эвентүүд',
    now_live_event: 'Шууд эвент одоогоор байхгүй байна.',
    no_maze: 'Мэйз байхгүй байна.', // to translate
    webinar_event_title: 'Вебинарын суваг',
    webinar_event_subTitle: 'Дууссан вебинарууд',
    webinar_event: 'Вебинар одоогоор байхгүй байна.',
    p2p_event_title: 'Дасгалжуулалтын уулзалтууд',
    p2p_event_subTitle: 'Дууссан дасгалжуулалтын уулзалтууд',
    p2p_event: 'Дасгалжуулалтын уулзалт одоогоор байхгүй байна.',
    // new translate
    conference_event_title: 'Хурлын эвентүүд', // to translate
    conference_event_subTitle: 'Дууссан хурлын эвентүүд', // to translate
    conference_event: 'Хурлын эвент одоогоор байхгүй байна.', // to translate
    skill_journey: 'Ур чадварын аялал', // to translate
    no_skill: 'Ур чадварын аялал одоогоор байхгүй байна', // to translate

    now_live_assessment_title: 'Одоо шууд дамжуулж байна',
    now_live_assessment_subTitle:
      'Шууд дамжуулж буй эсвэл удахгүй шууд дамжуулах үнэлгээнүүд',
    now_live_assessment_message: 'Шууд үнэлгээ одоогоор байхгүй байна',

    upcoming_assessment_title: 'Удахгүй болох шууд үнэлгээнүүд',
    upcoming_assessment_subtitle: 'Удахгүй болох шууд үнэлгээнүүд',
    upcoming_assessment_message: 'Шууд үнэлгээ одоогоор байхгүй байна.',

    past_live_assessment_title: 'Өмнөх шууд үнэлгээнүүд',
    past_live_assessment_subTitle: 'Дууссан шууд үнэлгээнүүд',
    past_live_assessment_message: 'Өмнөх шууд үнэлгээ байхгүй байна.',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'Таны <0><0/></0> дээр тулгуурлан курс, шууд эвентүүдийг санал болгож байна',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'Сургалт хайх',
    search_assessment: 'Үнэлгээ хайх',
    recomended_message: 'Санал болгох курс, эвент одоогоор байхгүй.',
    search_user: 'Компанийн нэрээр хайх' // to translate
  },

  warnings: {
    delete: 'Та итгэлтэй байна уу??'
  },

  workshop: {
    title: 'Миний дасгал ажил',
    subtitle: 'Өөрийн курс үүсгэх эсвэл шууд эвент зохион байгуулах',
    new_course: 'Шинэ курс үүсгэх',
    new_scorm_course: 'Шинэ CКОРМ курс байршуулах', // to translate
    upload_scorm_course: 'CКОРМ курс байршуулах', // to translate
    new_event: 'Шинэ шууд эвент үүсгэх',
    new_maze: 'Шинэ мэйз үүсгэх', // to translate
    new_skill_journey: 'Ур чадварын аялал үүсгэх', // to translate
    new_assessment: 'Шинээр шууд үнэлгээ үүсгэх',
    courses_title: 'Үүсгэсэн курсүүд & Шууд эвентүүд',
    courses_subtitle:
      'Үүсгэсэн курс, шууд эвентийн төлөвлөгөөгөө засах & нийтлэх',
    tags_course: 'Курс',
    tags_scorm: 'СКОРМ', // to translate
    tags_live: 'Шууд эвент',
    tags_assessment: 'Шууд үнэлгээ',
    tags_skillJourney: 'Ур чадварын аялал' // to translate
  },

  help_center: {
    sidebar: {
      title: 'Бид танд яаж туслах вэ?',
      back_to: 'Талбар'
    },
    menu: {
      help_center: 'Тусламжийн төв',
      whats_new: 'Шинэ юу байна',
      feedback: 'Санал зөвлөмж',
      feedback_title: 'Sharelook-т санал зөвлөмж илгээх',
      terms_and_conditions: 'Үйлчилгээний нөхцөл',
      privacy_policy: 'Нууцлалын бодлого',
      contact_us: 'Бидэнтэй холбоо барих'
    },
    get_started: {
      title: 'Sharelook-ыг ашиглаж эхлэх',
      new_title: 'Хэрэглэгчийн гарын авлага', // to translate
      description: {
        main:
          'БИД ХЯЛБАР АШИГЛАХ БОЛОМЖТОЙ ХИЧЭЭЛ БЭЛТГЭГЧИД ШУУД ВИДЕО ДАМЖУУЛАЛТЫГ ХОЛБОСОН',
        tagline:
          'ShareLook-ын патенттай шууд дамжуулах системийн тусламжтай та сургалтыг автоматжуулж, олныг хамруулж, мэдлэг түгээх явцыг улам боловсронгуй болгож болно.'
      }
    },
    whats_new: {
      title: 'Sharelook-ыг ашиглаж эхлэх',
      description: {
        main:
          'Түүх өгүүлэх замаар аливааг сурах нь цаг хэмнэхээс гадна хямд төсөр гэдгийг та мэдсэн үү? Та ShareLook-ын курс үүсгэх функц болон бусад үйлчилгээг ашиглаарай. "ХЭРХЭН гэдгийг биднээс асуу.',
        tagline: ''
      }
    },
    create_workshop: 'Дасгал ажил хэрхэн үүсгэх вэ',
    create_course: 'Курс хэрхэн үүсгэх вэ',
    create_user: 'Хэрэглэгч хэрхэн үүсгэх вэ',
    create_group: 'Групп хэрхэн үүсгэх вэ',
    create_webinar: 'Вебинар хэрхэн үүсгэх вэ',
    create_live_event: 'Шууд эвент хэрхэн үүсгэх вэ',
    create_live_assessment: 'Шууд үнэлгээ хэрхэн үүсгэх вэ',
    create_live_on_mobile: 'Гар утас дээр хэрхэн шууд дамжуулах вэ',
    personalize_profile: 'Профайлаа өөрийн болгож засах',
    manage_group: 'Групп удирдах',
    report: 'Тайлан',
    add_annotations: 'Тайлбар/Үсэрч гарч ирдэг хуудас хэрхэн хийх вэ',
    add_audio: 'Хэрхэн аудио нэмэх вэ',
    add_header_and_footer: 'Толгой & хөл хэрхэн нэмэх вэ',
    add_image: 'Зураг хэрхэн нэмэх вэ',
    add_quiz_content: 'Таавар контент хэрхэн нэмэх вэ',
    add_text_content: 'Текст контент хэрхэн нэмэх вэ',
    add_user: 'Хэрэглэгч хэрхэн нэмэх вэ',
    add_video: 'Видео хэрхэн нэмэх вэ',
    clone_course: 'Курсийг хэрхэн клон хийх вэ',
    find_live_broadcast: 'Шууд өргөн нэвтрүүлгийг хэрхэн олох вэ',
    transcribe_and_translate_live_broadcast:
      'Шууд өргөн нэвтрүүлгийг орчуулах/хөрвүүлэх', // to translate
    transcribe_and_translate_your_live_broadcast:
      'Шууд өргөн нэвтрүүлгийг хэрхэн хөрвүүлж, орчуулах вэ', // to translate
    contact_us: {
      title: 'Бидэнтэй холбоо барих',
      subject_placeholder: 'Гарчиг оруулна уу*',
      content_placeholder: 'Мессежээ оруулна*',
      subject_required: '*Гарчиг оруулах шаардлагатай',
      content_required: '*Мессеж оруулах шаардлагатай',
      submit: 'Илгээх',
      cancel: 'Цуцлах',
      sent: 'Илгээсэн'
    },
    feedback: {
      title: 'Sharelook-т санал зөвлөмж илгээх',
      attach_title: 'Файл хавсаргах',
      choose: 'Файл сонгох',
      detail: 'Тусламжийн багт файлыг хуваалцана',
      content_placeholder: ' Мессеж оруулна уу*',
      content_required: '*Мессеж оруулах шаардлагатай',
      submit: 'Илгээх',
      cancel: 'Цуцлах',
      sent: 'Илгээсэн'
    }
  },
  discussion: {
    join_discussion: 'Хэлэлцүүлэгт нэгдэх'
  },
  notes: {
    title: 'Миний тэмдэглэлүүд',
    add_note: 'Шинэ тэмдэглэл нэмэх'
  },
  // added_third
  groups: {
    search_group: 'Байгууллагын группийг хайх' // to translate
  },
  /* Information object is to be translated */
  v4: {
    title: 'Та өнөөдөр юу хийхийг хүсэж байна вэ?', // to translate
    build_course: 'Курсээ бий болгох', // to translate
    live_broadcast: 'Шууд өргөн нэвтрүүлэг', // to translate
    invite_users: 'Байгууллагадаа хэрэглэгчид урих', // to translate
    build_voice_over: 'Дуу оруулалтаа үүсгэх', // to translate
    view_reports: 'Тайлан харах', // to translate
    upload_media: 'Медиа эсхүл ажлаа байршуулах болон хуваалцах', // to translate
    main_menu: 'Үндсэн цэс', // to translate
    get_started: 'ЭХЛЭХ' // to translate
  }
  /* To Translate  */
}
